define(["esri/geometry/SpatialReference","esri/tasks/GeometryService","esri/tasks/support/ProjectParameters","esri/geometry/Point","esri/geometry/support/webMercatorUtils","esri/request","esri/views/MapView","esri/layers/TileLayer","esri/Map","esri/config","esri/core/Collection","esri/layers/GraphicsLayer","esri/layers/MapImageLayer","esri/symbols/SimpleMarkerSymbol","esri/PopupTemplate","esri/Graphic","esri/symbols/PictureMarkerSymbol","esri/tasks/RouteTask","esri/tasks/support/RouteParameters","esri/tasks/support/FeatureSet","esri/symbols/SimpleLineSymbol","esri/Color","esri/tasks/PrintTask","esri/tasks/support/PrintTemplate","esri/tasks/support/PrintParameters","dojo/request/xhr"], function(__WEBPACK_EXTERNAL_MODULE_78__, __WEBPACK_EXTERNAL_MODULE_80__, __WEBPACK_EXTERNAL_MODULE_81__, __WEBPACK_EXTERNAL_MODULE_82__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_84__, __WEBPACK_EXTERNAL_MODULE_119__, __WEBPACK_EXTERNAL_MODULE_121__, __WEBPACK_EXTERNAL_MODULE_122__, __WEBPACK_EXTERNAL_MODULE_123__, __WEBPACK_EXTERNAL_MODULE_124__, __WEBPACK_EXTERNAL_MODULE_125__, __WEBPACK_EXTERNAL_MODULE_126__, __WEBPACK_EXTERNAL_MODULE_128__, __WEBPACK_EXTERNAL_MODULE_129__, __WEBPACK_EXTERNAL_MODULE_130__, __WEBPACK_EXTERNAL_MODULE_131__, __WEBPACK_EXTERNAL_MODULE_132__, __WEBPACK_EXTERNAL_MODULE_133__, __WEBPACK_EXTERNAL_MODULE_134__, __WEBPACK_EXTERNAL_MODULE_135__, __WEBPACK_EXTERNAL_MODULE_136__, __WEBPACK_EXTERNAL_MODULE_137__, __WEBPACK_EXTERNAL_MODULE_138__, __WEBPACK_EXTERNAL_MODULE_139__, __WEBPACK_EXTERNAL_MODULE_150__) { return webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(24), __webpack_require__(4), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, platform_browser_dynamic_1, app_module_1, core_1, config_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import {HTTP_PROVIDERS, JSONP_PROVIDERS } from '@angular/http';
	    // import {TRANSLATE_PROVIDERS, TranslateService, TranslatePipe, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';
	    // import { AppComponent } from './app.component';
	    /**This portion below only works when working with Webpack. For SystemJS, comment the following lines**/
	    // import 'material-design-lite/dist/material.min.css';
	    // import 'mdl-selectfield/dist/mdl-selectfield.min.css';
	    // import '../css/styles.css';
	    // if (process.env.ENV === 'production') {
	    core_1.enableProdMode();
	    // }
	    // This is to use dojo/request/xhr from ArcGIS JS API library (theoretically compatible with all browsers)
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(150)], __WEBPACK_AMD_DEFINE_RESULT__ = function (xhr) {
	        xhr("data/settings.json", {
	            handleAs: "json"
	        }).then(function (data) {
	            // Do something with the handled data
	            config_1.Config.config = data;
	            platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);
	        }, function (err) {
	            // Handle the error condition
	            console.log(err);
	        }, function (evt) {
	            // Handle a progress event from the request if the
	            // browser supports XHR2
	        });
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	// bootstrap(AppComponent, [HTTP_PROVIDERS, JSONP_PROVIDERS, TRANSLATE_PROVIDERS]).catch(err => console.error(err)); 


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(22), __webpack_require__(27), __webpack_require__(27), __webpack_require__(26), __webpack_require__(25), __webpack_require__(57), __webpack_require__(74), __webpack_require__(142), __webpack_require__(146), __webpack_require__(148)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, platform_browser_1, http_1, http_2, ng2_translate_1, app_component_1, shared_module_1, voterinformation_module_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var AppModule = /** @class */ (function () {
	        function AppModule() {
	        }
	        AppModule = __decorate([
	            core_1.NgModule({
	                declarations: [
	                    app_component_1.AppComponent
	                ],
	                imports: [
	                    platform_browser_1.BrowserModule,
	                    http_1.HttpModule,
	                    http_2.JsonpModule,
	                    ng2_translate_1.TranslateModule.forRoot(),
	                    voterinformation_module_1.VoterInformationModule,
	                    shared_module_1.SharedModule.forRoot()
	                ],
	                providers: [],
	                bootstrap: [app_component_1.AppComponent]
	            })
	        ], AppModule);
	        return AppModule;
	    }());
	    exports.AppModule = AppModule;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(26), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, ng2_translate_1, Events_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var AppComponent = /** @class */ (function () {
	        //Note:  need to inject the TranslateService here in order to set the language of the trnaslator
	        function AppComponent(_eventsService, el, translate) {
	            this._eventsService = _eventsService;
	            this.translate = translate;
	            this.isVoterSearch = false;
	            this.logoPath = "./images/Political_Icon1_100x100.png";
	            this.userLang = 'en';
	            this.checkVal = false;
	            this.modalDialogShow = false;
	            this.modalDialogText = "";
	            this.element = el;
	        }
	        AppComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            componentHandler.upgradeAllRegistered();
	            // hide the drawer toggle button
	            this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
	            this.drawerToggle["style"].display = "none";
	            //toggle the drawer panel
	            this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
	            !this.drawer.classList.contains('is-visible') ? this.drawer.classList.toggle('is-visible') : console.log("This is the initial load");
	            this.drawer.setAttribute("aria-hidden", "false");
	            this.tabBar = document.getElementsByClassName('mdl-layout__tab-bar')[0];
	            this.tabBar ? this.tabBar.setAttribute("aria-hidden", "true") : null;
	            //enable this to change the default drawer toggle icon 
	            // this.changeIcon()
	            //handle the active tab event
	            this._eventsService.activeTab$.subscribe(function (tabview) {
	                // this.tabBar.scrollLeft = 20;
	                var tabpanels = document.querySelectorAll('.mdl-layout__tab-panel');
	                var tabs = document.querySelectorAll('.mdl-layout__tab');
	                var view = tabview;
	                var leftPos;
	                for (var _i = 0, tabpanels_1 = tabpanels; _i < tabpanels_1.length; _i++) {
	                    var tabpanel = tabpanels_1[_i];
	                    tabpanel.classList.contains('is-active') ? tabpanel.classList.remove('is-active') : null;
	                    tabpanel.id === tabview ? tabpanel.classList.add('is-active') : null;
	                }
	                for (var _a = 0, tabs_1 = tabs; _a < tabs_1.length; _a++) {
	                    var tab = tabs_1[_a];
	                    tab.classList.contains('is-active') ? tab.classList.remove('is-active') : null;
	                    // tab.hash === "#" + tabview ? tab.classList.add('is-active') : null;
	                    //set the active tab and get the offset position
	                    if (tab.hash === "#" + tabview) {
	                        tab.classList.add('is-active');
	                        leftPos = tab["offsetLeft"] - 60;
	                    }
	                }
	                //scroll the tab bar to the  position of the selected tab 
	                _this.tabBar.scrollLeft = leftPos;
	                var menuItems = document.querySelectorAll('.mdl-menu__item');
	                for (var _b = 0, menuItems_1 = menuItems; _b < menuItems_1.length; _b++) {
	                    var menuItem = menuItems_1[_b];
	                    menuItem.classList.contains('selectedMenuItem') ? menuItem.classList.remove('selectedMenuItem') : null;
	                    if (menuItem.getAttribute("value") === tabview) {
	                        menuItem.classList.add('selectedMenuItem');
	                    }
	                }
	            });
	            //handle search event
	            this._eventsService.searchInvoked$.subscribe(function (search) {
	                _this.isVoterSearch = true;
	                // // show the drawer toggle button
	                // this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
	                // this.drawerToggle["style"].display = "block";
	                //toggle the drawer panel
	                _this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
	                _this.drawer.classList.contains('is-visible') ? _this.drawer.classList.toggle('is-visible') : console.log("This is the initial load");
	                // this.drawer.setAttribute("aria-hidden", "false");
	                //toggle the obfuscation panel
	                _this.obfuscator = document.getElementsByClassName('mdl-layout__obfuscator')[0];
	                _this.obfuscator.classList.contains('is-visible') ? _this.obfuscator.classList.toggle('is-visible') : console.log("This is the initial load");
	                _this.tabBar ? _this.tabBar.setAttribute("aria-hidden", "false") : null;
	                //activate the tab right chevron button for mobile devices
	                if (window.innerWidth <= 800 && window.innerHeight <= 1024) {
	                    var tabRightChevron = document.getElementsByClassName('mdl-layout__tab-bar-right-button')[0];
	                    !tabRightChevron.classList.contains('is-active') ? tabRightChevron.classList.add('is-active') : null;
	                    // tabRightChevron.textContent = "more";
	                }
	                console.log("Received location search event!");
	            });
	            // this.userLang = navigator.language.split('-')[0]; // use navigator lang if available
	            this.userLang = /(es|en)/gi.test(this.userLang) ? this.userLang : 'en';
	            // this language will be used as a fallback when a translation isn't found in the current language
	            this.translate.setDefaultLang('en');
	            // the lang to use, if the lang isn't available, it will use the current loader to get them
	            this.translate.use(this.userLang);
	            this._eventsService.languageChanged$.subscribe(function (language) {
	                componentHandler.upgradeAllRegistered();
	                _this.userLang = language;
	                _this.translate.use(_this.userLang);
	            });
	        };
	        //chnage the icon from the default hamburger menu icon
	        //   changeIcon() {
	        //         var _db = document.querySelector('.mdl-layout__drawer-button i');
	        //         if (_db) {
	        //             _db.textContent = 'home';
	        //         }
	        //         if(!_db) {
	        //             setTimeout(function() {
	        //                 this.changeIcon();
	        //             }, 50);
	        //         }
	        //     }
	        AppComponent.prototype.onLangToggle = function (value) {
	            //notify of langauge chnage for help documentation
	            this.checkVal = value;
	            //toggle from english to spanish
	            this.checkVal ? this._eventsService.updateLanguage('es') : this._eventsService.updateLanguage('en');
	        };
	        AppComponent.prototype.onGeolocationError = function (errorString) {
	            this.modalDialogShow = true;
	            this.modalDialogText = errorString;
	        };
	        AppComponent.prototype.showDrawer = function () {
	            // show the drawer toggle button
	            //this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
	            //this.drawerToggle["style"].display = "block";
	            //toggle the drawer panel
	            var drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
	            !drawer.classList.contains('is-visible') ? drawer.classList.toggle('is-visible') : console.log("This is the initial load");
	            //toggle the obfuscation panel
	            var obfuscator = document.getElementsByClassName('mdl-layout__obfuscator')[0];
	            !obfuscator.classList.contains('is-visible') ? obfuscator.classList.toggle('is-visible') : console.log("This is the initial load");
	        };
	        AppComponent.prototype.showPanel = function (tabName) {
	            //set the active tab
	            this._eventsService.setActiveTab(tabName);
	        };
	        AppComponent.prototype.showFAQ = function (tabName) {
	            //set the active tab
	            this._eventsService.setActiveTab("tabFAQ");
	        };
	        AppComponent = __decorate([
	            core_1.Component({
	                selector: 'main-app',
	                template: __webpack_require__(56)
	            }),
	            __metadata("design:paramtypes", [Events_service_1.EventsService, core_1.ElementRef, ng2_translate_1.TranslateService])
	        ], AppComponent);
	        return AppComponent;
	    }());
	    exports.AppComponent = AppComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(5), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Subject_1, BehaviorSubject_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var EventsService = /** @class */ (function () {
	        function EventsService() {
	            // Observable  sources
	            this.isSearchInvokedSource = new Subject_1.Subject();
	            this.isAddressValidSource = new Subject_1.Subject();
	            this.validatedBirthdateSource = new Subject_1.Subject();
	            this.selectedAddressSource = new BehaviorSubject_1.BehaviorSubject(0);
	            this.activeTabSource = new Subject_1.Subject();
	            this.pollingPlaceSource = new BehaviorSubject_1.BehaviorSubject(0);
	            this.satellitesSource = new BehaviorSubject_1.BehaviorSubject(0);
	            this.mapLocationSource = new BehaviorSubject_1.BehaviorSubject(0);
	            this.updatedLanguageSource = new Subject_1.Subject();
	            this.directionsSource = new Subject_1.Subject();
	            this.addressFromGeolocation = new Subject_1.Subject();
	            this._startAddressFromGeolocation = new Subject_1.Subject();
	            // Observable  streams
	            this.searchInvoked$ = this.isSearchInvokedSource.asObservable();
	            this.birthdate$ = this.validatedBirthdateSource.asObservable();
	            this.addressValid$ = this.isAddressValidSource.asObservable();
	            this.selectedAddressObject$ = this.selectedAddressSource.asObservable();
	            this.activeTab$ = this.activeTabSource.asObservable();
	            this.pollingPlace$ = this.pollingPlaceSource.asObservable();
	            this.satellites$ = this.satellitesSource.asObservable();
	            this.mapZoom$ = this.mapLocationSource.asObservable();
	            this.languageChanged$ = this.updatedLanguageSource.asObservable();
	            this.directionsInvoked$ = this.directionsSource.asObservable();
	            this.addressFromGeolocation$ = this.addressFromGeolocation.asObservable();
	            this.startAddressFromGeolocation$ = this._startAddressFromGeolocation.asObservable();
	        }
	        //=============service commands to update observable streams======================
	        //updated selected address object
	        EventsService.prototype.setSelectedAddress = function (Object) {
	            this.selectedAddressSource.next(Object);
	            this.isAddressValidSource.next(true);
	        };
	        // update search status
	        EventsService.prototype.voterSearchInvoked = function (Object) {
	            // console.log("location search event sent!")
	            this.isSearchInvokedSource.next(Object);
	            // console.log("Location status is: " + locationStatus)
	        };
	        //set address validation status
	        EventsService.prototype.voterAddressValid = function (addressStatus) {
	            // console.log("location search event sent!")
	            this.isAddressValidSource.next(addressStatus);
	            // console.log("Location status is: " + locationStatus)
	        };
	        //set entered birthdate status
	        EventsService.prototype.voterBirthdate = function (birthdateStatus) {
	            this.validatedBirthdateSource.next(birthdateStatus);
	        };
	        //updated selected address object
	        EventsService.prototype.setActiveTab = function (tab) {
	            this.activeTabSource.next(tab);
	            // this.isAddressValidSource.next(true);
	        };
	        EventsService.prototype.setPollingPlace = function (polling) {
	            this.pollingPlaceSource.next(polling);
	        };
	        EventsService.prototype.setSatellites = function (satellitePolling) {
	            this.satellitesSource.next(satellitePolling);
	        };
	        EventsService.prototype.zoomToLocation = function (location) {
	            this.mapLocationSource.next(location);
	        };
	        EventsService.prototype.updateLanguage = function (language) {
	            this.updatedLanguageSource.next(language);
	        };
	        EventsService.prototype.getDirections = function (destination) {
	            this.directionsSource.next(destination);
	        };
	        EventsService.prototype.startAddressFromGeolocation = function () {
	            this._startAddressFromGeolocation.next();
	        };
	        EventsService.prototype.setAddressFromGeolocation = function (addressLocation) {
	            this.addressFromGeolocation.next(addressLocation);
	        };
	        EventsService = __decorate([
	            core_1.Injectable()
	        ], EventsService);
	        return EventsService;
	    }());
	    exports.EventsService = EventsService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"mdl-layout mdl-js-layout\r\n            mdl-layout--fixed-header\">\r\n    <header class=\"mdl-layout__header appHeaderClass\" role=\"banner\" aria-label=\"home\" >\r\n\r\n        <div class=\"mdl-layout__header-row paddingHeaderClass\">\r\n\r\n            <button id=\"menu-speed\" class=\"mdl-button mdl-js-button mdl-button--icon\" [style.visibility]=\"isVoterSearch == true ? 'visible' : 'hidden'\">\r\n                <i class=\"material-icons\">menu</i>\r\n            </button>\r\n            <ul class=\"mdl-menu mdl-js-menu menuSpeedClass\" for=\"menu-speed\" style=\"overflow: auto;\">\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabEarlyVoting')\" value=\"tabEarlyVoting\"><span class=\"menu-list-item-content\">{{'earlyVotingTabTitle' | translate:{value: earlyVotingTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabPollingPlace')\" value=\"tabPollingPlace\"><span class=\"menu-list-item-content\">{{'pplTabTitle' | translate:{value: pplTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabRegistration')\" value=\"tabRegistration\"><span class=\"menu-list-item-content\">{{'registrationTabTitle' | translate:{value: registrationTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabDistricts')\" value=\"tabDistricts\"><span class=\"menu-list-item-content\">{{'districtsTabTitle' | translate:{value: districtsTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabOfficials')\" value=\"tabOfficials\"><span class=\"menu-list-item-content\">{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabCandidates')\" value=\"tabCandidates\"><span class=\"menu-list-item-content\">{{'candidatesTabTitle' | translate:{value: candidatesTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabBallots')\" value=\"tabBallots\"><span class=\"menu-list-item-content\">{{'ballotsTabTitle' | translate:{value: ballotsTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabMap')\" value=\"tabMap\"><span class=\"menu-list-item-content\">{{'mapTabTitle' | translate:{value: mapTabTitle} }}</span></li>\r\n                <li class=\"mdl-menu__item\" (click)=\"showPanel('tabFAQ')\" value=\"tabFAQ\"><span class=\"menu-list-item-content\">{{'faqTabTitle' | translate:{value: faqTabTitle} }}</span></li>\r\n            </ul>\r\n\r\n            <img class=\"vip-logo\" alt=\"Voter Information Portal Logo\" src=\"{{logoPath}}\">\r\n\r\n            <!-- Title -->\r\n            <span class=\"mdl-layout-title\" id=\"main-title\">{{'websiteTitle' | translate:{value: websiteTitle} }}</span>\r\n            <!--<span class=\"mdl-layout-title mdl-layout--large-screen-only\">indy-viewer-template</span>-->\r\n\r\n            <!-- Add spacer, to align navigation to the right -->\r\n            <div class=\"mdl-layout-spacer\"></div>\r\n            <span id=\"sub-title\">{{'siteSubtitle' | translate:{value: siteSubtitle} }}</span>\r\n\r\n            <button class=\"mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab\" style=\"color:white; background: none;\" [style.visibility]=\"isVoterSearch == true ? 'visible' : 'hidden'\" (click)=\"showDrawer()\">\r\n                <i class=\"material-icons\">search</i>\r\n            </button>\r\n            <button class=\"mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab\" style=\"color:white; background: none;\" [style.visibility]=\"isVoterSearch == true ? 'visible' : 'hidden'\" (click)=\"showFAQ()\">\r\n                <i class=\"material-icons\">help_outline</i>\r\n            </button>\r\n        </div>\r\n        <div class=\"mdl-layout__tab-bar mdl-js-ripple-effect\">\r\n            <a href=\"#tabPollingPlace\" class=\"mdl-layout__tab is-active\"  >{{'pplTabTitle' | translate:{value: pplTabTitle} }}</a>\r\n            <a href=\"#tabEarlyVoting\" class=\"mdl-layout__tab is-active\"  >{{'earlyVotingTabTitle' | translate:{value: earlyVotingTabTitle} }}</a>\r\n            <a href=\"#tabRegistration\" class=\"mdl-layout__tab\" >{{'registrationTabTitle' | translate:{value: registrationTabTitle} }}</a>\r\n            <a href=\"#tabDistricts\" class=\"mdl-layout__tab\" >{{'districtsTabTitle' | translate:{value: districtsTabTitle} }}</a>\r\n            <a href=\"#tabOfficials\" class=\"mdl-layout__tab\" >{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</a>\r\n            <a href=\"#tabCandidates\" class=\"mdl-layout__tab\" >{{'candidatesTabTitle' | translate:{value: candidatesTabTitle} }}</a>\r\n            <a href=\"#tabBallots\" class=\"mdl-layout__tab\" >{{'ballotsTabTitle' | translate:{value: ballotsTabTitle} }}</a>\r\n            <a href=\"#tabMap\" class=\"mdl-layout__tab\" >{{'mapTabTitle' | translate:{value: mapTabTitle} }}</a>\r\n            <a href=\"#tabFAQ\" class=\"mdl-layout__tab faqTab\" >{{'faqTabTitle' | translate:{value: faqTabTitle} }}   </a>\r\n            <a href=\"#tabtemp\" class=\"mdl-layout__tab\"></a>\r\n        </div>\r\n        \r\n             <!--<button id=\"menu-speed\" class=\"mdl-button mdl-js-button mdl-button--icon\">\r\n            <i class=\"material-icons\">more_vert</i>\r\n        </button>\r\n        <ul class=\"mdl-menu mdl-js-menu\" for=\"menu-speed\">\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabPollingPlace\">{{'pplTabTitle' | translate:{value: pplTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item \"><a href=\"#tabRegistration\">{{'registrationTabTitle' | translate:{value: registrationTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabDistricts\" class=\"mdl-layout__tab\" >{{'districtsTabTitle' | translate:{value: districtsTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabOfficials\" class=\"mdl-layout__tab\" >{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabCandidates\" class=\"mdl-layout__tab\" >{{'candidatesTabTitle' | translate:{value: candidatesTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabBallots\" class=\"mdl-layout__tab\" >{{'ballotsTabTitle' | translate:{value: ballotsTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"><a href=\"#tabMap\" class=\"mdl-layout__tab\" >{{'mapTabTitle' | translate:{value: mapTabTitle} }}</a></li>\r\n            <li class=\"mdl-menu__item\"> <a href=\"#tabFAQ\" class=\"mdl-layout__tab faqTab\" >{{'faqTabTitle' | translate:{value: faqTabTitle} }}   </a></li>\r\n        </ul>-->\r\n    </header>\r\n\r\n    <!--slide-out drawer-->\r\n    <div class=\"mdl-layout__drawer\" [ngClass]=\"{locationvalidated: isVoterSearch, disabled: isDisabled}\" aria-hidden=\"false\">\r\n\r\n        <!-- <ul>\r\n            <li class=\"mdl-list__item\">{{'pplTabTitle' | translate:{value: pplTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'registrationTabTitle' | translate:{value: registrationTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'districtsTabTitle' | translate:{value: districtsTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'candidatesTabTitle' | translate:{value: candidatesTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'ballotsTabTitle' | translate:{value: ballotsTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'mapTabTitle' | translate:{value: mapTabTitle} }}</li>\r\n            <li class=\"mdl-list__item\">{{'faqTabTitle' | translate:{value: faqTabTitle} }}</li>\r\n        </ul> -->\r\n\r\n    <!--Custom Voter validation and search panel -->\r\n    <voter-verify (onValidLocation)=\"onValidLocation($event)\" [inputDrawer]=\"isVoterSearch\" (onGeolocationError)=\"onGeolocationError($event)\"></voter-verify>\r\n\r\n    <div class=\"mdl-layout-spacer\"></div>\r\n\r\n    <footer class=\"mdl-mega-footer\" role=\"contentinfo\" aria-label=\"footer\">\r\n\r\n\r\n        <div class=\"mdl-mega-footer__top-section\">\r\n                <label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" for=\"icon-toggle-lang\">\r\n\r\n                    <input type=\"checkbox\" id=\"icon-toggle-lang\" class=\"mdl-icon-toggle__input\" (change)=\"onLangToggle($event.target.checked)\">\r\n                    <i class=\"mdl-icon-toggle__label material-icons blue\">language</i>\r\n                    <span class=\"mdl-icon-toggle__label\" *ngIf=\"!checkVal\">En Español </span>\r\n                    <span class=\"mdl-icon-toggle__label\" *ngIf=\"checkVal\">In English </span>\r\n                </label>\r\n            <!--<a class=\"footer-heading\" href=\"https://my.indy.gov/agency/marion-county-election-board\" alt=\"Election Board Website\" target=\"_blank\">{{'countyElectionBoard' | translate:{value: countyElectionBoard} }}</a><br>-->\r\n            <!--<h1 class=\"mdl-mega-footer__heading\">{{'countyElectionBoard' | translate:{value: countyElectionBoard} }}</h1>-->\r\n<hr >\r\n        </div>\r\n        <div class=\"mdl-mega-footer__middle-section\">\r\n            <a class=\"footer-heading\" href=\"https://my.indy.gov/agency/marion-county-election-board\" alt=\"Election Board Website\" target=\"_blank\">{{'countyElectionBoard' | translate:{value: countyElectionBoard} }}</a><br>\r\n            <div class=\"mdl-grid\">\r\n                <div class=\"mdl-cell mdl-cell--3-col\"></div>\r\n                <div class=\"mdl-cell mdl-cell--3-col footer-supporting-text\">\r\n                    <span>200 E. Washington St., W144</span><br>\r\n                    <span>Indianapolis, IN 46204</span><br></div>\r\n                <div class=\"mdl-cell mdl-cell--3-col footer-supporting-text\">\r\n                    <span>(317) 327-VOTE</span><br>\r\n                    <span>elections@indy.gov</span>\r\n                </div>\r\n                <div class=\"mdl-cell mdl-cell--3-col\"></div>\r\n            </div>\r\n                <!--<div class=\"mdl-mega-footer__left-section\">-->\r\n\r\n        <!--</div>-->\r\n\r\n        <!--<div class=\"mdl-mega-footer__right-section\">-->\r\n\r\n        <!--</div>-->\r\n        </div>\r\n        <!--<hr style=\"margin:0px;\">-->\r\n            <div class=\"mdl-mega-footer__bottom-section\">\r\n                <!--<label class=\"mdl-icon-toggle mdl-js-icon-toggle mdl-js-ripple-effect\" for=\"icon-toggle-lang\">\r\n\r\n                    <input type=\"checkbox\" id=\"icon-toggle-lang\" class=\"mdl-icon-toggle__input\" (change)=\"onLangToggle($event.target.checked)\">\r\n                    <i class=\"mdl-icon-toggle__label material-icons\">language</i>\r\n                    <span class=\"mdl-icon-toggle__label\" *ngIf=\"!checkVal\">En Español </span>\r\n                    <span class=\"mdl-icon-toggle__label\" *ngIf=\"checkVal\">In English </span>\r\n                </label>-->\r\n            </div>\r\n    </footer>\r\n\r\n    </div>\r\n\r\n    <main class=\"mdl-layout__content\" role=\"main\" aria-label=\"page content\" >\r\n        <!--Tab bar for various pieces of information-->\r\n\r\n                <!--Component with polling place information-->\r\n                <polling-place-info></polling-place-info>\r\n                <!--Component with early voting place information-->\r\n                <early-voting-info></early-voting-info>\r\n                <!--Component with voter registration information-->\r\n                <registration-info></registration-info>\r\n                <!--Component with voting district information-->\r\n                <district-info></district-info>\r\n                <!--Component with voting officials information-->\r\n                <officials-info></officials-info>\r\n                <!--Component with candidates information-->\r\n                <candidates-info></candidates-info>\r\n                <!--Component with sample ballot information-->\r\n                <ballots-info></ballots-info>\r\n                <!--Component with mapping information-->\r\n                <map-view></map-view>\r\n                <!--Component with FAQ information-->\r\n                <faq-info></faq-info>\r\n\r\n    </main>\r\n\r\n<!--<div id=\"demo-snackbar-example\" class=\"mdl-js-snackbar mdl-snackbar\" *ngIf=\"error\">\r\n  <div class=\"mdl-snackbar__text\"></div>\r\n  <button class=\"mdl-snackbar__action\" type=\"button\"></button>\r\n</div>-->\r\n\r\n\r\n    <div class=\"modal-dialog\" *ngIf=\"modalDialogShow\" style=\"top:0px; padding-top:200px;\">\r\n    <!--header-->\r\n      <div class=\"demo-card-square mdl-card mdl-shadow--2dp\" style=\"height:auto; position:relative;\">\r\n        <div class=\"mdl-card__title\" style=\"height:auto;\">\r\n            <span>Geolocation error</span>\r\n                    <div class=\"mdl-layout-spacer\"></div>\r\n                      <button class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"modalDialogShow = false\">\r\n                        <i class=\"material-icons\">cancel</i>\r\n                    </button>\r\n        </div>\r\n    <!--from/to email inputs-->\r\n       <div class=\"mdl-card__supporting-text\" >\r\n          {{modalDialogText}}\r\n       </div>\r\n    <!--footer and OK button-->\r\n        <div class=\"mdl-card__actions mdl-card--border\">\r\n            <a (click)=\"modalDialogShow = false\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n                {{'addressInvalidOKButton' | translate:{value: addressInvalidOKButton} }}\r\n              </a>\r\n        </div>\r\n    </div>\r\n    </div>\r\n\r\n</div>\r\n";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(23), __webpack_require__(60), __webpack_require__(26), __webpack_require__(64), __webpack_require__(58), __webpack_require__(70), __webpack_require__(72), __webpack_require__(66), __webpack_require__(54), __webpack_require__(65), __webpack_require__(73)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, common_1, forms_1, ng2_translate_1, email_component_1, expandpanel_component_1, loading_component_1, electionLevels_pipe_1, settings_service_1, Events_service_1, election_service_1, autoNext_directive_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import { HttpModule }     from '@angular/http';
	    // // import { JsonpModule, JSONP_PROVIDERS }     from '@angular/http';
	    // import { JsonpModule }     from '@angular/http';
	    var SharedModule = /** @class */ (function () {
	        function SharedModule() {
	        }
	        SharedModule_1 = SharedModule;
	        SharedModule.forRoot = function () {
	            return {
	                ngModule: SharedModule_1,
	                providers: [Events_service_1.EventsService, settings_service_1.SettingsService, election_service_1.ElectionService]
	            };
	        };
	        SharedModule = SharedModule_1 = __decorate([
	            core_1.NgModule({
	                imports: [common_1.CommonModule, forms_1.FormsModule, forms_1.ReactiveFormsModule, ng2_translate_1.TranslateModule.forRoot()],
	                declarations: [email_component_1.EmailComponent, expandpanel_component_1.ExpandPanelComponent, loading_component_1.LoadingComponent, electionLevels_pipe_1.FederalLevelPipe, electionLevels_pipe_1.StateLevelPipe, electionLevels_pipe_1.LocalLevelPipe, electionLevels_pipe_1.CityLevelPipe, electionLevels_pipe_1.PartyPipe, electionLevels_pipe_1.SpecialElectionPipe, autoNext_directive_1.AutoNextDirective],
	                exports: [common_1.CommonModule, forms_1.FormsModule, ng2_translate_1.TranslateModule, forms_1.ReactiveFormsModule, email_component_1.EmailComponent, expandpanel_component_1.ExpandPanelComponent, loading_component_1.LoadingComponent, electionLevels_pipe_1.FederalLevelPipe, electionLevels_pipe_1.StateLevelPipe, electionLevels_pipe_1.LocalLevelPipe, electionLevels_pipe_1.CityLevelPipe, electionLevels_pipe_1.PartyPipe, electionLevels_pipe_1.SpecialElectionPipe, autoNext_directive_1.AutoNextDirective]
	            })
	        ], SharedModule);
	        return SharedModule;
	        var SharedModule_1;
	    }());
	    exports.SharedModule = SharedModule;
	    var SharedRootModule = /** @class */ (function () {
	        function SharedRootModule() {
	        }
	        SharedRootModule = __decorate([
	            core_1.NgModule({
	                exports: [SharedModule],
	                providers: [Events_service_1.EventsService, settings_service_1.SettingsService, election_service_1.ElectionService]
	            })
	        ], SharedRootModule);
	        return SharedRootModule;
	    }());
	    exports.SharedRootModule = SharedRootModule;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var icon_expand = "keyboard_arrow_down";
	    var icon_collapse = "keyboard_arrow_up";
	    var ExpandPanelComponent = /** @class */ (function () {
	        function ExpandPanelComponent(elRef, _eventsService) {
	            var _this = this;
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this.isExpanded = false;
	            this.arrow_icon = icon_expand;
	            this.panelTitle = "This is my title";
	            this.parent = false;
	            _eventsService.searchInvoked$.subscribe(function (search) {
	                _this.isExpanded = false;
	                _this.arrow_icon = icon_expand;
	            });
	        }
	        ExpandPanelComponent.prototype.ngOnInit = function () {
	        };
	        ExpandPanelComponent.prototype.ngOnDestroy = function () {
	        };
	        //handle the expand/close events
	        ExpandPanelComponent.prototype.expandClick = function () {
	            this.isExpanded ? this.isExpanded = false : this.isExpanded = true;
	            this.isExpanded ? this.arrow_icon = icon_collapse : this.arrow_icon = icon_expand;
	        };
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", Object)
	        ], ExpandPanelComponent.prototype, "panelTitle", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", Boolean)
	        ], ExpandPanelComponent.prototype, "parent", void 0);
	        ExpandPanelComponent = __decorate([
	            core_1.Component({
	                selector: 'expand-panel',
	                template: __webpack_require__(59)
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService])
	        ], ExpandPanelComponent);
	        return ExpandPanelComponent;
	    }());
	    exports.ExpandPanelComponent = ExpandPanelComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = "\r\n<div class=\"content-card-wide mdl-card \">\r\n\r\n      <div class=\"mdl-card__title mdl-button mdl-js-button\" (click)=\"expandClick()\" >\r\n        <h6 class=\"expand-panel-heading\" [ngClass]=\"{titlebold: parent}\">{{ panelTitle }} </h6>\r\n        <div class=\"mdl-layout-spacer\"></div>\r\n        <label class=\"mdl-button mdl-js-button mdl-button--icon\" >\r\n        <i class=\"material-icons\">{{arrow_icon}}</i>\r\n      </label>\r\n\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\" *ngIf=\"isExpanded\">\r\n        <ng-content></ng-content>\r\n\r\n</div>\r\n</div>\r\n ";

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var EmailComponent = /** @class */ (function () {
	        //  inject necessary services
	        function EmailComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.displayStatus = new core_1.EventEmitter();
	            this.isDisplayed = false;
	        }
	        //initialize email objects 
	        EmailComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            //update chnages in the DOM
	            componentHandler.upgradeAllRegistered();
	            //get email inputs
	            var fromInput = document.getElementById('fromemail');
	            var toInput = document.getElementById('toemail');
	            // //if there is an address in local storage
	            this.fromAddress = window.localStorage.getItem("vipFromEmail");
	            this.fromAddress ? toInput.focus() : fromInput.focus();
	            ;
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings;
	            }, function (err) { _this.error = true; });
	            //update chnages in the DOM
	            componentHandler.upgradeAllRegistered();
	            //set necessary styles
	            fromInput ? fromInput.parentElement.classList.add('is-dirty') : console.log("from email input is undefined");
	            fromInput ? fromInput.parentElement.classList.remove('is-invalid') : console.log("from email input is undefined");
	        };
	        // destroy 
	        EmailComponent.prototype.ngOnDestroy = function () {
	        };
	        //emit the event telling the parent component to show the panel
	        EmailComponent.prototype.showPanel = function () {
	            //this.isDisplayed = true;
	            this.displayStatus.emit(true);
	        };
	        //emit the event telling the parent component to hide the panel
	        EmailComponent.prototype.closePanel = function () {
	            this.displayStatus.emit(false);
	        };
	        //trigger the send email
	        EmailComponent.prototype.sendEmail = function () {
	            console.log(this.emailSubject + ": " + this.emailBody);
	            //create the message object to send to the service
	            this.message = JSON.stringify({
	                "toAddress": this.toAddress,
	                "fromAddress": this.fromAddress,
	                "subject": this.emailSubject,
	                "body": this.emailBody
	            });
	            //submit the email to the server and send
	            this._electionService.sharePPViaEmail(this.message);
	            window.localStorage.setItem("vipFromEmail", this.fromAddress);
	            // window.localStorage.setItem("vipToEmail",this.toAddress );
	            //close the dialog
	            this.displayStatus.emit(false);
	        };
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], EmailComponent.prototype, "emailSubject", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], EmailComponent.prototype, "emailBody", void 0);
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], EmailComponent.prototype, "displayStatus", void 0);
	        EmailComponent = __decorate([
	            core_1.Component({
	                selector: 'email-panel',
	                template: __webpack_require__(69)
	                // pipes: [TranslatePipe]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], EmailComponent);
	        return EmailComponent;
	    }());
	    exports.EmailComponent = EmailComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(27), __webpack_require__(66), __webpack_require__(68), __webpack_require__(67), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, http_1, settings_service_1, config_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import {FAQComponent} from '../information/faq/faq.component'
	    /*
	    service module for querying information from the Indy.Elections.Service .Net web service
	    */
	    var ElectionService = /** @class */ (function () {
	        function ElectionService(http, jsonp, _settingsService) {
	            this.http = http;
	            this.jsonp = jsonp;
	            this._settingsService = _settingsService;
	            this.pollingPlaceEndPoint = "PollLocationByXY";
	            this.satelliteEndPoint = "SatellitePollLocationsByXY";
	            this.registrationEndPoint = 'RegistrationInfo';
	            this.districtsEndPoint = 'DistrictInfoByXY';
	            this.officialsEndPoint = 'ElectedOfficialsByXY';
	            this.candidatesEndPoint = 'CandidatesByXY';
	            this.publicQuestionsEndPoint = 'PublicQuestions';
	            this.ballotsEndPoint = 'BallotsByXY';
	            this.concatenators = ['and', '&', 'at'];
	            this.jsonpCallback = "?method=JSONP_CALLBACK";
	            this.searchType = "";
	            this.appSettings = config_1.Config.config[0];
	            this.electionServiceURL = this.appSettings["electionServiceURL"];
	            // // Get app settings from settings service
	            // this._settingsService.getAppSettings().subscribe(
	            //     settings => {
	            //         this.appSettings = settings[0]
	            //         this.electionServiceURL = this.appSettings["electionServiceURL"];
	            //     },
	            //     err => { this.error = true }
	            // );
	        }
	        //Web Service call to get the location and supporting information about the polling place based upon the XY coordinates of the voters address location
	        ElectionService.prototype.getPollLocation = function (x, y) {
	            var urlEndpoint = this.electionServiceURL + this.pollingPlaceEndPoint + '/' + x + '/' + y + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Web Service call to get the satellite voting locations
	        ElectionService.prototype.getSatellites = function (x, y) {
	            var urlEndpoint = this.electionServiceURL + this.satelliteEndPoint + '/' + x + '/' + y + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Web service call to get the voters registration info
	        ElectionService.prototype.getRegistrationInfo = function (houseNum, birthdate) {
	            var urlEndpoint = this.electionServiceURL + this.registrationEndPoint + '/' + houseNum + '/' + birthdate + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Web service call to get the voters registration info
	        ElectionService.prototype.getDistricts = function (x, y) {
	            var urlEndpoint = this.electionServiceURL + this.districtsEndPoint + '/' + x + '/' + y + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //web service call to get elected officicals for location
	        ElectionService.prototype.getOfficials = function (x, y) {
	            var urlEndpoint = this.electionServiceURL + this.officialsEndPoint + '/' + x + '/' + y + '/ALL' + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Get the list of candidates
	        ElectionService.prototype.getCandidates = function (x, y) {
	            var urlEndpoint = this.electionServiceURL + this.candidatesEndPoint + '/' + x + '/' + y + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Get the public questions
	        ElectionService.prototype.getPublicQuestions = function () {
	            var urlEndpoint = this.electionServiceURL + this.publicQuestionsEndPoint + this.jsonpCallback;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        //Web service call to get the ballot info
	        ElectionService.prototype.getBallots = function (x, y, urlPathPrefix, fileExt) {
	            var urlEndpoint = this.electionServiceURL + this.ballotsEndPoint + '/' + x + '/' + y + this.jsonpCallback + '&urlPathPrefix=' + urlPathPrefix + '&fileExt=' + fileExt;
	            return this.jsonp.get(urlEndpoint)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        ElectionService.prototype.getFAQs = function (language) {
	            var urlEndpoint;
	            //determine which set of questions to load
	            switch (language) {
	                case "en":
	                    urlEndpoint = "data/faq_en.json"; // + this.jsonpCallback;
	                    break;
	                case "es":
	                    urlEndpoint = "data/faq_es.json"; // + this.jsonpCallback;
	                    break;
	            }
	            return this.http.get(urlEndpoint).map(function (res) { return res.json(); });
	        };
	        ElectionService.prototype.sharePPViaEmail = function (msgBody) {
	            var urlEndpoint = this.appSettings["emailService"] + this.jsonpCallback;
	            var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	            var options = new http_1.RequestOptions({ headers: headers });
	            return this.http.post(urlEndpoint, msgBody, options)
	                .toPromise()
	                .then(function (response) { return response.json(); })
	                .catch(this.handleError);
	        };
	        ElectionService.prototype.notifyResult = function (res) {
	            var body = res.json();
	            return body.data || {};
	        };
	        //handle any errors
	        ElectionService.prototype.handleError = function (error) {
	            console.error('An error occurred', error);
	            return Promise.reject(error.message || error);
	        };
	        ElectionService = __decorate([
	            core_1.Injectable(),
	            __metadata("design:paramtypes", [http_1.Http, http_1.Jsonp, settings_service_1.SettingsService])
	        ], ElectionService);
	        return ElectionService;
	    }());
	    exports.ElectionService = ElectionService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(27), __webpack_require__(67), __webpack_require__(41)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, http_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    /*
	    service module for loading application settings
	    */
	    var SettingsService = /** @class */ (function () {
	        function SettingsService(http) {
	            this.http = http;
	        }
	        SettingsService.prototype.getAppSettings = function () {
	            return this.http.get('data/settings.json').map(function (res) { return res.json(); });
	        };
	        SettingsService = __decorate([
	            core_1.Injectable(),
	            __metadata("design:paramtypes", [http_1.Http])
	        ], SettingsService);
	        return SettingsService;
	    }());
	    exports.SettingsService = SettingsService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var Config = /** @class */ (function () {
	        function Config() {
	        }
	        return Config;
	    }());
	    exports.Config = Config;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"emailModal\" class=\"modal-dialog\" >\r\n<!--header-->\r\n  <div class=\"demo-card-square mdl-card mdl-shadow--2dp emailCard\" >\r\n    <div class=\"mdl-card__title\">\r\n        <h1 class=\"mdl-card__title-text\">{{'pplShareDialogTitle' | translate:{value: pplShareDialogTitle} }}</h1>\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                  <button id=\"btnCloseDialog\" class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"closePanel()\">    \r\n                    <i class=\"material-icons\">cancel</i>\r\n                </button>\r\n    </div>\r\n<!--from/to email inputs-->\r\n   <div class=\"mdl-card__supporting-text\" >\r\n      <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label\">\r\n        <input class=\"mdl-textfield__input\" type=\"email\" id=\"fromemail\" [(ngModel)]=\"fromAddress\" value={{fromAddress}} required />\r\n        <label class=\"mdl-textfield__label\" for=\"fromemail\">{{'pplShareFromEmail' | translate:{value: pplShareFromEmail} }}</label>\r\n      </div>\r\n        <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label\">\r\n        <input class=\"mdl-textfield__input\" type=\"email\" id=\"toemail\" [(ngModel)]=\"toAddress\" value={{toAddress}} required />\r\n        <label class=\"mdl-textfield__label\" for=\"toemail\">{{'pplShareToEmail' | translate:{value: pplShareToEmail} }}</label>\r\n      </div>\r\n   </div>\r\n<!--footer and submit button-->\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n        <button  class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\" [disabled]=\"!fromAddress || !toAddress || !emailBody\" (click)=\"sendEmail()\">\r\n            <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" *ngIf=\"!emailBody\"></div>\r\n          {{'pplSendEmailButton' | translate:{value: pplSendEmailButton} }}\r\n        </button>\r\n    </div>\r\n</div>\r\n</div> ";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var LoadingComponent = /** @class */ (function () {
	        //  inject necessary services
	        function LoadingComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	        }
	        //initialize email objects 
	        LoadingComponent.prototype.ngOnInit = function () {
	            // //get email inputs
	            // let fromInput: any = document.getElementById('fromemail');
	            // let toInput:any = document.getElementById('toemail');
	            // //if there is an address in local storage
	            // this.fromAddress = window.localStorage.getItem("vipFromEmail" );
	            // this.fromAddress ? toInput.focus() : fromInput.focus();;
	            // // Get app settings from settings service      
	            // this._settingsService.getAppSettings().subscribe(
	            //     settings => { 
	            //         this.appSettings = settings
	            //     },
	            //     err => { this.error = true }
	            // );
	            //update chnages in the DOM
	            componentHandler.upgradeAllRegistered();
	            //set necessary styles
	            // fromInput ? fromInput.parentElement.classList.add('is-dirty'): console.log("from email input is undefined");
	            // fromInput ? fromInput.parentElement.classList.remove('is-invalid'): console.log("from email input is undefined");
	        };
	        LoadingComponent = __decorate([
	            core_1.Component({
	                selector: 'loading-spinner',
	                template: __webpack_require__(71),
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], LoadingComponent);
	        return LoadingComponent;
	    }());
	    exports.LoadingComponent = LoadingComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = "    <div class=\"tab-loading\">    \r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\"  ></div>\r\n    </div>  ";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    //import { Flyer } from './electedofficials.component';
	    var FederalLevelPipe = /** @class */ (function () {
	        function FederalLevelPipe() {
	        }
	        FederalLevelPipe.prototype.transform = function (Persons) {
	            if (Persons) {
	                return Persons.filter(function (person) { return person["Level"] === "Federal"; });
	            }
	        };
	        FederalLevelPipe = __decorate([
	            core_1.Pipe({ name: 'federallevel' })
	        ], FederalLevelPipe);
	        return FederalLevelPipe;
	    }());
	    exports.FederalLevelPipe = FederalLevelPipe;
	    var StateLevelPipe = /** @class */ (function () {
	        function StateLevelPipe() {
	        }
	        StateLevelPipe.prototype.transform = function (Persons) {
	            if (Persons) {
	                return Persons.filter(function (person) { return person["Level"] === "State"; });
	            }
	        };
	        StateLevelPipe = __decorate([
	            core_1.Pipe({ name: 'statelevel' })
	        ], StateLevelPipe);
	        return StateLevelPipe;
	    }());
	    exports.StateLevelPipe = StateLevelPipe;
	    var LocalLevelPipe = /** @class */ (function () {
	        function LocalLevelPipe() {
	        }
	        LocalLevelPipe.prototype.transform = function (Persons) {
	            if (Persons) {
	                return Persons.filter(function (person) { return person["Level"] === "Local"; });
	            }
	        };
	        LocalLevelPipe = __decorate([
	            core_1.Pipe({ name: 'locallevel' })
	        ], LocalLevelPipe);
	        return LocalLevelPipe;
	    }());
	    exports.LocalLevelPipe = LocalLevelPipe;
	    var CityLevelPipe = /** @class */ (function () {
	        function CityLevelPipe() {
	        }
	        CityLevelPipe.prototype.transform = function (Persons) {
	            if (Persons) {
	                return Persons.filter(function (person) { return person["Level"] === "Indpls/Marion County"; });
	            }
	        };
	        CityLevelPipe = __decorate([
	            core_1.Pipe({ name: 'citylevel' })
	        ], CityLevelPipe);
	        return CityLevelPipe;
	    }());
	    exports.CityLevelPipe = CityLevelPipe;
	    var PartyPipe = /** @class */ (function () {
	        function PartyPipe() {
	        }
	        PartyPipe.prototype.transform = function (Persons, Party) {
	            if (Persons) {
	                if (Party) {
	                    return Persons.filter(function (person) { return person["Party"] === Party; });
	                }
	                else {
	                    return Persons;
	                }
	            }
	        };
	        PartyPipe = __decorate([
	            core_1.Pipe({ name: 'party' })
	        ], PartyPipe);
	        return PartyPipe;
	    }());
	    exports.PartyPipe = PartyPipe;
	    var SpecialElectionPipe = /** @class */ (function () {
	        function SpecialElectionPipe() {
	        }
	        SpecialElectionPipe.prototype.transform = function (Persons, SpecialElection) {
	            if (Persons) {
	                return Persons.filter(function (person) { return person["SpecialElection"] === SpecialElection; });
	            }
	        };
	        SpecialElectionPipe = __decorate([
	            core_1.Pipe({ name: 'specialelection' })
	        ], SpecialElectionPipe);
	        return SpecialElectionPipe;
	    }());
	    exports.SpecialElectionPipe = SpecialElectionPipe;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var AutoNextDirective = /** @class */ (function () {
	        function AutoNextDirective(el, renderer) {
	            this.el = el;
	        }
	        //listen for keyup event and then check if text length  = maxlength. if so then change focus to provided HTML element
	        AutoNextDirective.prototype.onchange = function () {
	            if (this.el.nativeElement.value.length == this.el.nativeElement.maxLength) {
	                var nextElement = document.getElementById(this.nextElID);
	                if (nextElement) {
	                    nextElement.focus();
	                }
	            }
	        };
	        __decorate([
	            core_1.Input('autoNext'),
	            __metadata("design:type", String)
	        ], AutoNextDirective.prototype, "nextElID", void 0);
	        __decorate([
	            core_1.HostListener('keyup'),
	            __metadata("design:type", Function),
	            __metadata("design:paramtypes", []),
	            __metadata("design:returntype", void 0)
	        ], AutoNextDirective.prototype, "onchange", null);
	        AutoNextDirective = __decorate([
	            core_1.Directive({ selector: '[autoNext]' }),
	            __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	        ], AutoNextDirective);
	        return AutoNextDirective;
	    }());
	    exports.AutoNextDirective = AutoNextDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(77), __webpack_require__(86), __webpack_require__(88), __webpack_require__(90), __webpack_require__(92), __webpack_require__(75), __webpack_require__(94), __webpack_require__(96), __webpack_require__(98), __webpack_require__(100), __webpack_require__(117), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, verification_component_1, pollingplace_component_1, registration_component_1, votingdistrict_component_1, electedofficials_component_1, candidates_component_1, ballots_component_1, faq_component_1, earlyvoting_component_1, locationsearch_module_1, mapinfo_module_1, shared_module_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var VoterInformationModule = /** @class */ (function () {
	        function VoterInformationModule() {
	        }
	        VoterInformationModule = __decorate([
	            core_1.NgModule({
	                imports: [
	                    locationsearch_module_1.LocationSearchModule,
	                    mapinfo_module_1.MapInfoModule,
	                    shared_module_1.SharedModule
	                ],
	                declarations: [
	                    verification_component_1.VerificationComponent,
	                    pollingplace_component_1.PollingPlaceComponent,
	                    registration_component_1.RegistrationComponent,
	                    votingdistrict_component_1.VotingDistrictComponent,
	                    electedofficials_component_1.ElectedOfficialsComponent,
	                    candidates_component_1.CandidatesComponent,
	                    ballots_component_1.BallotsComponent,
	                    faq_component_1.FAQComponent,
	                    earlyvoting_component_1.EarlyVotingComponent
	                ],
	                providers: [],
	                exports: [verification_component_1.VerificationComponent,
	                    pollingplace_component_1.PollingPlaceComponent,
	                    registration_component_1.RegistrationComponent,
	                    votingdistrict_component_1.VotingDistrictComponent,
	                    electedofficials_component_1.ElectedOfficialsComponent,
	                    candidates_component_1.CandidatesComponent,
	                    ballots_component_1.BallotsComponent,
	                    faq_component_1.FAQComponent,
	                    earlyvoting_component_1.EarlyVotingComponent,
	                    mapinfo_module_1.MapInfoModule]
	            })
	        ], VoterInformationModule);
	        return VoterInformationModule;
	    }());
	    exports.VoterInformationModule = VoterInformationModule;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var CandidatesComponent = /** @class */ (function () {
	        function CandidatesComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.candidatesInfo = [];
	            this.questionsInfo = [];
	            this.isCandidateInfoRetrieved = false;
	            this.tabActivated = false;
	            this.partyList = [];
	            this.specialElectionPartyList = [];
	            this.electionList = [];
	            this.specialElectionList = [];
	            this.specialElectionCandidates = [];
	        }
	        CandidatesComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            //subscribe to the selected address from the address search
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	            });
	            //subscribe to the search invoked event, once a search is begun
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isCandidateInfoRetrieved = false;
	                _this.selectedAddressLocation ? _this.getCandidatesInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'Candidates'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	                _this.isRegularElection = _this.appSettings["regularElection"];
	                _this.isRegularPrimary = _this.appSettings["regularPrimary"];
	                _this.regularElectionDate = _this.appSettings["regularElectionDate"];
	                _this.isSpecialElection = _this.appSettings["specialElection"];
	                _this.isSpecialPrimary = _this.appSettings["specialPrimary"];
	                _this.specialElectionDate = _this.appSettings["specialElectionDate"];
	                // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            }, function (err) { _this.error = true; });
	        };
	        CandidatesComponent.prototype.ngAfterViewChecked = function () {
	            componentHandler.upgradeAllRegistered();
	        };
	        CandidatesComponent.prototype.getCandidatesInformation = function () {
	            var _this = this;
	            //web service call to get the candidates
	            this._electionService
	                .getCandidates(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (candidates) {
	                var sortingCount = 0;
	                candidates.sort(function (n1, n2) {
	                    var partyRanks = ["Democratic", "Republican", "Libertarian"];
	                    if (n1["Rank"] > n2["Rank"]) {
	                        return 1;
	                    }
	                    else if (n1["Rank"] < n2["Rank"]) {
	                        return -1;
	                    }
	                    else if (n1["Rank"] == n2["Rank"] && partyRanks.indexOf(n1["Party"]) < partyRanks.indexOf(n2["Party"])) {
	                        return -1;
	                    }
	                    else if (n1["Rank"] == n2["Rank"] && partyRanks.indexOf(n1["Party"]) > partyRanks.indexOf(n2["Party"])) {
	                        return 1;
	                    }
	                });
	                _this.candidatesInfo = candidates;
	                _this.partyList = [];
	                _this.specialElectionPartyList = [];
	                _this.electionList = [];
	                _this.specialElectionList = [];
	                _this.specialElectionCandidates = [];
	                //get all the parties and special election candidates
	                for (var _i = 0, _a = _this.candidatesInfo; _i < _a.length; _i++) {
	                    var c = _a[_i];
	                    var party = c["Party"];
	                    if (!_this.partyList.includes(party)) {
	                        _this.partyList.push(party);
	                    }
	                    //if the candidate is for a special election
	                    if (c["SpecialElection"]) {
	                        if (!_this.specialElectionPartyList.includes(party)) {
	                            _this.specialElectionPartyList.push(c["Party"]);
	                        }
	                        _this.specialElectionCandidates.push(c);
	                    }
	                }
	                //OK, now setup the elections array
	                //if it's a regular election
	                if (_this.isRegularElection) {
	                    //and it's a regular primary
	                    if (_this.isRegularPrimary) {
	                        for (var _b = 0, _c = _this.partyList; _b < _c.length; _b++) {
	                            var pty = _c[_b];
	                            var election = {
	                                name: "Regular",
	                                party: pty,
	                                type: "Primary",
	                                date: _this.regularElectionDate
	                            };
	                            _this.electionList.push(election);
	                        }
	                        //ok wait, it's just a regular election
	                    }
	                    else {
	                        var election = {
	                            name: "Regular",
	                            party: "",
	                            type: "General",
	                            date: _this.regularElectionDate
	                        };
	                        _this.electionList.push(election);
	                    }
	                }
	                //now check if there is a special election too
	                if (_this.isSpecialElection) {
	                    //and it's also a special primary
	                    if (_this.isSpecialPrimary) {
	                        for (var _d = 0, _e = _this.specialElectionPartyList; _d < _e.length; _d++) {
	                            var pty = _e[_d];
	                            var election = {
	                                name: "Special",
	                                party: pty,
	                                type: "Primary",
	                                date: _this.specialElectionDate
	                            };
	                            _this.specialElectionList.push(election);
	                        }
	                        //or not
	                    }
	                    else {
	                        var election = {
	                            name: "Special",
	                            party: "",
	                            type: "General",
	                            date: _this.specialElectionDate
	                        };
	                        _this.specialElectionList.push(election);
	                    }
	                }
	                //let the application know that it's good to render the HTML'
	                _this.isCandidateInfoRetrieved = true;
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log(_this.error);
	            });
	            //web service call to get the public questions
	            this._electionService
	                .getPublicQuestions()
	                .then(function (questions) {
	                _this.questionsInfo = questions;
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log(_this.error);
	            });
	        };
	        // destroy map
	        CandidatesComponent.prototype.ngOnDestroy = function () {
	        };
	        CandidatesComponent.prototype.onMenuClick = function () {
	            console.log("item was selected");
	        };
	        CandidatesComponent = __decorate([
	            core_1.Component({
	                selector: 'candidates-info',
	                template: __webpack_require__(76)
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], CandidatesComponent);
	        return CandidatesComponent;
	    }());
	    exports.CandidatesComponent = CandidatesComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabCandidates\">\r\n    <!-- <div class=\"content-card-wide mdl-card\">\r\n        <div class=\"mdl-card__title\">\r\n            <h2 class=\"mdl-card__title-text\">{{'candidatesTitle' | translate:{value: candidatesTitle} }}</h2>\r\n        </div>\r\n    </div> -->\r\n    <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <!--<i class=\"material-icons orange600\">info</i>-->\r\n            <h2 class=\"mdl-card__title-text\">{{'candidatesInactive' | translate:{value: candidatesInactive} }}</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"tabActivated\">\r\n        <div class=\"gen-text-content\" *ngIf=\"error\">\r\n            <div class=\"mdl-card__supporting-text\">\r\n                <i class=\"material-icons red\">error</i>\r\n                <h2 class=\"mdl-card__title-text\">{{'candidatesError' | translate:{value: candidatesError} }}</h2>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"!error\">\r\n            <loading-spinner *ngIf=\"!isCandidateInfoRetrieved\"></loading-spinner>\r\n            <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n                <div class=\"mdl-card__title\">\r\n                    <h2 class=\"mdl-card__title-text\">{{'candidatesTitle' | translate:{value: candidatesTitle} }}</h2>\r\n                </div>\r\n                <div style=\"padding:10px\">\r\n                    <p  [innerHtml]=\"'candidatesInstructions' | translate:{value: candidatesInstructions}\"></p>\r\n                </div>\r\n            <br>\r\n            <!--<hr>-->\r\n            <expand-panel panelTitle=\"{{election.party}} {{election.type}} {{'candidatesRegularElectionTitle' | translate:{value: candidatesRegularElectionTitle} }} {{election.date}}\" parent=true *ngFor=\"let election of electionList; let i = index\">\r\n                <expand-panel panelTitle=\"{{'federalLevel' | translate:{value: federalLevel} }}\" *ngIf=\"(candidatesInfo | federallevel | party:election.party | specialelection:false).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr> \r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | federallevel | party:election.party | specialelection:false\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'stateLevel' | translate:{value: stateLevel} }}\" *ngIf=\"(candidatesInfo | statelevel | party:election.party | specialelection:false).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | statelevel | party:election.party | specialelection:false\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'countyLevel' | translate:{value: countyLevel} }}\" *ngIf=\"(candidatesInfo | citylevel | party:election.party | specialelection:false).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | citylevel | party:election.party | specialelection:false\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'localLevel' | translate:{value: localLevel} }}\" *ngIf=\"(candidatesInfo | locallevel | party:election.party | specialelection:false).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | locallevel | party:election.party | specialelection:false\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n            </expand-panel>\r\n\r\n            <expand-panel panelTitle=\"{{'candidatesSpecialHeader' | translate:{value: candidatesSpecialHeader} }} - {{spelection.party}} {{'candidatesSpecialElectionTitle' | translate:{value: candidatesSpecialElectionTitle} }} {{spelection.date}}\" parent=true  *ngFor=\"let spelection of specialElectionList; let i = index\">\r\n                <expand-panel panelTitle=\"{{'federalLevel' | translate:{value: federalLevel} }}\" *ngIf=\"(candidatesInfo | federallevel | party:spelection.party | specialelection:true).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | federallevel | party:spelection.party | specialelection:true\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'stateLevel' | translate:{value: stateLevel} }}\" *ngIf=\"(candidatesInfo | statelevel | party:spelection.party | specialelection:true).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | statelevel | party:spelection.party | specialelection:true\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'countyLevel' | translate:{value: countyLevel} }}\" *ngIf=\"(candidatesInfo | citylevel | party:spelection.party | specialelection:true).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | citylevel | party:spelection.party | specialelection:true\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n                <expand-panel panelTitle=\"{{'localLevel' | translate:{value: localLevel} }}\" *ngIf=\"(candidatesInfo | locallevel | party:spelection.party | specialelection:true).length\">\r\n                    <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                                <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                                <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let candidate of candidatesInfo | locallevel | party:spelection.party | specialelection:true\">\r\n                                <td data-label=\"Title\" class=\"official-title\">{{candidate.Title}}</td>\r\n                                <td data-label=\"Party\">{{candidate.Party}}</td>\r\n                                <td data-label=\"Name\">{{candidate.Name}}</td>\r\n\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </expand-panel>\r\n            </expand-panel>\r\n\r\n            <expand-panel panelTitle=\"{{'candidatesPublicQuestionsHeader' | translate:{value: candidatesPublicQuestionsHeader} }}\" parent=true *ngIf=\"(questionsInfo).length\">\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                    <thead>\r\n                        <tr>\r\n                                <th>{{'candidatesQuestionNumber' | translate:{value: candidatesQuestionNumber} }}</th>\r\n                                <th>{{'candidatesQuestionTitle' | translate:{value: candidatesQuestionTitle} }}</th>\r\n                                <th>{{'candidatesQuestionDescription' | translate:{value: candidatesQuestionDescription} }}</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let question of questionsInfo\">\r\n                            <td data-label=\"Number\" class=\"official-title\">Question #{{question.Number}}</td>\r\n                            <td data-label=\"Title\">{{question.Title}}</td>\r\n                            <td data-label=\"Description\">{{question.Description}}</td>\r\n\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </expand-panel>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(79), __webpack_require__(66), __webpack_require__(80), __webpack_require__(81), __webpack_require__(78), __webpack_require__(82), __webpack_require__(83), __webpack_require__(84), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, utilities_1, settings_service_1, GeometryService, ProjectParameters, SpatialReference, Point, WebMercatorUtils, EsriRequest, ng2_translate_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var VerificationComponent = /** @class */ (function () {
	        //    changeLanguageControl:FormControl = new FormControl(true);
	        //    loginControl: FormControl = new FormControl('');
	        //  myForm = new FormGroup({
	        //     changeLanguage: this.changeLanguageCtrl,
	        // });
	        // myGroup = new FormGroup({
	        //    changeLanguageControl: new FormControl()
	        // });
	        //  myForm = new FormGroup({
	        //    changeLanguage: 
	        //  });
	        // monthInputControl = new FormControl();
	        // dayInputControl = new FormControl();
	        // yearInputControl = new FormControl();
	        // viewSelectControl = new FormControl();
	        function VerificationComponent(elRef, _eventsService, _settingsService, _translate) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._settingsService = _settingsService;
	            this._translate = _translate;
	            this.onValidLocation = new core_1.EventEmitter();
	            this.onGeolocationError = new core_1.EventEmitter();
	            this.inputDrawer = false;
	            this.infoViewVal = "";
	            this.isSearchInvoked = false;
	            this.isGeolocationInProgress = false;
	            this.isVoterRegistered = false;
	            this.isValidAddress = false;
	            this.isValidDOB = false;
	            this.checkVal = false;
	            this.urlQueryTab = "";
	            this.urlQueryAddress = "";
	            this.urlQueryCity = "";
	            this.urlQueryZip = "";
	            this.urlQueryXcoord = "";
	            this.urlQueryYcoord = "";
	            this.urlQueryDOB = "";
	            this.selectOptions = ["tabPollingPlace", "tabRegistration", "tabDistricts", "tabOfficials", "tabCandidates", "tabBallots", "tabMap", "tabFAQ"];
	            //    this.changeLanguageControl.setValue(false);
	            var urlQueryObject = {};
	            for (var prop in dojo["queryToObject"](window.location.search.substring(1))) {
	                var propValue = dojo["queryToObject"](window.location.search.substring(1))[prop];
	                var propCorr = prop.toLowerCase();
	                urlQueryObject[propCorr] = propValue;
	            }
	            if (urlQueryObject.address) {
	                var urlSearchAddress = urlQueryObject.address;
	                this.urlQueryAddress = urlSearchAddress;
	                if (urlQueryObject.city) {
	                    this.urlQueryCity = urlQueryObject.city.toString();
	                }
	                if (urlQueryObject.zip) {
	                    this.urlQueryZip = urlQueryObject.zip.toString();
	                }
	                console.log("Verification Component: address - " + urlSearchAddress);
	            }
	            if (urlQueryObject.tab) {
	                var selectTab = urlQueryObject.tab;
	                this.urlQueryTab = selectTab;
	                console.log("Verification Component: tab - " + selectTab);
	            }
	            if (urlQueryObject.xcoord && urlQueryObject.ycoord) {
	                var selectCoords = {
	                    Xcoord: urlQueryObject.xcoord,
	                    Ycoord: urlQueryObject.ycoord
	                };
	                this.urlQueryXcoord = selectCoords["Xcoord"];
	                this.urlQueryYcoord = selectCoords["Ycoord"];
	                console.log("Verification Component: coords - " + selectCoords);
	            }
	            if (urlQueryObject.dob) {
	                var dob = urlQueryObject.dob;
	                this.urlQueryDOB = dob;
	                var dobArray = dob.split("-");
	                if (dobArray.length == 3) {
	                    this.yearInputVal = Number(dobArray[0]);
	                    this.monthInputVal = Number(dobArray[1]);
	                    this.dayInputVal = Number(dobArray[2]);
	                }
	            }
	        }
	        //setup the parameters for the information search
	        VerificationComponent.prototype.setupSearch = function (address) {
	            console.log(this.selectedAddressSuggestion["FullAddress"]);
	            //invoke valid voter address event
	            this._eventsService.voterAddressValid(true);
	            this._eventsService.setSelectedAddress(this.selectedAddressObject);
	        };
	        //Close the drawer if open
	        VerificationComponent.prototype.closeDrawer = function () {
	            //toggle the drawer panel
	            this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
	            this.drawer.classList.contains('is-visible') ? this.drawer.classList.toggle('is-visible') : console.log("There was an issue closing the drawer");
	            this.drawer.setAttribute("aria-hidden", "true");
	            //toggle the obfuscation panel
	            this.obfuscator = document.getElementsByClassName('mdl-layout__obfuscator')[0];
	            this.obfuscator.classList.contains('is-visible') ? this.obfuscator.classList.toggle('is-visible') : console.log("There was an issue closing the obfuscator");
	        };
	        //invoke the information search
	        VerificationComponent.prototype.searchClick = function () {
	            var birthDate;
	            var month = this.monthInputVal;
	            var day = this.dayInputVal;
	            var year = this.yearInputVal;
	            var infoview = this.infoViewVal;
	            console.log("Search button clicked: " + month + "/" + day + "/" + year);
	            //format and validate the birthdate
	            if (utilities_1.default.isValidDate(day, month, year)) {
	                birthDate = year + '-';
	                if ((month + '').length == 1) {
	                    birthDate += '0' + month + '-';
	                }
	                else {
	                    birthDate += month + '-';
	                }
	                if ((day + '').length == 1) {
	                    birthDate += '0' + day;
	                }
	                else {
	                    birthDate += day;
	                }
	                //infor app that birthdate is validated
	                this._eventsService.voterBirthdate(birthDate);
	                console.log("Validated date: " + birthDate);
	            }
	            else {
	                //alert(applicationStrings.birthDateError);
	                console.log("birthdate not valid");
	                this._eventsService.voterBirthdate(null);
	            }
	            //set the active tab
	            this._eventsService.setActiveTab(infoview);
	            this.isSearchInvoked = true;
	            //invoke the search event
	            this._eventsService.voterSearchInvoked(this.selectedAddressObject);
	            this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
	            this.drawer.setAttribute("aria-hidden", "true");
	        };
	        VerificationComponent.prototype.addressIsSelected = function (address) {
	            // selectedAddressItem
	            address ? this.selectedAddressObject = address : null;
	            this.selectedAddressSuggestion = address["addressSuggestion"];
	            this.selectedAddressSuggestion ? this.setupSearch(address) : console.log("Address object Undefined");
	            if (this.urlQueryXcoord != "" && this.urlQueryYcoord != "" && this.urlQueryAddress != "") {
	                // setTimeout(() => {
	                //     this.searchClick();
	                // }, 3000);
	                this.urlQueryXcoord = "";
	                this.urlQueryYcoord = "";
	                this.urlQueryAddress = "";
	                this.urlQueryCity = "";
	                this.urlQueryZip = "";
	            }
	        };
	        //handle events from the address search input
	        VerificationComponent.prototype.validateAddressToggle = function (validAddress) {
	            this.isValidAddress = validAddress;
	            if (this.infoViewVal != 'tabRegistration' && this.infoViewVal != 'tabEarlyVoting') {
	                if (this.isValidAddress) {
	                    this.searchClick();
	                }
	                //if address is cleared, clear out birthday
	                if (!this.isValidAddress) {
	                    this.monthInputVal = null;
	                    this.dayInputVal = null;
	                    this.yearInputVal = null;
	                }
	            }
	            else if (this.infoViewVal == 'tabRegistration') {
	                if (this.urlQueryDOB != "") {
	                    if (this.isValidAddress) {
	                        this.searchClick();
	                    }
	                    //if address is cleared, clear out birthday
	                    if (!this.isValidAddress) {
	                        this.monthInputVal = null;
	                        this.dayInputVal = null;
	                        this.yearInputVal = null;
	                    }
	                    this.urlQueryDOB = "";
	                }
	            }
	            else if (this.infoViewVal == 'tabEarlyVoting') {
	            }
	        };
	        // navToNextDateVal(element:Element) {
	        //     if (element["TextLength"] >= 2) {
	        //         document.getElementById("dayinput").focus();
	        //     }
	        // }
	        //Upon component initialize, wire up event subscribers
	        VerificationComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	            }, function (err) { _this.error = true; });
	            if (this.urlQueryTab != "") {
	                for (var i = 0; i < this.selectOptions.length; i++) {
	                    if (this.urlQueryTab.toLowerCase() == this.selectOptions[i].toLowerCase()) {
	                        this.infoViewVal = this.selectOptions[i];
	                        continue;
	                    }
	                }
	            }
	            // if(this.urlQueryTab != "" && this.selectOptions.indexOf(this.urlQueryTab) != -1){
	            //     this.infoViewVal = this.urlQueryTab;
	            // }
	            this._eventsService.activeTab$.subscribe(function (tabview) {
	                _this.infoViewVal = tabview;
	            });
	        };
	        VerificationComponent.prototype.ngAfterViewChecked = function () {
	            // componentHandler.upgradeAllRegistered();
	        };
	        // destroy map
	        VerificationComponent.prototype.ngOnDestroy = function () {
	        };
	        VerificationComponent.prototype.getUserLocation = function () {
	            var _this = this;
	            if (navigator.geolocation) {
	                this.isGeolocationInProgress = true;
	                this._eventsService.startAddressFromGeolocation();
	                navigator.geolocation.getCurrentPosition(this.showPosition.bind(this), this.locationError.bind(this));
	            }
	            else {
	                //this.onGeolocationError.next("Geolocation is not supported by your browser.");
	                this._translate.get("geolocationNotSupported").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	            }
	        };
	        VerificationComponent.prototype.showPosition = function (position) {
	            var _this = this;
	            console.log(position);
	            var pt = WebMercatorUtils.geographicToWebMercator(new Point({
	                x: position.coords.longitude,
	                y: position.coords.latitude
	            }));
	            var gsvc = new GeometryService();
	            gsvc.url = this.appSettings["geometryService"]["url"];
	            var params = new ProjectParameters();
	            params.geometries = [pt];
	            params.outSR = new SpatialReference(this.appSettings["geometryService"]["outSR"]);
	            gsvc.project(params).then(function (projectedGeometries) {
	                _this.geocodeCoordinates(projectedGeometries[0]);
	            }, function (error) {
	                _this.isGeolocationInProgress = false;
	                _this._eventsService.setAddressFromGeolocation(null);
	                _this._translate.get("geolocationProjectionError").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	            });
	        };
	        VerificationComponent.prototype.geocodeCoordinates = function (point) {
	            var _this = this;
	            EsriRequest(this.appSettings["reverseGeocode"]["url"], {
	                "query": {
	                    "location": point.x + ", " + point.y,
	                    "distance": this.appSettings["reverseGeocode"]["distance"],
	                    "outSR": this.appSettings["reverseGeocode"]["outSR"],
	                    "returnIntersection": this.appSettings["reverseGeocode"]["returnIntersection"],
	                    "f": this.appSettings["reverseGeocode"]["f"]
	                }
	            }).then(function (result) {
	                console.log(result);
	                if (result.data) {
	                    _this.setAddressFromLocation(result.data);
	                }
	                else {
	                    _this.isGeolocationInProgress = false;
	                    _this._eventsService.setAddressFromGeolocation(null);
	                    _this._translate.get("geolocationGeocodeError").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                }
	            }, function (error) {
	                _this.isGeolocationInProgress = false;
	                _this._eventsService.setAddressFromGeolocation(null);
	                _this._translate.get("geolocationGeocodeError").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	            });
	        };
	        VerificationComponent.prototype.setAddressFromLocation = function (addressLocation) {
	            //let selectTab:string = "tabEarlyVoting";
	            var selectTab = this.infoViewVal;
	            if (!this.selectedAddressObject) {
	                this.infoViewVal = selectTab;
	            }
	            this.isGeolocationInProgress = false;
	            this._eventsService.setAddressFromGeolocation(addressLocation);
	        };
	        VerificationComponent.prototype.locationError = function (error) {
	            var _this = this;
	            this.isGeolocationInProgress = false;
	            this._eventsService.setAddressFromGeolocation(null);
	            switch (error.code) {
	                case error.PERMISSION_DENIED:
	                    this._translate.get("geolocationDeniedForVIP").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                    break;
	                case error.POSITION_UNAVAILABLE:
	                    this._translate.get("geolocationPositionUnavailble").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                    break;
	                case error.TIMEOUT:
	                    this._translate.get("geolocationTimedout").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                    break;
	                case error.UNKNOWN_ERROR:
	                    this._translate.get("geolocationUnknownError").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                    break;
	                default:
	                    this._translate.get("geolocationUnknownError").subscribe(function (text) { return _this.onGeolocationError.next(text); });
	                    break;
	            }
	        };
	        VerificationComponent.prototype.inputDrawerCalc = function () {
	            if (this.inputDrawer == true) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        };
	        VerificationComponent.prototype.onSearchOptionChange = function (event) {
	            //console.log(event);
	        };
	        VerificationComponent.prototype.onDOBChange = function (event) {
	            var month = this.monthInputVal;
	            var day = this.dayInputVal;
	            var year = this.yearInputVal;
	            if (utilities_1.default.isValidDate(day, month, year)) {
	                this.isValidDOB = true;
	            }
	            else {
	                this.isValidDOB = false;
	            }
	        };
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], VerificationComponent.prototype, "onValidLocation", void 0);
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], VerificationComponent.prototype, "onGeolocationError", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", Boolean)
	        ], VerificationComponent.prototype, "inputDrawer", void 0);
	        VerificationComponent = __decorate([
	            core_1.Component({
	                selector: 'voter-verify',
	                template: __webpack_require__(85)
	                // directives: [LocationSearchComponent]
	                // pipes: [TranslatePipe]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, settings_service_1.SettingsService, ng2_translate_1.TranslateService])
	        ], VerificationComponent);
	        return VerificationComponent;
	    }());
	    exports.VerificationComponent = VerificationComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_78__;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var Utilities = /** @class */ (function () {
	        function Utilities() {
	        }
	        /**
	      * Returns whether a date is valid.
	      * Month is 1 - January, 2 - February, etc.
	      * Modified from http://www.codetoad.com/javascript_IsValidDate.asp
	      */
	        Utilities.isValidDate = function (day, month, year) {
	            if (day && month && year) {
	                if (year.toString().length == 4) {
	                    var dteDate = void 0;
	                    dteDate = new Date(year, (month - 1), day);
	                    return ((day == dteDate.getDate()) && ((month - 1) == dteDate.getMonth()) && (year == dteDate.getFullYear()));
	                }
	                else {
	                    return false;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        /**
	         * Creates a dialog that has the title specified and whose content includes the image
	         * specified by the url.
	         */
	        Utilities.showPhoto = function (title, url) {
	            // var photodialog = new dijit.Dialog({ title: title,
	            //     content: '<img src="' + url + '"></img>'
	            // });
	            // dojo.body().appendChild(photodialog.domNode);
	            // photodialog.startup();
	            // dojo.connect(photodialog, 'hide', function () { this.destroyRecursive(); });
	            // photodialog.show();
	        };
	        Utilities.escape = function (string) {
	            string = string.replace('\'', '\\\'');
	            return string;
	        };
	        return Utilities;
	    }());
	    exports.default = Utilities;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_80__;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_81__;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_82__;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_84__;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = "<section id=\"panelVerification\">\r\n\r\n    <div class=\"mdl-grid\">\r\n        <!--Intro/Disclaimer section-->\r\n        <div class=\"mdl-cell mdl-cell--6-col disclaimerCell\">\r\n\r\n            <div class=\"disclaimer\" *ngIf=\"!isSearchInvoked\">\r\n                <section role=\"region\" aria-label=\"Site Introduction\">\r\n                    <div class=\"verification-card-wide mdl-card mdl-shadow--2dp disclaimer-section\" [ngClass]=\"{'disclaimer-section-tabRegistration': (infoViewVal == 'tabRegistration')}\">\r\n                        <div class=\"mdl-card__title main-opening-title\">\r\n                            <h1 class=\"mdl-card__title-text\">{{'openingTitle' | translate:{value: openingTitle} }}</h1>\r\n                        </div>\r\n                        <div class=\"mdl-card__supporting-text\">\r\n                            <span id=\"vipDisclaimer\" [innerHtml]=\"'disclaimer' | translate:{value: disclaimer}\"></span>\r\n                        </div>\r\n                    </div>\r\n                </section>\r\n            </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"mdl-cell mdl-cell--6-col\">\r\n\r\n            <div class=\"mdl-card__title main-banner\" *ngIf=\"isSearchInvoked\">\r\n                <h2 class=\"mdl-card__title-text\">{{'searchTitleForAddress' | translate:{value: searchTitleForAddress} }}</h2>\r\n                <!-- Add spacer, to align navigation to the right -->\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                <button id=\"btnCloseDrawer\" alt=\"Close Search Panel\" class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"closeDrawer()\">    \r\n                    <i class=\"material-icons\">close</i>\r\n                </button>\r\n            </div>\r\n            \r\n            <!-- Add birthdate criteria for registration search -->\r\n            <div class=\"verification-card-wide mdl-card mdl-shadow--2dp registration-section\" [style.display]=\"isSearchInvoked ? 'none' : ''\">\r\n                <section role=\"region\" aria-label=\"Information Search\">\r\n                    <div class=\"mdl-card__title main-opening-title\">\r\n                        <h2 class=\"mdl-card__title-text\">{{'chooseSearchOptionText' | translate:{value: chooseSearchOptionText} }}</h2>\r\n                    </div>\r\n                </section>\r\n                <!--Registration data date of birth-->\r\n                <!-- <div class=\"voter-reg-container\">\r\n                    <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                        <input id=\"monthinput\" class=\"mdl-textfield__input\" placeholder=\"mm\" type=\"text\" pattern=\"[0-9]*\" maxlength=\"2\" [(ngModel)]=\"monthInputVal\"\r\n                            value={{monthInputVal}}  #monthinput [autoNext]=\"'dayinput'\">\r\n                        <label class=\"mdl-textfield__label\" for=\"monthinput\">{{'birthMonthLabel' | translate:{value: birthMonthLabel} }}</label>\r\n                        <span class=\"mdl-textfield__error\">{{'nAnMessage' | translate:{value: nAnMessage} }}</span>\r\n                    </div>\r\n                    <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                        <input id=\"dayinput\" class=\"mdl-textfield__input\" placeholder=\"dd\" type=\"text\" pattern=\"[0-9]*\" maxlength=\"2\" [(ngModel)]=\"dayInputVal\"\r\n                            value={{dayInputVal}} [autoNext]=\"'yearinput'\" #dayinput>\r\n                        <label class=\"mdl-textfield__label\" for=\"dayinput\">{{'birthDayLabel' | translate:{value: birthDayLabel} }}</label>\r\n                        <span class=\"mdl-textfield__error\">{{'nAnMessage' | translate:{value: nAnMessage} }}</span>\r\n                    </div>\r\n                    <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                        <input id=\"yearinput\" class=\"mdl-textfield__input\" placeholder=\"yyyy\" type=\"text\" pattern=\"[0-9]*\" minlength=\"4\" maxlength=\"4\"\r\n                            [(ngModel)]=\"yearInputVal\" value={{yearInputVal}} [autoNext]=\"'infoview'\" #yearinput>\r\n                        <label class=\"mdl-textfield__label\" for=\"yearinput\">{{'birthYearLabel' | translate:{value: birthYearLabel} }}</label>\r\n                        <span class=\"mdl-textfield__error\">{{'nAFdigitNumMessage' | translate:{value: nAFdigitNumMessage} }}</span>\r\n                    </div>\r\n                </div> -->\r\n                 <!-- Invoke search section and set initial view -->\r\n                <div class=\"mdl-card__actions mdl-card--border optionsCard\">\r\n                    <div class=\"mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label\">\r\n                        <select class=\"mdl-selectfield__select\" id=\"infoview\" [(ngModel)]=\"infoViewVal\" value={{infoViewVal}} (ngModelChange)=\"onSearchOptionChange($event)\" #infoview>\r\n                            <option [style.display]=\"infoViewVal == '' ? 'inherit' : 'none'\"></option>\r\n                            <option value=\"tabEarlyVoting\">{{'earlyVotingTabTitle' | translate:{value: earlyVotingTabTitle} }}</option>\r\n                            <option value=\"tabPollingPlace\">{{'pplTabTitle' | translate:{value: pplTabTitle} }}</option>\r\n                            <option value=\"tabRegistration\">{{'registrationTabTitle' | translate:{value: registrationTabTitle} }}</option>\r\n                            <option value=\"tabDistricts\">{{'districtsTabTitle' | translate:{value: districtsTabTitle} }}</option>\r\n                            <option value=\"tabOfficials\">{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</option>\r\n                            <option value=\"tabCandidates\">{{'candidatesTabTitle' | translate:{value: candidatesTabTitle} }}</option>\r\n                            <option value=\"tabBallots\">{{'ballotsTabTitle' | translate:{value: ballotsTabTitle} }}</option>\r\n                            <option value=\"tabMap\">{{'mapTabTitle' | translate:{value: mapTabTitle} }}</option>\r\n                            <!-- <option value=\"tabFAQ\">{{'faqTabTitle' | translate:{value: faqTabTitle} }}</option> -->\r\n                        </select>\r\n                        <label class=\"mdl-selectfield__label\" for=\"infoview\">{{'dropdownViewLabel' | translate:{value: dropdownViewLabel} }}</label>\r\n                    </div>\r\n                    <!-- <button id=\"btnSearch\" type=\"button\" role=\"button\" aria-live=\"polite\" alt=\"Search\" class=\"mdl-button mdl-js-button mdl-button--primary\" [disabled]=\"!isValidAddress\" (click)=\"searchClick()\">\r\n                        {{'searchButtonText' | translate:{value: searchButtonText} }}\r\n                    </button> -->\r\n                </div>\r\n            </div>\r\n\r\n            <!--Registration card-->\r\n            <!-- <div class=\"verification-card-wide mdl-card mdl-shadow--2dp polling-place-section\" [style.display]=\"(infoViewVal == 'tabRegistration' && !isSearchInvoked) ? 'inherit' : 'none'\" [ngClass]=\"{'polling-place-section-drawer': inputDrawer}\">\r\n                <section role=\"region\" aria-label=\"Specify Address\">\r\n                    <div class=\"mdl-card__title main-opening-title\" style=\"display: flex;width:95%\">\r\n                        <span>Please visit <a href='https://indianavoters.in.gov/' target=\"_blank\">State of Indiana Voting Portal</a>.</span>\r\n                    </div>\r\n                </section>\r\n            </div> -->\r\n\r\n            <!-- Address locate and search -->\r\n            <div class=\"verification-card-wide mdl-card mdl-shadow--2dp polling-place-section\" [style.display]=\"((infoViewVal != '' && infoViewVal != 'tabEarlyVoting') || isSearchInvoked) ? 'inherit' : 'none'\" [ngClass]=\"{'polling-place-section-drawer': inputDrawer, 'polling-place-section-tabRegistration': (infoViewVal == 'tabRegistration')}\">\r\n                <section role=\"region\" aria-label=\"Specify Address\">\r\n                    <div class=\"mdl-card__title main-opening-title\" style=\"display: flex;width:95%\">\r\n                        <h2 class=\"mdl-card__title-text\">{{'addressInstructions' | translate:{value: addressInstructions} }}</h2>\r\n                    </div>\r\n                </section>\r\n                <location-search (selectedAddressItem)=\"addressIsSelected($event)\" (voterAddressValid)=\"validateAddressToggle($event)\" inputWidth=\"70%\" inputAddress=\"{{urlQueryAddress}}\" inputCity=\"{{urlQueryCity}}\" inputZip=\"{{urlQueryZip}}\" inputXcoord=\"{{urlQueryXcoord}}\" inputYcoord=\"{{urlQueryYcoord}}\"></location-search>\r\n                <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" style=\"max-width: 190px; align-self: center;\" [disabled]=\"isGeolocationInProgress\" title=\"Your Location\" (click)=\"getUserLocation()\">\r\n                    <i class=\"material-icons blue\">my_location</i>\r\n                    {{'userLocationButtonTitle' | translate:{value: userLocationButtonTitle} }}\r\n                </button>\r\n                <!--Registration data date of birth-->\r\n                <div [style.display]=\"(infoViewVal == 'tabRegistration') ? 'inherit' : 'none'\">\r\n                    <section role=\"region\" aria-label=\"Specify DOB\">\r\n                        <div class=\"mdl-card__title main-opening-title\" style=\"display: flex;width:95%\">\r\n                            <h2 class=\"mdl-card__title-text\">{{'birthdayInstructions' | translate:{value: birthdayInstructions} }}</h2>\r\n                        </div>\r\n                    </section>\r\n                    <div class=\"voter-reg-container\">\r\n                        <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                            <input id=\"monthinput\" class=\"mdl-textfield__input\" placeholder=\"mm\" type=\"text\" pattern=\"[0-9]*\" maxlength=\"2\" [(ngModel)]=\"monthInputVal\"\r\n                                value={{monthInputVal}}  #monthinput [autoNext]=\"'dayinput'\" (ngModelChange)=\"onDOBChange($event)\">\r\n                            <label class=\"mdl-textfield__label\" for=\"monthinput\">{{'birthMonthLabel' | translate:{value: birthMonthLabel} }}</label>\r\n                            <span class=\"mdl-textfield__error\">{{'nAnMessage' | translate:{value: nAnMessage} }}</span>\r\n                        </div>\r\n                        <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                            <input id=\"dayinput\" class=\"mdl-textfield__input\" placeholder=\"dd\" type=\"text\" pattern=\"[0-9]*\" maxlength=\"2\" [(ngModel)]=\"dayInputVal\"\r\n                                value={{dayInputVal}} [autoNext]=\"'yearinput'\" #dayinput (ngModelChange)=\"onDOBChange($event)\">\r\n                            <label class=\"mdl-textfield__label\" for=\"dayinput\">{{'birthDayLabel' | translate:{value: birthDayLabel} }}</label>\r\n                            <span class=\"mdl-textfield__error\">{{'nAnMessage' | translate:{value: nAnMessage} }}</span>\r\n                        </div>\r\n                        <div class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label date-val-container\">\r\n                            <input id=\"yearinput\" class=\"mdl-textfield__input\" placeholder=\"yyyy\" type=\"text\" pattern=\"[0-9]*\" minlength=\"4\" maxlength=\"4\"\r\n                                [(ngModel)]=\"yearInputVal\" value={{yearInputVal}} #yearinput (ngModelChange)=\"onDOBChange($event)\">\r\n                            <label class=\"mdl-textfield__label\" for=\"yearinput\">{{'birthYearLabel' | translate:{value: birthYearLabel} }}</label>\r\n                            <span class=\"mdl-textfield__error\">{{'nAFdigitNumMessage' | translate:{value: nAFdigitNumMessage} }}</span>\r\n                        </div>\r\n                    </div>\r\n                    <button type=\"button\" role=\"button\" aria-live=\"polite\" alt=\"Search\" class=\"mdl-button mdl-js-button mdl-button--primary searchButton\" [disabled]=\"!isValidAddress || !isValidDOB\" (click)=\"searchClick()\">\r\n                        {{'searchButtonText' | translate:{value: searchButtonText} }}\r\n                    </button>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"verification-card-wide mdl-card mdl-shadow--2dp polling-place-section\" [style.display]=\"(infoViewVal == 'tabEarlyVoting') ? 'inherit' : 'none'\" [ngClass]=\"{'polling-place-section-drawer': inputDrawer, 'polling-place-section-tabRegistration': (infoViewVal == 'tabRegistration')}\">\r\n                <section role=\"region\" aria-label=\"Specify Address\">\r\n                    <div class=\"mdl-card__title main-opening-title\" style=\"display: flex;width:95%\">\r\n                        <p class=\"mdl-card__title-text\" style=\"display:block;\" [innerHtml]=\"'earlyVotingRedirect' | translate:{value: earlyVotingRedirect}\"></p>\r\n                    </div>\r\n                </section>\r\n            </div>\r\n\r\n            <div></div>\r\n        </div>\r\n    </div>\r\n</section>";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66), __webpack_require__(26), __webpack_require__(80), __webpack_require__(81), __webpack_require__(78), __webpack_require__(82), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1, ng2_translate_1, GeometryService, ProjectParameters, SpatialReference, Point, config_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var PollingPlaceComponent = /** @class */ (function () {
	        function PollingPlaceComponent(elRef, _eventsService, _electionService, _settingsService, _translate) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this._translate = _translate;
	            //General state/admin variables
	            this.isPollingPlaceRetrieved = false;
	            this.isEarlyVotingRetrieved = false;
	            this.isRedirectEnabled = true;
	            this.isAutomaticRedirectionEnabled = false;
	            this.tabActivated = false;
	            this.showEmailPanel = false;
	            var urlQueryObject = {};
	            for (var prop in dojo["queryToObject"](window.location.search.substring(1))) {
	                var propValue = dojo["queryToObject"](window.location.search.substring(1))[prop];
	                var propCorr = prop.toLowerCase();
	                urlQueryObject[propCorr] = propValue;
	            }
	            if (urlQueryObject.tab) {
	                var selectTab = urlQueryObject.tab;
	                if (selectTab.toLowerCase() == "tabpollingplace") {
	                    this.isAutomaticRedirectionEnabled = true;
	                }
	            }
	        }
	        PollingPlaceComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            //subscribe to the selected address from the address search
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                //Get the current address location
	                _this.selectedAddressLocation = address["addressLocation"];
	            });
	            //subscribe to the search invoked event, once a search is begun
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                //Get the current address location
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isPollingPlaceRetrieved = false;
	                _this.selectedAddressLocation ? _this.preGetPollingPlaceInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service 
	            this.appSettings = config_1.Config.config[0];
	            var currentTabSettings = this.appSettings["widgets"].filter(function (item) { return item.name === 'PollingPlace'; });
	            this.tabActivated = currentTabSettings[0].activate;
	            // this._settingsService.getAppSettings().subscribe(
	            //     settings => { 
	            //         this.appSettings = settings[0];
	            //         let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'PollingPlace'; });
	            //         this.tabActivated = currentTabSettings[0].activate;                
	            //         // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            //     },
	            //     err => { this.error = true }
	            // );
	            // componentHandler.upgradeAllRegistered();
	        };
	        //Upon component initialize, wire up event subscribers
	        PollingPlaceComponent.prototype.ngAfterContentChecked = function () {
	            // componentHandler.upgradeAllRegistered();
	        };
	        // destroy map
	        PollingPlaceComponent.prototype.ngOnDestroy = function () {
	        };
	        // Pre-step for polling location search - get lat lon if the redirect to indyvotes.org is enabled
	        PollingPlaceComponent.prototype.preGetPollingPlaceInformation = function () {
	            var _this = this;
	            if (this.isRedirectEnabled) {
	                var pt = new Point({
	                    x: this.selectedAddressLocation["X"],
	                    y: this.selectedAddressLocation["Y"],
	                    spatialReference: {
	                        "wkid": 2965
	                    }
	                });
	                var gsvc = new GeometryService();
	                gsvc.url = this.appSettings["geometryService"]["url"];
	                var params = new ProjectParameters();
	                params.geometries = [pt];
	                params.outSR = new SpatialReference({
	                    "wkid": 4326
	                });
	                gsvc.project(params).then(function (projectedGeometries) {
	                    _this.selectedAddressLocationString = "lat=" + projectedGeometries[0]["y"] + "&lng=" + projectedGeometries[0]["x"];
	                    var automaticRedirectURL = "";
	                    _this._translate.get("pollingPlaceRedirectURL").subscribe(function (text) { return automaticRedirectURL = text; });
	                    automaticRedirectURL = automaticRedirectURL.replace("{0}", _this.selectedAddressLocationString);
	                    console.log(automaticRedirectURL);
	                    if (_this.isAutomaticRedirectionEnabled == true) {
	                        window.open(automaticRedirectURL, "_self");
	                    }
	                    else {
	                        _this._translate.get("pollingPlaceRedirect").subscribe(function (text) { return _this.redirectHTMLComponent = text; });
	                        _this.redirectHTMLComponent = _this.redirectHTMLComponent.replace("{0}", automaticRedirectURL);
	                        _this.isPollingPlaceRetrieved = true;
	                        _this.getPollingPlaceInformation();
	                    }
	                }, function (error) {
	                    _this.error = error;
	                    console.log("Logging error: Cannot retrieve Polling Place. " + _this.error);
	                });
	            }
	            else {
	                this.getPollingPlaceInformation();
	            }
	        };
	        //Retrieve the polling place info from the service
	        PollingPlaceComponent.prototype.getPollingPlaceInformation = function () {
	            var _this = this;
	            this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion["FullAddress"] : this.selectedFullAddress = "Address undefined";
	            //Get primary polling place info
	            this._electionService
	                .getPollLocation(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (pollingplace) {
	                _this.pollingPlaceInfo = pollingplace;
	                _this.pollingPlaceName = pollingplace.Name;
	                _this.photos = pollingplace.Photos;
	                _this.pollingPlacePrecinct = pollingplace.Precinct;
	                _this.pollingPlaceAddress = pollingplace.StreetAddress;
	                _this.pollingPlaceCity = pollingplace.City;
	                _this.isPollingPlaceRetrieved = true;
	                _this._eventsService.setPollingPlace(pollingplace);
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log("Logging error: Cannot retrieve Polling Place. " + _this.error);
	            });
	            // //get the early votiung location info
	            //  this._electionService
	            //     .getSatellites(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	            //     .then(satellites => {
	            //          this.satelliteLocations = satellites
	            //          this.satelliteName = satellites[0].Name
	            //          this.isEarlyVotingRetrieved = true
	            //          this._eventsService.setSatellites(satellites)
	            //         }
	            //     )
	            //     .catch(error => {
	            //         this.error = error
	            //         console.log("Logging error: Cannot retrieve Satellite Polling Place. " + this.error )
	            //      });
	        };
	        //activate map panel and zoom to the polling place
	        PollingPlaceComponent.prototype.viewPollingPlaceOnMap = function () {
	            this._eventsService.zoomToLocation({ "place": this.pollingPlaceInfo, "id": "polling" });
	            this._eventsService.setActiveTab("tabMap");
	        };
	        //activate map panel and zoom to the polling place
	        PollingPlaceComponent.prototype.viewSatelliteOnMap = function (satelliteVotingLocation) {
	            this._eventsService.zoomToLocation(satelliteVotingLocation);
	            this._eventsService.setActiveTab("tabMap");
	        };
	        //activate map panel and zoom to the polling place
	        PollingPlaceComponent.prototype.getDrivingDirections = function (destination) {
	            if (destination === void 0) { destination = "polling"; }
	            this._eventsService.getDirections(destination);
	            this._eventsService.setActiveTab("tabMap");
	        };
	        //view the full image in the larger modal dialog
	        PollingPlaceComponent.prototype.viewFullImage = function (photoURL) {
	            var modalImg = document.getElementById("img01");
	            var modal = document.getElementById('myModal');
	            modal.style.display = "block";
	            this.activePhoto = photoURL;
	        };
	        //show/hide the share via email panel
	        PollingPlaceComponent.prototype.toggleEmailPanel = function (display, votingType, satelliteVotingLocation) {
	            this.showEmailPanel = display;
	            switch (votingType) {
	                case "polling-place":
	                    this.showEmailPanel ? this.sharePollingPlace() : null;
	                    break;
	                case "early-voting":
	                    this.showEmailPanel && satelliteVotingLocation ? this.shareSatellitePollingPlace(satelliteVotingLocation) : null;
	                    break;
	            }
	            // this.showEmailPanel ? this.sharePollingPlace(): null;
	        };
	        //trigger the sharing of a polling place via email
	        PollingPlaceComponent.prototype.sharePollingPlace = function () {
	            var _this = this;
	            var forAddress;
	            var ppPrecinctLabel;
	            var ppNameLabel;
	            var ppAddressLabel;
	            var ppCityLabel;
	            var accessibilityText;
	            this._translate.get("emailSubject").subscribe(function (text) { return _this.emailSubject = text; });
	            this._translate.get("emailForAddress").subscribe(function (text) { return forAddress = text; });
	            this._translate.get("pplAddress").subscribe(function (text) { return ppAddressLabel = text; });
	            this._translate.get("pplPrecinct").subscribe(function (text) { return ppPrecinctLabel = text; });
	            this._translate.get("pplPollingPlace").subscribe(function (text) { return ppNameLabel = text; });
	            this._translate.get("pplCity").subscribe(function (text) { return ppCityLabel = text; });
	            this._translate.get("accessibilityText").subscribe(function (text) { return accessibilityText = text; });
	            // let accessibilityText:string = "Polling locations have been set for the May 3, 2016 General Election. Occasionally locations have to be changed for unforseen reasons so please check back.";
	            this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
	                ppPrecinctLabel + " " + this.pollingPlacePrecinct + "<br/>" +
	                ppNameLabel + ' ' + this.pollingPlaceName + "<br/>" +
	                ppAddressLabel + " " + this.pollingPlaceAddress +
	                "<br/>" + ppCityLabel + " " + this.pollingPlaceCity + "<br/><br/>" +
	                accessibilityText;
	        };
	        //trigger the sharing of a polling place via email
	        PollingPlaceComponent.prototype.shareSatellitePollingPlace = function (satelliteVotingLocation) {
	            // this.showEmailPanel = true;
	            var _this = this;
	            var forAddress;
	            var pplHoursLabel;
	            var ppNameLabel;
	            var ppAddressLabel;
	            var ppCityLabel;
	            var accessibilityText;
	            this._translate.get("pplTitle").subscribe(function (text) { return _this.emailSubject = text; });
	            this._translate.get("emailForAddress").subscribe(function (text) { return forAddress = text; });
	            this._translate.get("pplAddress").subscribe(function (text) { return ppAddressLabel = text; });
	            this._translate.get("pplHours").subscribe(function (text) { return pplHoursLabel = text; });
	            this._translate.get("pplPollingPlace").subscribe(function (text) { return ppNameLabel = text; });
	            this._translate.get("pplCity").subscribe(function (text) { return ppCityLabel = text; });
	            // this._translate.get("accessibilityText").subscribe(text => accessibilityText = text );
	            this.emailSubject = "Early Voting Locations";
	            // let accessibilityText:string = "Polling locations have been set for the May 3, 2016 General Election. Occasionally locations have to be changed for unforseen reasons so please check back.";
	            // this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
	            //                     ppPrecinctLabel + " " + this.pollingPlacePrecinct + "<br/>" +
	            //                     ppNameLabel + ' ' + this.pollingPlaceName + "<br/>" +
	            //                     ppAddressLabel + " " + this.pollingPlaceAddress +
	            //                     "<br/>" + ppCityLabel + " " + this.pollingPlaceCity + "<br/><br/>" +
	            //                     accessibilityText;
	            this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
	                satelliteVotingLocation["Name"] + "<br/><br/>" + ppAddressLabel + " " + satelliteVotingLocation["StreetAddress"] +
	                "<br/>" + ppCityLabel + " " + satelliteVotingLocation["City"] + "<br/>" + pplHoursLabel +
	                satelliteVotingLocation["Schedule"];
	        };
	        PollingPlaceComponent = __decorate([
	            core_1.Component({
	                selector: 'polling-place-info',
	                template: __webpack_require__(87)
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService, ng2_translate_1.TranslateService])
	        ], PollingPlaceComponent);
	        return PollingPlaceComponent;
	    }());
	    exports.PollingPlaceComponent = PollingPlaceComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel is-active\" id=\"tabPollingPlace\" >\r\n   <div class=\"page-content\"><!-- Your content goes here -->\r\n  <div *ngIf=\"!tabActivated\">\r\n           <div class=\"mdl-card__supporting-text\">\r\n         <!--<i class=\"material-icons red\" >error</i>-->\r\n          <!--<span>{{'pplError' | translate:{value: pplError} }}</span>-->\r\n           <h2 class=\"mdl-card__title-text\">{{'pplInactive' | translate:{value: pplInactive} }}</h2>\r\n        </div>\r\n  </div>\r\n  <div *ngIf=\"tabActivated\">\r\n  <loading-spinner *ngIf=\"!isPollingPlaceRetrieved && !isEarlyVotingRetrieved && !error\"></loading-spinner>\r\n \r\n  <!--Error message content-->\r\n <div class=\"gen-text-content\" *ngIf=\"error\" >\r\n    <section role=\"region\" aria-label=\"Error\">\r\n      <div class=\"mdl-card__title\">\r\n        <i class=\"material-icons red\" >error</i><h2 class=\"mdl-card__title-text\">{{'pplError' | translate:{value: pplError} }}</h2>\r\n\r\n      </div>\r\n \r\n    </section>\r\n </div>\r\n\r\n<!--main content-->\r\n  <section role=\"region\" aria-label=\"Polling Place Information\">\r\n<div *ngIf=\"!error && isPollingPlaceRetrieved && !isRedirectEnabled\">\r\n  <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n\r\n    <div class=\"mdl-card__title\">\r\n      <h2 class=\"mdl-card__title-text\">{{'pplTitle' | translate:{value: pplTitle} }} <span class=\"card-pp-name\">{{pollingPlaceName}}</span></h2>\r\n\r\n    </div>\r\n \r\n    <!--display PP photos-->\r\n<div class=\"content-group\">\r\n  <div class=\"photo-card-image mdl-card mdl-shadow--2dp\" *ngFor=\"let photo of photos\" [ngStyle]=\"{'background': 'url(ESRIProxy/proxy.ashx?' + photo + ') center / cover'}\">\r\n    <div class=\"mdl-card__title mdl-card--expand\"></div>\r\n    <div class=\"mdl-card__actions\">\r\n      <a aria-hidden=\"true\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon\"  (click)=\"viewFullImage('ESRIProxy/proxy.ashx?' + photo)\" title=\"{{'pplEnlargePictures' | translate:{value: pplEnlargePictures} }}\">\r\n        <i class=\"material-icons white\"  alt=\"Open Polling Place Photo\">settings_overscan</i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n<!-- The modal dialog for displaying the full image-->\r\n<div id=\"myModal\" class=\"modal\">\r\n  <span class=\"close\" onclick=\"document.getElementById('myModal').style.display='none'\">&times;</span>\r\n  <img class=\"modal-content\" id=\"img01\" src=\"{{activePhoto}}\">\r\n  <div id=\"caption\"></div>\r\n</div> \r\n\r\n<!--election day polling information-->\r\n <section role=\"region\" aria-label=\"Polling Place Information\">\r\n    <div class=\"mdl-grid\">\r\n      <div class=\"mdl-cell mdl-cell--4-col\">\r\n        <ul class=\"mdl-list\">\r\n          <li class=\"mdl-list__item mdl-list__item--two-line\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n      <span>{{'pplPrecinct' | translate:{value: pplPrecinct} }}</span>\r\n            <span class=\"mdl-list__item-sub-title\">{{pollingPlacePrecinct}}</span>\r\n            </span>\r\n          </li>\r\n          <li class=\"mdl-list__item mdl-list__item--three-line\" style=\"height: 65px;\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n      <span>{{'pplAddress' | translate:{value: pplAddress} }}</span><br/>\r\n            <span style=\"font-weight: normal;\">{{pollingPlaceAddress}}</span><br/>\r\n            <span style=\"font-weight: normal;\">{{pollingPlaceCity}}</span>\r\n            </span>\r\n          </li>\r\n          <!-- <li class=\"mdl-list__item mdl-list__item--two-line\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n      <span>{{'pplCity' | translate:{value: pplCity} }}</span>\r\n            <span class=\"mdl-list__item-sub-title\">{{pollingPlaceCity}}</span>\r\n            </span>\r\n          </li> -->\r\n        </ul>\r\n      </div>\r\n      <div class=\"mdl-cell mdl-cell--8-col\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n\r\n         {{'accessibilityText' | translate:{value: accessibilityText} }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n </section>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Get Directions\" (click)=\"getDrivingDirections()\">\r\n        <i class=\"material-icons blue\">directions</i>\r\n            {{'pplDrivingDirections' | translate:{value: pplDrivingDirections} }}\r\n      </button>\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"View on Map\" (click)=\"viewPollingPlaceOnMap()\">\r\n        <i class=\"material-icons blue\">place</i>\r\n             {{'pplViewOnMap' | translate:{value: pplViewOnMap} }}\r\n      </button>\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Share via Email\" (click)=\"toggleEmailPanel(true,'polling-place', null)\">\r\n           <i class=\"material-icons blue\">email</i>\r\n            {{'emailLocationText' | translate:{value: emailLocationText} }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n  </div>\r\n  </section>\r\n  <!--<br>-->\r\n\r\n  <!--Early voting location info-->\r\n\r\n  <div *ngIf=\"!error && isEarlyVotingRetrieved\">\r\n\r\n\r\n  <div class=\"content-card-wide mdl-card mdl-shadow--2dp\" *ngFor=\"let satellite of satelliteLocations; let i = index\">\r\n    <div class=\"mdl-card__title\">\r\n      <h2 class=\"mdl-card__title-text\">{{'pplSatellites' | translate:{value: pplSatellites} }} <span class=\"card-pp-name\">{{satellite.Name}}</span></h2>\r\n    </div>\r\n <section role=\"region\" aria-label=\"Early Voting Information\">\r\n    <div class=\"mdl-grid\">\r\n      <div class=\"mdl-cell mdl-cell--4-col\">\r\n        <ul class=\"mdl-list\">\r\n          <li class=\"mdl-list__item mdl-list__item--two-line\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n        <span>{{'pplAddress' | translate:{value: pplAddress} }}</span>\r\n            <span class=\"mdl-list__item-sub-title\">{{satellite.StreetAddress}}</span>\r\n            </span>\r\n          </li>\r\n          <li class=\"mdl-list__item mdl-list__item--two-line\">\r\n            <span class=\"mdl-list__item-primary-content\">\r\n        <span>{{'pplCity' | translate:{value: pplCity} }}</span>\r\n            <span class=\"mdl-list__item-sub-title\">{{satellite.City}}</span>\r\n            </span>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"mdl-cell mdl-cell--8-col\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n          <b>{{'pplHours' | translate:{value: pplHours} }}</b>\r\n          <span [innerHtml]=\"satellite.Schedule\"> </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n </section>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Get Directions\" (click)=\"getDrivingDirections('satellite-' + i)\">\r\n        <i class=\"material-icons blue\">directions</i>\r\n             {{'pplDrivingDirections' | translate:{value: pplDrivingDirections} }}\r\n      </button>\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"View on Map\" (click)='viewSatelliteOnMap({\"place\":satellite, \"id\":(\"satellite-\" + i)})'>\r\n        <i class=\"material-icons blue\">place</i>\r\n            {{'pplViewOnMap' | translate:{value: pplViewOnMap} }}\r\n      </button>\r\n      <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Share via Email\"  (click)=\"toggleEmailPanel(true, 'early-voting', satellite)\">\r\n            <i class=\"material-icons blue\">email</i>\r\n           {{'emailLocationText' | translate:{value: emailLocationText} }}\r\n      </button>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n\r\n<div class=\"mdl-card__title\" *ngIf=\"isRedirectEnabled\">\r\n  <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n    <div class=\"mdl-card__title\">\r\n      <h2 class=\"mdl-card__title-text\" [innerHtml]=\"redirectHTMLComponent\"></h2>\r\n    </div>\r\n  </div> \r\n</div>\r\n  \r\n\r\n<!--modal dialog for email sharing-->\r\n<email-panel *ngIf=\"showEmailPanel\" (displayStatus)=\"showEmailPanel = $event\" emailSubject = \"{{emailSubject}}\" emailBody = \"{{emailBody}}\" ></email-panel>\r\n\r\n  </div>\r\n  </div>\r\n</section>";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1, forms_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var RegistrationComponent = /** @class */ (function () {
	        function RegistrationComponent(elRef, _eventsService, _electionService, _settingsService) {
	            var _this = this;
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.voterRegistered = false;
	            this.isVotingResponse = false;
	            this.registeredVoterInfo = [];
	            //  voterName: string;
	            //  voterAddress: string;
	            //  voterCity: string;
	            //  voterZip: string;
	            //  voterCounty: string;
	            //  voterPrecinct: string;
	            this.tabActivated = false;
	            this.selectedVoterControl = new forms_1.FormControl();
	            this.multipleVoters = false;
	            this.selectedVoter = 0;
	            _eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                //this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion.FullAddress : this.selectedFullAddress = "Address undefined";
	            });
	            _eventsService.birthdate$.subscribe(function (birthdate) {
	                //Get the current birthday
	                _this.voterBirthdate = birthdate;
	                //initiate the query
	                //   this.voterBirthdate ? this.getRegistration() : console.log("Voter birthday is undefined")
	            });
	            //listen for when a search has been invoked
	            _eventsService.searchInvoked$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                _this.voterRegistered = false;
	                _this.voterBirthdate ? _this.getRegistration() : console.log("Voter birthday is undefined");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'Registration'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	                // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            }, function (err) { _this.error = true; });
	        }
	        //Retrieve the voter registration info from the service
	        RegistrationComponent.prototype.getRegistration = function () {
	            // componentHandler.upgradeAllRegistered();
	            var _this = this;
	            this.isVotingResponse = true;
	            //retrieve from web service
	            this._electionService
	                .getRegistrationInfo(this.selectedAddressSuggestion["HouseNum"], this.voterBirthdate)
	                .then(function (registration) {
	                _this.registeredVoterInfo = registration;
	                _this.voterRegistered = true;
	                _this.isVotingResponse = false;
	                if (_this.registeredVoterInfo.length === 1) {
	                    _this.selectedVoterObject = _this.registeredVoterInfo[0];
	                }
	                else if (_this.registeredVoterInfo.length > 1) {
	                    _this.multipleVoters = true;
	                }
	                else {
	                    _this.voterRegistered = false;
	                }
	                //  componentHandler.upgradeAllRegistered();
	            })
	                .catch(function (error) {
	                _this.error = error;
	                _this.isVotingResponse = false;
	            });
	        };
	        RegistrationComponent.prototype.selectVoter = function () {
	            this.selectedVoterObject = this.registeredVoterInfo[this.selectedVoter];
	            this.multipleVoters = false;
	        };
	        RegistrationComponent.prototype.ngOnInit = function () {
	            // create the map
	            //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
	            //  // get a reference to teh map and expose response to app
	            //  this.map = response.map;
	            //  this.mapLoaded.next(response);
	            //});
	        };
	        // destroy map
	        RegistrationComponent.prototype.ngOnDestroy = function () {
	        };
	        RegistrationComponent = __decorate([
	            core_1.Component({
	                selector: 'registration-info',
	                // templateUrl: 'app/information/registration/registration.component.html'
	                template: __webpack_require__(89),
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], RegistrationComponent);
	        return RegistrationComponent;
	    }());
	    exports.RegistrationComponent = RegistrationComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabRegistration\">\r\n  <div *ngIf=\"!tabActivated\">\r\n           <div class=\"mdl-card__supporting-text\">\r\n           <h2 class=\"mdl-card__title-text\">{{'registrationInactive' | translate:{value: registrationInactive} }}</h2>\r\n        </div>\r\n  </div>\r\n          <div *ngIf=\"tabActivated\">\r\n        <loading-spinner  *ngIf=\"isVotingResponse\"></loading-spinner>\r\n\r\n        <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n            <div class=\"mdl-card__title\">\r\n                <h2 class=\"mdl-card__title-text\">{{'registrationTitle' | translate:{value: registrationTitle} }}</h2>\r\n            </div>\r\n            <!-- <div class=\"gen-text-content\">\r\n                <div class=\"mdl-card__supporting-text\">\r\n                    Please visit <a href='https://indianavoters.in.gov/' target=\"_blank\">State of Indiana Voting Portal</a>.\r\n                </div>\r\n            </div> -->\r\n            <div class=\"gen-text-content\" *ngIf=\"!voterBirthdate\">\r\n                <div class=\"mdl-card__supporting-text\">\r\n                  \r\n                    <!-- <i class=\"material-icons orange600\">info</i> {{'registrationBirthdateMissing' | translate:{value: registrationBirthdateMissing} }}<br> -->\r\n                    <i class=\"material-icons orange600\">info</i> {{'registrationBirthdateMissingVerbosePart1' | translate:{value: registrationBirthdateMissingVerbosePart1} }} <i class=\"material-icons\">search</i> {{'registrationBirthdateMissingVerbosePart2' | translate:{value: registrationBirthdateMissingVerbosePart2} }}<br>\r\n                </div>\r\n            </div>\r\n            <div class=\"gen-text-content\" *ngIf=\"voterBirthdate && !voterRegistered\">\r\n                <div class=\"mdl-card__supporting-text\" [innerHtml]=\"'registrationNotFound' | translate:{value: registrationNotFound}\">\r\n                    <i class=\"material-icons orange600\">info</i> \r\n                </div>\r\n            </div>\r\n         \r\n            <div class=\"mdl-card__supporting-text\" *ngIf=\"voterRegistered && multipleVoters\">\r\n                <span>{{'registrationMultipleVoterLabel' | translate:{value: registrationMultipleVoterLabel} }}</span><br>\r\n                <div class=\"mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label\">\r\n        \r\n                    <select class=\"mdl-selectfield__select\" id=\"multipleVoters\" [(ngModel)]=\"selectedVoter\"  #multipleVoters [formControl]=\"selectedVoterControl\">\r\n                        <option value=\"{{i}}\" *ngFor=\"let voter of registeredVoterInfo; let i = index\">{{voter.Name}}</option>\r\n\r\n                    </select>\r\n                </div>  \r\n                <br>\r\n                <button id=\"btContinueReg\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--colored\" title=\"{{'continueButtonLabel' | translate:{value: continueButtonLabel} }}\" (click)=\"selectVoter()\">\r\n                    \r\n                    <span>{{'continueButtonLabel' | translate:{value: continueButtonLabel} }}</span>\r\n                    <i class=\"material-icons gray\">navigate_next</i>\r\n                </button>\r\n            </div>\r\n            <div class=\"mdl-card__supporting-text\" *ngIf=\"voterRegistered && !multipleVoters\">\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp\">\r\n                    <thead>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationName' | translate:{value: registrationName} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.Name}}</td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationAddress' | translate:{value: registrationAddress} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.Address}}</td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationCity' | translate:{value: registrationCity} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.City}}</td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationZip' | translate:{value: registrationZip} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.Zip}}</td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationCounty' | translate:{value: registrationCounty} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.County}}</td>\r\n                        </tr>\r\n                        <tr>\r\n                            <td class=\"official-title no-header-table\">{{'registrationPrecinct' | translate:{value: registrationPrecinct} }}</td>\r\n                            <td class=\"no-header-table\">{{selectedVoterObject.Precinct}}</td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n            <div class=\"mdl-card__actions mdl-card--border\">\r\n                <div class=\"gen-text-content\" *ngIf=\"voterBirthdate && !voterRegistered\" [innerHtml]=\"'registrationNotFoundContact' | translate:{value: registrationNotFound}\">\r\n                   \r\n                </div>\r\n                <div class=\"gen-text-content\" *ngIf=\"voterRegistered\">\r\n                    <p><i class=\"material-icons orange600\">info</i> {{'registrationInfo' | translate:{value: registrationInfo} }}</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';
	    var VotingDistrictComponent = /** @class */ (function () {
	        function VotingDistrictComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.tabActivated = false;
	            this.isDistrictRetrieved = false;
	        }
	        VotingDistrictComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	                //this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion.FullAddress : this.selectedFullAddress = "Address undefined";
	                //  this.selectedAddressLocation ? this.getDistrictInformation() : console.log("Address location is undefined");
	            });
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isDistrictRetrieved = false;
	                _this.selectedAddressLocation ? _this.getDistrictInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'Districts'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	                // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            }, function (err) { _this.error = true; });
	        };
	        VotingDistrictComponent.prototype.getDistrictInformation = function () {
	            var _this = this;
	            this._electionService
	                .getDistricts(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (district) {
	                _this.isDistrictRetrieved = true;
	                _this.votingDistrictInfo = district;
	                // this.pollingPlaceName = pollingplace.Name
	                // this.photos = pollingplace.Photos
	                // this.pollingPlacePrecinct = pollingplace.Precinct;
	                // this.pollingPlaceAddress = pollingplace.StreetAddress;
	                // this.pollingPlaceCity = pollingplace.City
	            })
	                .catch(function (error) { return _this.error = error; });
	        };
	        // ngAfterContentInit () {
	        // }
	        // destroy map
	        VotingDistrictComponent.prototype.ngOnDestroy = function () {
	        };
	        VotingDistrictComponent = __decorate([
	            core_1.Component({
	                selector: 'district-info',
	                // templateUrl: 'app/information/votingdistrict/votingdistrict.component.html'
	                template: __webpack_require__(91)
	                // directives: [LoadingComponent]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], VotingDistrictComponent);
	        return VotingDistrictComponent;
	    }());
	    exports.VotingDistrictComponent = VotingDistrictComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabDistricts\">\r\n    <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <!--<i class=\"material-icons red\" >error</i>-->\r\n            <!--<span>{{'pplError' | translate:{value: pplError} }}</span>-->\r\n            <h2 class=\"mdl-card__title-text\">{{'districtsInactive' | translate:{value: districtsInactive} }}</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"tabActivated\">\r\n        <div class=\"gen-text-content\" *ngIf=\"error\">\r\n            <div class=\"mdl-card__supporting-text\">\r\n                <i class=\"material-icons red\">error</i>\r\n                <h2 class=\"mdl-card__title-text\">{{'districtsError' | translate:{value: districtsError} }}</h2>\r\n            </div>\r\n        </div>\r\n     <div *ngIf=\"!error\">\r\n    <loading-spinner *ngIf=\"!isDistrictRetrieved\"></loading-spinner>\r\n\r\n    <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n        <div class=\"mdl-card__title\">\r\n            <h2 class=\"mdl-card__title-text\">{{'districtsTitle' | translate:{value: districtsTitle} }}</h2>\r\n        </div>\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp districtInfoTable\">\r\n                <thead>\r\n                </thead>\r\n                <tbody>\r\n                    <tr *ngFor=\"let district of votingDistrictInfo\">\r\n                        <td class=\"official-title no-header-table\">{{district.Name}}</td>\r\n                        <td class=\"no-header-table\" *ngIf=\"district.Value != ''\">{{district.Value}}</td>\r\n                        <td class=\"no-header-table\" *ngIf=\"district.Value === ''\">N/A</td>\r\n                    </tr>\r\n\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n        <!--<ul class=\"mdl-list\">\r\n                    <li class=\"mdl-list__item mdl-list__item--three-line\" *ngFor=\"let district of votingDistrictInfo\">\r\n                        <span class=\"mdl-list__item-primary-content\" >\r\n                            <span>{{district.Name}}</span>\r\n                             \r\n                            <span class=\"mdl-list__item-text-body\" *ngIf=\"district.Value != ''\">{{district.Value}}</span>\r\n                            <span class=\"mdl-list__item-text-body\" *ngIf=\"district.Value === ''\">N/A</span>\r\n                       </span>\r\n                    </li>\r\n                </ul>-->\r\n\r\n\r\n    </div>\r\n</div>\r\n    </div>\r\n</section>\r\n";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';
	    var federal_label = "Federal";
	    var ElectedOfficialsComponent = /** @class */ (function () {
	        function ElectedOfficialsComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.isElectedOfficialsRetrieved = false;
	            this.tabActivated = false;
	        }
	        ElectedOfficialsComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	            });
	            //listen for when a search has been invoked
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isElectedOfficialsRetrieved = false;
	                _this.selectedAddressLocation ? _this.getElectedOfficicalsInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'Officials'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	                // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            }, function (err) { _this.error = true; });
	        };
	        //get elected officials data
	        ElectedOfficialsComponent.prototype.getElectedOfficicalsInformation = function () {
	            var _this = this;
	            this._electionService
	                .getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"]) //getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (officials) {
	                _this.officialsInfo = officials;
	                _this.isElectedOfficialsRetrieved = true;
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log(_this.error);
	            });
	        };
	        // destroy map
	        ElectedOfficialsComponent.prototype.ngOnDestroy = function () {
	        };
	        ElectedOfficialsComponent = __decorate([
	            core_1.Component({
	                selector: 'officials-info',
	                // templateUrl: 'app/information/electedofficials/electedofficials.component.html',
	                template: __webpack_require__(93)
	                // directives: [ExpandPanelComponent, LoadingComponent],
	                // pipes: [FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], ElectedOfficialsComponent);
	        return ElectedOfficialsComponent;
	    }());
	    exports.ElectedOfficialsComponent = ElectedOfficialsComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabOfficials\">\r\n        <loading-spinner *ngIf=\"!isElectedOfficialsRetrieved\"></loading-spinner>\r\n    <div class=\"content-card-wide mdl-card\">\r\n        <div class=\"mdl-card__title\">\r\n            <h2 class=\"mdl-card__title-text\">{{'officialsTabTitle' | translate:{value: officialsTabTitle} }}</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <!--<i class=\"material-icons red\" >error</i>-->\r\n            <!--<span>{{'pplError' | translate:{value: pplError} }}</span>-->\r\n            <h2 class=\"mdl-card__title-text\">{{'officialsInactive' | translate:{value: officialsInactive} }}</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"tabActivated\">\r\n        <div class=\"gen-text-content\" *ngIf=\"error\">\r\n            <div class=\"mdl-card__supporting-text\">\r\n                <!--<i class=\"material-icons red\">error</i>-->\r\n                <i class=\"material-icons red\">error</i>\r\n                <h2 class=\"mdl-card__title-text\">{{'officialsError' | translate:{value: officialsError} }}</h2>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"!error\">\r\n            <!--Federal elected officials -->\r\n            <expand-panel panelTitle=\"{{'federalLevel' | translate:{value: federalLevel} }}\" parent=true >\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                            <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            <th>{{'officialsTermBegins' | translate:{value: officialsTermBegins} }}</th>\r\n                            <th>{{'officialsTermEnds' | translate:{value: officialsTermEnds} }}</th>\r\n                            <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                            <th>{{'officialsPhone' | translate:{value: officialsPhone} }}</th>\r\n\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let official of officialsInfo | federallevel\">\r\n                            <td data-label=\"Office\" class=\"official-title\">{{official.Title}}</td>\r\n                            <td data-label=\"Official\"><a href=\"{{official.Url}}\" target=\"new\">{{official.Name}}</a></td>\r\n                            <td data-label=\"Term Begin\">{{official.TermStart}}</td>\r\n                            <td data-label=\"Term End\">{{official.TermEnd}}</td>\r\n                            <td data-label=\"Party\">{{official.Party}}</td>\r\n                            <td data-label=\"Phone\">{{official.Phone}}</td>\r\n\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </expand-panel>\r\n\r\n            <!--State elected officials -->\r\n            <expand-panel panelTitle=\"{{'stateLevel' | translate:{value: stateLevel} }}\" parent=true >\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                            <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            <th>{{'officialsTermBegins' | translate:{value: officialsTermBegins} }}</th>\r\n                            <th>{{'officialsTermEnds' | translate:{value: officialsTermEnds} }}</th>\r\n                            <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                            <th>{{'officialsPhone' | translate:{value: officialsPhone} }}</th>\r\n\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let official of officialsInfo | statelevel\">\r\n                            <td data-label=\"Office\">{{official.Title}}</td>\r\n                            <td data-label=\"Official\"><a href=\"{{official.Url}}\" target=\"new\">{{official.Name}}</a></td>\r\n                            <td data-label=\"Term Begin\">{{official.TermStart}}</td>\r\n                            <td data-label=\"Term End\">{{official.TermEnd}}</td>\r\n                            <td data-label=\"Party\">{{official.Party}}</td>\r\n                            <td data-label=\"Phone\">{{official.Phone}}</td>\r\n\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </expand-panel>\r\n            <!--Indianapolis/Marion County elected officials -->\r\n            <expand-panel panelTitle=\"{{'countyLevel' | translate:{value: countyLevel} }}\" parent=true >\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                            <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            <th>{{'officialsTermBegins' | translate:{value: officialsTermBegins} }}</th>\r\n                            <th>{{'officialsTermEnds' | translate:{value: officialsTermEnds} }}</th>\r\n                            <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                            <th>{{'officialsPhone' | translate:{value: officialsPhone} }}</th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let official of officialsInfo | citylevel\">\r\n                            <td data-label=\"Office\">{{official.Title}}</td>\r\n                            <td data-label=\"Official\"><a href=\"{{official.Url}}\" target=\"new\">{{official.Name}}</a></td>\r\n                            <td data-label=\"Term Begin\">{{official.TermStart}}</td>\r\n                            <td data-label=\"Term End\">{{official.TermEnd}}</td>\r\n                            <td data-label=\"Party\">{{official.Party}}</td>\r\n                            <td data-label=\"Phone\">{{official.Phone}}</td>\r\n\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </expand-panel>\r\n\r\n            <!--Local elected officials -->\r\n            <expand-panel panelTitle=\"{{'localLevel' | translate:{value: localLevel} }}\" parent=true >\r\n                <table class=\"mdl-data-table mdl-js-data-table mdl-shadow--2dp table\">\r\n                    <thead>\r\n                        <tr>\r\n                            <th>{{'officialsOffice' | translate:{value: officialsOffice} }}</th>\r\n                            <th>{{'officialsName' | translate:{value: officialsName} }}</th>\r\n                            <th>{{'officialsTermBegins' | translate:{value: officialsTermBegins} }}</th>\r\n                            <th>{{'officialsTermEnds' | translate:{value: officialsTermEnds} }}</th>\r\n                            <th>{{'officialsParty' | translate:{value: officialsParty} }}</th>\r\n                            <th>{{'officialsPhone' | translate:{value: officialsPhone} }}</th>\r\n\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let official of officialsInfo | locallevel\">\r\n                            <td data-label=\"Office\">{{official.Title}}</td>\r\n                            <td data-label=\"Official\"><a href=\"{{official.Url}}\" target=\"new\">{{official.Name}}</a></td>\r\n                            <td data-label=\"Term Begin\">{{official.TermStart}}</td>\r\n                            <td data-label=\"Term End\">{{official.TermEnd}}</td>\r\n                            <td data-label=\"Party\">{{official.Party}}</td>\r\n                            <td data-label=\"Phone\">{{official.Phone}}</td>\r\n\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </expand-panel>\r\n        </div>\r\n    </div>\r\n</section>";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1, config_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var BallotsComponent = /** @class */ (function () {
	        function BallotsComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.isBallotInfoRetrieved = false;
	            this.ballotFolder = "";
	            //   ballotNotes:string = 'Notes:<br/><ol><li>Primary elections decide which major political party candidates will be on the ballot in November\'s general election. Indiana law requires voters participating in the primary election to request one of the following ballots: Democratic, Republican or Non-Partisan.</li><ol><li>Democratic and Republican ballots include their party candidates. Additionally, primary ballots include the final election in school board races, public questions, precinct committeeperson (Democratic only) and state convention delegate (Democratic and Republican).</li><li>Non-Partisan ballot only includes final elections for school board races and public questions.</li></ol><li>Indiana law permits 17 year old voters who will be 18 on or before November\'s general election (11/2/10) to participate in May\'s primary election. The ballot contains all races except for school board, precinct committeeperson, state convention delegate and public questions. These options are omitted from the 17 year old ballot because the contests are decided in the May primary election.</li></ol>';
	            this.electionDatePrefix = "";
	            this.tabActivated = false;
	        }
	        BallotsComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressLocation = address["addressLocation"];
	            });
	            //listen for when a search has been invoked
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isBallotInfoRetrieved = false;
	                _this.selectedAddressLocation ? _this.getBallotsInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service      
	            this.appSettings = config_1.Config.config[0];
	            try {
	                var currentTabSettings = this.appSettings["widgets"].filter(function (item) { return item.name === 'Ballots'; });
	                this.tabActivated = currentTabSettings[0].activate;
	                this.ballotFolder = this.appSettings["ballotFolder"];
	            }
	            catch (err) {
	                this.error = true;
	            }
	            // this._settingsService.getAppSettings().subscribe(
	            //     settings => { 
	            //         this.appSettings = settings[0];
	            //         let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Ballots'; });
	            //         this.tabActivated = currentTabSettings[0].activate;
	            //         this.ballotFolder = this.appSettings["ballotFolder"];
	            //     },
	            //     err => { this.error = true }
	            // ); 
	        };
	        //get elected officials data
	        BallotsComponent.prototype.getBallotsInformation = function () {
	            var _this = this;
	            //Get election date
	            var electionDate = '';
	            var electionName = '';
	            if (this.appSettings["regularElection"]) {
	                electionDate = this.appSettings["regularElectionDate"];
	                if (this.appSettings["regularPrimary"]) {
	                    // electionName = this.i18nStrings.candidatesPrimaryElectionTitle + " " + electionDate;
	                }
	                else {
	                    // electionName = this.i18nStrings.candidatesRegularElectionTitle + " " + electionDate;
	                }
	            }
	            else if (this.appSettings["specialElection"]) {
	                electionDate = this.appSettings["specialElectionDate"];
	                // electionName = this.i18nStrings.candidatesSpecialHeader + this.i18nStrings.candidatesSpecialElectionTitle + " " + electionDate;
	            }
	            if (electionDate != null) {
	                var components = electionDate.split("/");
	                if (components.length == 3) {
	                    var month = components[0];
	                    if (month.length == 1) {
	                        month = '0' + month;
	                    }
	                    var day = components[1];
	                    if (day.length == 1) {
	                        day = '0' + day;
	                    }
	                    var year = components[2];
	                    if (year.length == 2) {
	                        year = '20' + year;
	                    }
	                    this.electionDatePrefix = year.substr(2, 2) + month + day;
	                }
	            }
	            this._electionService
	                .getBallots(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"], (this.ballotFolder + "/" + this.electionDatePrefix + "_"), ".pdf") //getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (ballots) {
	                //this._electionService.checkIfLinkIsAlive();
	                _this.ballotsInfo = ballots;
	                _this.isBallotInfoRetrieved = true;
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log(_this.error);
	            });
	        };
	        BallotsComponent.prototype.ngOnDestroy = function () {
	        };
	        BallotsComponent = __decorate([
	            core_1.Component({
	                selector: 'ballots-info',
	                template: __webpack_require__(95)
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], BallotsComponent);
	        return BallotsComponent;
	    }());
	    exports.BallotsComponent = BallotsComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabBallots\">\r\n    <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <!--<i class=\"material-icons red\" >error</i>-->\r\n            <!--<span>{{'pplError' | translate:{value: pplError} }}</span>-->\r\n            <h2 class=\"mdl-card__title-text\">{{'ballotsInactive' | translate:{value: ballotsInactive} }}</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"tabActivated\">\r\n        <div class=\"gen-text-content\" *ngIf=\"error\">\r\n            <div class=\"mdl-card__supporting-text\">\r\n                <i class=\"material-icons red\">error</i>\r\n                <h2 class=\"mdl-card__title-text\">{{'ballotsError' | translate:{value: ballotsError} }}</h2>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"!error\">\r\n            <loading-spinner *ngIf=\"!isBallotInfoRetrieved\"></loading-spinner>\r\n            <!--<div class=\"tab-loading\" *ngIf=\"!isBallotInfoRetrieved\">    \r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\"  ></div>\r\n    </div>      -->\r\n            <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n                <div class=\"mdl-card__title\">\r\n                    <h2 class=\"mdl-card__title-text\">{{'ballotsTitle' | translate:{value: ballotsTitle} }}</h2>\r\n                </div>\r\n                <div class=\"gen-text-content\">\r\n                    <ul class=\"mdl-list\">\r\n                        <li class=\"mdl-list__item\" *ngFor=\"let ballot of ballotsInfo\">\r\n                             <span class=\"mdl-list__item-primary-content\">\r\n                                 <i class=\"material-icons blue mdl-list__item-icon\">playlist_add_check</i>\r\n                            <a href=\"{{ballotFolder}}/{{electionDatePrefix}}_{{ballot.Link}}.pdf\" target=\"_blank\"> {{ballot.Name}}</a>\r\n                             </span>\r\n        \r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"mdl-card__actions mdl-card--border\">\r\n                    <div [innerHtml]=\"'ballotsNotes' | translate:{value: ballotsNotes}\">\r\n\r\n                    </div>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';
	    var FAQComponent = /** @class */ (function () {
	        function FAQComponent(elRef, _eventsService, _electionService, _settingsService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this.isFAQsInfoRetrieved = false;
	            this.faqLanguage = "en";
	            this.tabActivated = false;
	        }
	        FAQComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            //listen for when a search has been invoked
	            this._eventsService.searchInvoked$.subscribe(function (search) {
	                _this.isFAQsInfoRetrieved = false;
	                search ? _this.getFAQsInfo() : console.log("FAQs are not found");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'FAQ'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	                // this.electionServiceURL = this.appSettings["electionServiceURL"];
	            }, function (err) { _this.error = true; });
	            this._eventsService.languageChanged$.subscribe(function (language) {
	                _this.faqLanguage = language;
	                _this.faqLanguage ? _this.getFAQsInfo() : console.log("FAQs are not found");
	                // componentHandler.upgradeAllRegistered();
	                // this.userLang = language;
	                // this.translate.use(this.userLang);
	            });
	        };
	        FAQComponent.prototype.getFAQsInfo = function () {
	            var _this = this;
	            this._electionService.getFAQs(this.faqLanguage).subscribe(function (data) {
	                _this.faqInfo = data;
	                //let troubleshootFaqs:Object = this.faqInfo.
	            }, function (err) { _this.error = true; });
	            //  this._electionService
	            //     .getFAQs()  //getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	            //     .then(faqs => {
	            //          this.faqInfo = faqs
	            //          this.isFAQsInfoRetrieved = true;
	            //         }
	            //     )
	            //     .catch(error => {
	            //         this.error = error
	            //         console.log(this.error)
	            //     });
	        };
	        // destroy map
	        FAQComponent.prototype.ngOnDestroy = function () {
	        };
	        FAQComponent.prototype.onMenuClick = function () {
	            console.log("item was selected");
	        };
	        FAQComponent = __decorate([
	            core_1.Component({
	                selector: 'faq-info',
	                // templateUrl: 'app/information/faq/faq.component.html',
	                template: __webpack_require__(97)
	                // directives: [ExpandPanelComponent]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService])
	        ], FAQComponent);
	        return FAQComponent;
	    }());
	    exports.FAQComponent = FAQComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\"  id=\"tabFAQ\">\r\n        <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <!--<i class=\"material-icons red\" >error</i>-->\r\n            <!--<span>{{'pplError' | translate:{value: pplError} }}</span>-->\r\n            <h2 class=\"mdl-card__title-text\">FAQ information is currently unavailable.</h2>\r\n        </div>\r\n    </div>\r\n     <div *ngIf=\"tabActivated\">\r\n     <div class=\"gen-text-content\" *ngIf=\"error\" >\r\n       <div class=\"mdl-card__supporting-text\">\r\n           <i class=\"material-icons red\" >error</i>\r\n          <h2 class=\"mdl-card__title-text\">There was a problem retrieving the voting district information. Please try again later.</h2>\r\n        </div>\r\n </div>\r\n <div *ngIf=\"!error\" >\r\n    <div class=\"content-card-wide mdl-card\">\r\n        <div class=\"mdl-card__title\">\r\n            <h2 class=\"mdl-card__title-text\">{{'faqTabTitle' | translate:{value: faqTabTitle} }}</h2>\r\n        </div>\r\n    </div>\r\n    <expand-panel *ngFor=\"let faqcategory of faqInfo\" panelTitle=\"{{faqcategory.displayname}}\" parent = true>\r\n    <expand-panel *ngFor=\"let faq of faqcategory.questions\" panelTitle=\"{{faq.question}}\">\r\n             <div [innerHtml]=\"faq.answer\"></div>\r\n    </expand-panel>\r\n</expand-panel> \r\n </div>\r\n     </div>\r\n  <!--<expand-panel panelTitle=\"Voter Information Portal Troubleshoot\">\r\n      <expand-panel panelTitle=\"Why won't it verify my address?\">\r\n          <p>This application only works for Marion County addresses. If you live outside of Marion County, please visit the <a href=\"http://www.indianavoters.com/\" target=\"_blank\">Secretary of State’s Web site</a> to determine your voting location. If you live in Marion County and are still having trouble verifying an address it could be related to a couple of different problems. First, to eliminate the possibility of a spelling error, try typing in the street number and the first few characters of your street name and pause to allow the application to provide you suggestions in the drop down box. If no suggestions are offered, you can type in the full address and click on the Verify Address button to see if the address entered is potentially a valid address based on street range information. If you still cannot find an address, it may be that your address is missing from our system. To report potential address omissions, please email <a href=\"mailto:gis@indy.gov\">gis@indy.gov</a> and provide the address you are having trouble locating.</p>\r\n      </expand-panel>\r\n      <expand-panel panelTitle=\"How can I view elected officials outside of my precinct?\">\r\n          <p>To view elected officials outside of your precinct, enter an address that falls within a precinct other than your own. Elected official information for that address and precinct will be displayed.</p>\r\n      </expand-panel>\r\n  </expand-panel>\r\n    <expand-panel panelTitle=\"Voter Registration\">\r\n      <expand-panel panelTitle=\"How do I know if I am a registered voter?\">\r\n          <p>If you live in Marion County, you can confirm this information by calling the Voter Registration Board at (317) 327-VOTE or using the county’s voter information portal. Registration information can also be confirmed using the Secretary of State’s Web site.</p>\r\n      </expand-panel>\r\n      <expand-panel panelTitle=\"When does voter registration close for an election?\">\r\n          <p>State law closes registration 29 days before any election. Mailed forms can be received after the deadline as long as the envelope is postmarked on or before the deadline and received no later than the Monday after the deadline.</p>\r\n      </expand-panel>\r\n  </expand-panel>-->\r\n</section>";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(54), __webpack_require__(65), __webpack_require__(66), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Events_service_1, election_service_1, settings_service_1, ng2_translate_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var EarlyVotingComponent = /** @class */ (function () {
	        function EarlyVotingComponent(elRef, _eventsService, _electionService, _settingsService, _translate) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._electionService = _electionService;
	            this._settingsService = _settingsService;
	            this._translate = _translate;
	            this.isEarlyVotingRetrieved = false;
	            this.isRedirectEnabled = true;
	            this.tabActivated = false;
	            this.showEmailPanel = false;
	        }
	        EarlyVotingComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            //subscribe to the selected address from the address search
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                //Get the current address location
	                _this.selectedAddressLocation = address["addressLocation"];
	            });
	            //subscribe to the search invoked event, once a search is begun
	            this._eventsService.searchInvoked$.subscribe(function (address) {
	                //get the current address
	                _this.selectedAddressSuggestion = address["addressSuggestion"];
	                //Get the current address location
	                _this.selectedAddressLocation = address["addressLocation"];
	                _this.isEarlyVotingRetrieved = false;
	                _this.selectedAddressLocation ? _this.getEarlyVotingInformation() : console.log("Address location is undefined");
	            });
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'EarlyVoting'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	            }, function (err) { _this.error = true; });
	        };
	        //Upon component initialize, wire up event subscribers
	        EarlyVotingComponent.prototype.ngAfterContentChecked = function () {
	            // componentHandler.upgradeAllRegistered();
	        };
	        // destroy map
	        EarlyVotingComponent.prototype.ngOnDestroy = function () {
	        };
	        EarlyVotingComponent.prototype.getEarlyVotingInformation = function () {
	            var _this = this;
	            this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion["FullAddress"] : this.selectedFullAddress = "Address undefined";
	            //get the early votiung location info
	            this._electionService.getSatellites(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
	                .then(function (satellites) {
	                // satellites.forEach(satellite => {
	                //     let busRoutes:String = (satellite.BusRoutes as Array<string>).join(", ");
	                //     satellite.BusRoutes = busRoutes;
	                // });
	                _this.satelliteLocations = satellites;
	                _this.satelliteName = satellites[0].Name;
	                _this.isEarlyVotingRetrieved = true;
	                _this._eventsService.setSatellites(satellites);
	            })
	                .catch(function (error) {
	                _this.error = error;
	                console.log("Logging error: Cannot retrieve Early Voting Info." + _this.error);
	            });
	        };
	        //activate map panel and zoom to the polling place
	        EarlyVotingComponent.prototype.viewSatelliteOnMap = function (satelliteVotingLocation) {
	            this._eventsService.zoomToLocation(satelliteVotingLocation);
	            this._eventsService.setActiveTab("tabMap");
	        };
	        //activate map panel and zoom to the satellite polling place
	        EarlyVotingComponent.prototype.getDrivingDirections = function (destination) {
	            if (destination === void 0) { destination = "polling"; }
	            this._eventsService.getDirections(destination);
	            this._eventsService.setActiveTab("tabMap");
	        };
	        //show/hide the share via email panel
	        EarlyVotingComponent.prototype.toggleEmailPanel = function (display, votingType, satelliteVotingLocation) {
	            this.showEmailPanel = display;
	            switch (votingType) {
	                case "early-voting":
	                    this.showEmailPanel && satelliteVotingLocation ? this.shareSatellitePollingPlace(satelliteVotingLocation) : null;
	                    break;
	            }
	        };
	        //trigger the sharing of a polling place via email
	        EarlyVotingComponent.prototype.shareSatellitePollingPlace = function (satelliteVotingLocation) {
	            var _this = this;
	            var forAddress;
	            var pplHoursLabel;
	            var ppNameLabel;
	            var ppAddressLabel;
	            var ppCityLabel;
	            var accessibilityText;
	            this._translate.get("pplTitle").subscribe(function (text) { return _this.emailSubject = text; });
	            this._translate.get("emailForAddress").subscribe(function (text) { return forAddress = text; });
	            this._translate.get("pplAddress").subscribe(function (text) { return ppAddressLabel = text; });
	            this._translate.get("pplHours").subscribe(function (text) { return pplHoursLabel = text; });
	            this._translate.get("pplPollingPlace").subscribe(function (text) { return ppNameLabel = text; });
	            this._translate.get("pplCity").subscribe(function (text) { return ppCityLabel = text; });
	            this.emailSubject = "Early Voting Locations";
	            this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
	                satelliteVotingLocation["Name"] + "<br/><br/>" + ppAddressLabel + " " + satelliteVotingLocation["StreetAddress"] +
	                "<br/>" + ppCityLabel + " " + satelliteVotingLocation["City"] + "<br/>" + pplHoursLabel +
	                satelliteVotingLocation["Schedule"];
	        };
	        //view the full image in the larger modal dialog
	        EarlyVotingComponent.prototype.viewFullImage = function (photoURL) {
	            var modal = document.getElementById('myEarlyVotingModal');
	            modal.style.display = "block";
	            this.activePhoto = photoURL;
	        };
	        EarlyVotingComponent = __decorate([
	            core_1.Component({
	                selector: 'early-voting-info',
	                template: __webpack_require__(99)
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, election_service_1.ElectionService, settings_service_1.SettingsService, ng2_translate_1.TranslateService])
	        ], EarlyVotingComponent);
	        return EarlyVotingComponent;
	    }());
	    exports.EarlyVotingComponent = EarlyVotingComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel is-active\" id=\"tabEarlyVoting\" >\r\n    <div class=\"page-content\"><!-- Your content goes here -->\r\n        <div *ngIf=\"tabActivated\">\r\n            <loading-spinner *ngIf=\"!isEarlyVotingRetrieved && !error\"></loading-spinner>\r\n           \r\n            <!--Error message content-->\r\n            <div class=\"gen-text-content\" *ngIf=\"error\" >\r\n                <section role=\"region\" aria-label=\"Error\">\r\n                    <div class=\"mdl-card__title\">\r\n                    <i class=\"material-icons red\" >error</i><h2 class=\"mdl-card__title-text\">{{'pplError' | translate:{value: pplError} }}</h2>\r\n            \r\n                    </div>\r\n            \r\n                </section>\r\n            </div>\r\n          \r\n\r\n\r\n            <!-- The modal dialog for displaying the full image-->\r\n            <div id=\"myEarlyVotingModal\" class=\"modal\" >\r\n                <span class=\"close\" onclick=\"document.getElementById('myEarlyVotingModal').style.display='none'\">&times;</span>\r\n                <img class=\"modal-content\" src=\"{{activePhoto}}\">\r\n                <div></div>\r\n            </div> \r\n            <!--Early voting location info-->\r\n            <div *ngIf=\"!error && isEarlyVotingRetrieved && !isRedirectEnabled\">\r\n                <div class=\"content-card-wide mdl-card mdl-shadow--2dp\" *ngFor=\"let satellite of satelliteLocations; let i = index\">\r\n                    <div class=\"mdl-card__title\">\r\n                        <h2 class=\"mdl-card__title-text\">{{'pplSatellites' | translate:{value: pplSatellites} }} <span class=\"card-pp-name\">{{satellite.Name}}</span></h2>\r\n                    </div>\r\n\r\n                    <!--display PP photos-->\r\n                    <div class=\"content-group\" *ngIf=\"satellite.Photos\">\r\n                        <div class=\"photo-card-image mdl-card mdl-shadow--2dp\" *ngFor=\"let photo of satellite.Photos\" [ngStyle]=\"{'background': 'url(ESRIProxy/proxy.ashx?' + photo + ') center / cover'}\">\r\n                        <div class=\"mdl-card__title mdl-card--expand\"></div>\r\n                        <div class=\"mdl-card__actions\">\r\n                            <a aria-hidden=\"true\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon\"  (click)=\"viewFullImage('ESRIProxy/proxy.ashx?' + photo)\" title=\"{{'pplEnlargePictures' | translate:{value: pplEnlargePictures} }}\">\r\n                            <i class=\"material-icons white\" alt=\"Open Early Voting Place Photo\">settings_overscan</i>\r\n                            </a>\r\n                        </div>\r\n                        </div>\r\n                    </div>\r\n                    \r\n\r\n                    <section role=\"region\" aria-label=\"Early Voting Information\">\r\n                        <div class=\"mdl-grid\">\r\n                            <div class=\"mdl-cell mdl-cell--4-col\">\r\n                                <ul class=\"mdl-list\">\r\n                                    <li class=\"mdl-list__item mdl-list__item--three-line\" style=\"height: 65px;\">\r\n                                        <span class=\"mdl-list__item-primary-content\">\r\n                                            <span>{{'pplAddress' | translate:{value: pplAddress} }}</span><br/>\r\n                                            <span style=\"font-weight: normal;\">{{satellite.StreetAddress}}</span><br/>\r\n                                            <span style=\"font-weight: normal;\">{{satellite.City}}</span>\r\n                                        </span>\r\n                                    </li>\r\n                                    <!-- <li class=\"mdl-list__item mdl-list__item--two-line\">\r\n                                    <span class=\"mdl-list__item-primary-content\">\r\n                                <span>{{'pplCity' | translate:{value: pplCity} }}</span>\r\n                                    <span class=\"mdl-list__item-sub-title\">{{satellite.City}}</span>\r\n                                    </span>\r\n                                    </li> -->\r\n                                </ul>\r\n                                \r\n                            </div>\r\n                            \r\n                            <div class=\"mdl-cell mdl-cell--8-col\">\r\n                            <div class=\"mdl-card__supporting-text\">\r\n                                <b>{{'pplHours' | translate:{value: pplHours} }}</b>\r\n                                <span [innerHtml]=\"satellite.Schedule\"> </span>\r\n                                <div *ngIf=\"satellite.BusRoutes.length > 0\">\r\n                                    <br/>\r\n                                    <b>{{'earlyVotingBusRoutes' | translate:{value: earlyVotingBusRoutes} }}</b>\r\n                                    <span>{{satellite.BusRoutes.join(\", \")}}</span>\r\n                                </div>\r\n                            </div>\r\n                            </div>\r\n                        </div>\r\n                    </section>\r\n                    <div class=\"mdl-card__actions mdl-card--border\">\r\n                        <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Get Directions\" (click)=\"getDrivingDirections('satellite-' + i)\">\r\n                            <i class=\"material-icons blue\">directions</i>\r\n                            {{'pplDrivingDirections' | translate:{value: pplDrivingDirections} }}\r\n                        </button>\r\n                        <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"View on Map\" (click)='viewSatelliteOnMap(({\"place\":satellite, \"id\":(\"satellite-\" + i)}))'>\r\n                            <i class=\"material-icons blue\">place</i>\r\n                            {{'pplViewOnMap' | translate:{value: pplViewOnMap} }}\r\n                        </button>\r\n                        <button class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"Share via Email\"  (click)=\"toggleEmailPanel(true, 'early-voting', satellite)\">\r\n                            <i class=\"material-icons blue\">email</i>\r\n                            {{'emailLocationText' | translate:{value: emailLocationText} }}\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n          \r\n            <!--Temporary redirection to another resource (statis URL link)-->\r\n            <div class=\"mdl-card__title\" *ngIf=\"isRedirectEnabled\">\r\n                <div class=\"content-card-wide mdl-card mdl-shadow--2dp\">\r\n                    <div class=\"mdl-card__title\">\r\n                        <h2 class=\"mdl-card__title-text\" style=\"display:block;\" [innerHtml]=\"'earlyVotingRedirect' | translate:{value: earlyVotingRedirect}\"></h2>\r\n                    </div>  \r\n                </div>\r\n            </div>\r\n\r\n            <!--modal dialog for email sharing-->\r\n            <email-panel *ngIf=\"showEmailPanel\" (displayStatus)=\"showEmailPanel = $event\" emailSubject = \"{{emailSubject}}\" emailBody = \"{{emailBody}}\" >\r\n            </email-panel>\r\n        </div>\r\n    </div>  \r\n</section>";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(57), __webpack_require__(101)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, shared_module_1, locationsearch_component_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    // import { LocationService }     from './locationsearch.service';
	    var LocationSearchModule = /** @class */ (function () {
	        function LocationSearchModule() {
	        }
	        LocationSearchModule = __decorate([
	            core_1.NgModule({
	                imports: [
	                    shared_module_1.SharedModule
	                ],
	                declarations: [locationsearch_component_1.LocationSearchComponent],
	                // providers:    [ LocationService ],
	                exports: [locationsearch_component_1.LocationSearchComponent]
	            })
	        ], LocationSearchModule);
	        return LocationSearchModule;
	    }());
	    exports.LocationSearchModule = LocationSearchModule;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(60), __webpack_require__(102), __webpack_require__(54), __webpack_require__(26), __webpack_require__(105), __webpack_require__(112), __webpack_require__(114)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, forms_1, locationsearch_service_1, Events_service_1, ng2_translate_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var LocationSearchComponent = /** @class */ (function () {
	        function LocationSearchComponent(elRef, locationService, _eventsService, translate) {
	            this.elRef = elRef;
	            this.locationService = locationService;
	            this._eventsService = _eventsService;
	            this.translate = translate;
	            this.selectedAddressItem = new core_1.EventEmitter();
	            this.voterAddressValid = new core_1.EventEmitter();
	            this.inputWidth = "";
	            this.inputAddress = "";
	            this.inputCity = "";
	            this.inputZip = "";
	            this.inputXcoord = "";
	            this.inputYcoord = "";
	            this.values = '';
	            this.searchInProgress = false;
	            this.term = new forms_1.FormControl();
	            // lstSuggestions = new FormControl();
	            this.ignoreTextChange = false;
	            this.enableFallback = false;
	            this.fallbackRun = false;
	            this.dialogShow = false;
	            this.searchButtonEnabled = true;
	            this.langValue = "en";
	            this.validRangesHeader = "";
	            this.oneSuggStreet = false;
	            this.selectIdx = -1;
	        }
	        LocationSearchComponent.prototype.ngOnInit = function () {
	            // create the map
	            //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
	            //  // get a reference to teh map and expose response to app
	            //  this.map = response.map;
	            //  this.mapLoaded.next(response);
	            //});
	            var _this = this;
	            // this.translate.get('addressPlaceholder').subscribe((res: string) => {
	            //     // do something with res
	            //     this.placeHolderText = res;
	            // });
	            // this.translate.get('addressSearchInstructions').subscribe((res: string) => {
	            //     // do something with res
	            //     this.placeHolderText = res;
	            // });
	            this._eventsService.languageChanged$.subscribe(function (language) {
	                _this.langValue = language;
	            });
	            this._eventsService.startAddressFromGeolocation$.subscribe(function () {
	                _this.searchInProgress = true;
	            });
	            this._eventsService.addressFromGeolocation$.subscribe(function (addressLocation) {
	                _this.searchInProgress = false;
	                if (addressLocation == null) {
	                    return;
	                }
	                if (addressLocation["address"].Street) {
	                    _this.inputAddress = addressLocation["address"].Street;
	                }
	                if (addressLocation["address"].City) {
	                    _this.inputCity = addressLocation["address"].City;
	                }
	                if (addressLocation["address"].ZIP) {
	                    _this.inputZip = addressLocation["address"].ZIP;
	                }
	                if (addressLocation["location"].x && addressLocation["location"].y) {
	                    var selectCoords = {
	                        Xcoord: addressLocation["location"].x,
	                        Ycoord: addressLocation["location"].y
	                    };
	                    _this.inputXcoord = selectCoords["Xcoord"];
	                    _this.inputYcoord = selectCoords["Ycoord"];
	                }
	                _this.setAddressFromOutsideSourceIfAvailable();
	            });
	            this.term.valueChanges
	                .debounceTime(400)
	                .switchMap(function (term) { return _this.turnOnInProgress(term); })
	                .subscribe(function (suggestions) {
	                _this.suggestionsReceived(suggestions);
	            }, function (err) { return _this.handleError(err); });
	            this.locationService.navItem$.subscribe(function (item) {
	                return item ? _this.searchInProgress = true : _this.searchInProgress = false;
	            });
	        };
	        LocationSearchComponent.prototype.ngAfterViewInit = function () {
	            this.setAddressFromOutsideSourceIfAvailable();
	        };
	        LocationSearchComponent.prototype.setAddressFromOutsideSourceIfAvailable = function () {
	            console.log("set location if needed");
	            if (this.inputAddress != "" && (this.inputXcoord == "" || this.inputYcoord == "")) {
	                this.searchinput.nativeElement.focus();
	                this.searchinput.nativeElement.value = this.inputAddress;
	                this.term.setValue(this.inputAddress);
	                this.searchContainer.nativeElement.classList.remove('is-invalid');
	                this.searchContainer.nativeElement.classList.add('is-focused');
	                this.searchContainer.nativeElement.classList.add('is-dirty');
	                this.inputAddress = "";
	                this.inputCity = "";
	                this.inputZip = "";
	            }
	            else if (this.inputAddress != "" && this.inputXcoord != "" && this.inputYcoord != "" && Number(this.inputXcoord) != NaN && Number(this.inputYcoord) != NaN) {
	                this.searchContainer.nativeElement.classList.remove('is-invalid');
	                this.searchContainer.nativeElement.classList.add('is-focused');
	                this.searchContainer.nativeElement.classList.add('is-dirty');
	                this.ignoreTextChange = true;
	                this.searchinput.nativeElement.value = this.inputAddress;
	                this.term.setValue(this.inputAddress);
	                this.pickedAddress = new Object();
	                this.pickedAddress["FullName"] = this.inputAddress;
	                this.pickedAddress["City"] = this.inputCity;
	                this.pickedAddress["FullAddress"] = this.inputAddress + ", " + this.inputCity;
	                this.pickedAddress["Zip"] = this.inputZip;
	                this.pickedAddress["HouseNum"] = this.inputAddress.split(" ")[0];
	                this.addressLocationPicked([{ "X": Number(this.inputXcoord), "Y": Number(this.inputYcoord) }]);
	                this.inputAddress = "";
	                this.inputCity = "";
	                this.inputZip = "";
	                this.inputXcoord = "";
	                this.inputYcoord = "";
	            }
	        };
	        LocationSearchComponent.prototype.turnOnInProgress = function (term) {
	            if (this.ignoreTextChange == false) {
	                this.searchInProgress = true;
	                return this.locationService.getAddressSuggestions(term);
	            }
	            else {
	                return [];
	            }
	        };
	        LocationSearchComponent.prototype.emptySuggestionsFallback = function () {
	            if (this.enableFallback == true) {
	                this.locationService.searchType = "Streets";
	                this.fallbackRun = true;
	                this.term.setValue(this.searchinput.nativeElement.value);
	                this.enableFallback = false;
	            }
	            else {
	                return;
	            }
	        };
	        LocationSearchComponent.prototype.handleError = function (error) {
	            console.log(error);
	            this.suggestions = [];
	            this.searchInProgress = false;
	            //return Observable.throw(error.json().error || 'Server error');
	        };
	        // destroy map
	        LocationSearchComponent.prototype.ngOnDestroy = function () {
	        };
	        //invoke fallback search if criteira met
	        LocationSearchComponent.prototype.startFallbackSearch = function () {
	            this.enableFallback = true;
	            this.term.setValue(this.searchinput.nativeElement.value);
	        };
	        LocationSearchComponent.prototype.onKey = function (event) {
	            this.ignoreTextChange = false;
	            if (this.searchinput.nativeElement.value == "") {
	                this.suggestions = [];
	                this.searchInProgress = false;
	                // this._eventsService.voterAddressValid(false);
	                //diable the search button and reset label
	                this.searchButtonEnabled = true;
	                //// this.placeHolderText = "Type to enter address"
	                this.voterAddressValid.emit(false);
	            }
	            if (event.keyCode == 13) {
	                this.enableFallback = true;
	                this.term.setValue(this.searchinput.nativeElement.value);
	            }
	            else if (event.keyCode == 38) {
	                // this.lstSuggestions.nativeElement.children[0].focus()
	            }
	            else if (event.keyCode == 40) {
	                this.selectIdx = this.selectIdx + 1;
	                // this.lstSuggestions.nativeElement.children[0].focus()
	            }
	            else {
	                this.fallbackRun = false;
	            }
	        };
	        LocationSearchComponent.prototype.onKeyDown = function (event) {
	            this.fallbackRun = false;
	        };
	        LocationSearchComponent.prototype.suggestionsReceived = function (suggestions) {
	            this.searchInProgress = false;
	            this.suggestions = [];
	            if (suggestions.length == 0) {
	                //enable the search button and chnage the label text
	                this.searchButtonEnabled = false;
	                //// this.placeHolderText = "Press arrow icon or Enter key to search"
	                //             if(this.enableFallback == true){
	                //     this.emptySuggestionsFallback();
	                // }else if(this.fallbackRun == true){
	                //     this.findStreetRanges();
	                //     this.locationService.searchType = "";
	                //     this.fallbackRun = false;
	                // }
	                // this.enableFallback = false;
	                // return;
	                // this.enableFallback = true;
	                //  this.term.setValue(this.searchinput.nativeElement.value);
	                if (this.enableFallback == true) {
	                    this.emptySuggestionsFallback();
	                }
	                else if (this.fallbackRun == true) {
	                    this.findStreetRanges();
	                    this.locationService.searchType = "";
	                    this.fallbackRun = false;
	                    this.enableFallback = false;
	                }
	                this.enableFallback = false;
	                return;
	            }
	            else {
	                this.enableFallback = false;
	            }
	            suggestions.sort(function (n1, n2) {
	                if (n1["Level"] > n2["Level"]) {
	                    return -1;
	                }
	                if (n1["Level"] < n2["Level"]) {
	                    return 1;
	                }
	                return 0;
	            });
	            for (var _i = 0, suggestions_1 = suggestions; _i < suggestions_1.length; _i++) {
	                var suggestion = suggestions_1[_i];
	                if (this.weedoutDuplicateSuggestions(suggestion) == false) {
	                    suggestion = this.constructFullAddress(suggestion);
	                    this.suggestions.push(suggestion);
	                }
	            }
	            this.suggestions.sort(function (n1, n2) {
	                if (n1["FullAddress"] > n2["FullAddress"]) {
	                    return 1;
	                }
	                if (n1["FullAddress"] < n2["FullAddress"]) {
	                    return -1;
	                }
	                return 0;
	            });
	            this.locationService.searchType = "";
	        };
	        LocationSearchComponent.prototype.constructFullAddress = function (suggestion) {
	            if (suggestion["SuggestionType"] == "Streets") {
	                var num = this.locationService.parsedAddress["streetNumber"];
	                var zip;
	                var city;
	                if (suggestion["FromLeft"] % 2 == num % 2 && suggestion["FromLeft"] <= num && suggestion["FromLeft"] >= num) {
	                    city = suggestion["LeftCity"];
	                    zip = suggestion["LeftZip"];
	                }
	                else {
	                    city = suggestion["RightCity"];
	                    zip = suggestion["RightZip"];
	                }
	                suggestion["FullAddress"] = num + " " + suggestion["FullName"] + ", " + city;
	                suggestion["StreetNumber"] = num;
	                suggestion["FullName"] = num + " " + suggestion["FullName"];
	                suggestion["Zip"] = zip;
	                suggestion["City"] = city;
	            }
	            else if (suggestion["SuggestionType"] == "Address") {
	                if (suggestion["Unit"]) {
	                    suggestion["FullAddress"] = suggestion["FullName"] + (suggestion["Unit"] == "" ? "" : " #" + suggestion["Unit"]) + ", " + suggestion["City"];
	                }
	                else {
	                    suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
	                }
	                suggestion["StreetNumber"] = suggestion["HouseNum"];
	            }
	            else {
	                suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
	            }
	            return suggestion;
	        };
	        LocationSearchComponent.prototype.weedoutDuplicateSuggestions = function (suggestion) {
	            for (var _i = 0, _a = this.suggestions; _i < _a.length; _i++) {
	                var sug = _a[_i];
	                if (sug["FullName"] + " #" + sug["Unit"] == suggestion["FullName"] + " #" + suggestion["Unit"]) {
	                    return true;
	                }
	            }
	            return false;
	        };
	        LocationSearchComponent.prototype.findStreetRanges = function () {
	            var _this = this;
	            this.locationService
	                .getStreetRanges()
	                .then(function (addressRanges) {
	                return _this.processStreetRanges(addressRanges);
	            })
	                .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	        };
	        LocationSearchComponent.prototype.processStreetRanges = function (addressRanges) {
	            //Create some variables
	            var ranges = new Array();
	            var rangesObjArray = new Array();
	            //Flag if this is only one street
	            var _suggStreets = new Array();
	            for (var _i = 0, addressRanges_1 = addressRanges; _i < addressRanges_1.length; _i++) {
	                var street = addressRanges_1[_i];
	                //Get street & address ranges
	                var stname = street.FullName;
	                var lf = street.FromLeft;
	                var lt = street.ToLeft;
	                var rf = street.FromRight;
	                var rt = street.ToRight;
	                var min = Math.min(lf, lt, rf, rt);
	                var max = Math.max(lf, lt, rf, rt);
	                //See if this street already is in my list
	                var range = null;
	                for (var zz = 0; zz < ranges.length; zz++) {
	                    if (ranges[zz].name == stname) {
	                        range = ranges[zz];
	                        break;
	                    }
	                }
	                //Add range
	                if (range == null) {
	                    //Create new street and add it to the list
	                    range = { name: stname, min: min, max: max };
	                    ranges.push(range);
	                    _suggStreets.push(stname);
	                }
	                else {
	                    //Update street range
	                    if (min < range.min) {
	                        range.min = min;
	                    }
	                    if (max > range.max) {
	                        range.max = max;
	                    }
	                }
	                //**Get the min max objects**///
	                rangesObjArray.push({ "name": stname, "min": min, "max": max });
	            }
	            if (_suggStreets.length == 1) {
	                //var sortedRanges = rangesObjArray.sortOn("min", Array.NUMERIC);
	                var sortedRanges = rangesObjArray.sort(function (obj1, obj2) {
	                    return obj1.min - obj2.min;
	                });
	                var finalRanges = [{ "name": sortedRanges[0].name, "min": sortedRanges[0].min, "max": sortedRanges[0].max }];
	                for (var sr = 1; sr < sortedRanges.length; sr++) {
	                    if (sortedRanges[sr].min - sortedRanges[sr - 1].max > 99) {
	                        finalRanges.push(sortedRanges[sr]);
	                    }
	                    else {
	                        finalRanges[(finalRanges.length - 1)]["max"] = sortedRanges[sr].max;
	                    }
	                }
	                ranges = finalRanges;
	                this.validRangesHeader = "Valid address ranges for " + sortedRanges[0].name + " are:";
	                this.oneSuggStreet = true;
	            }
	            else {
	                this.oneSuggStreet = false;
	                this.validRangesHeader = "Valid address ranges are:";
	            }
	            if (addressRanges.length == 0) {
	                this.validRangesHeader = "The address you entered could not be found within Marion County.";
	            }
	            console.log(ranges);
	            this.validStreetRanges = ranges;
	            this.dialogShow = true;
	            this.searchinput.nativeElement.blur();
	        };
	        LocationSearchComponent.prototype.suggestionClicked = function (suggestion) {
	            var _this = this;
	            this.searchInProgress = true;
	            this.pickedAddress = suggestion;
	            this.locationService
	                .getAddressLocation(suggestion)
	                .then(function (addressLocation) {
	                return _this.addressLocationPicked(addressLocation);
	            })
	                .catch(function (error) { return _this.error = error; }); // TODO: Display error message
	        };
	        LocationSearchComponent.prototype.addressLocationPicked = function (addressLocation) {
	            this.ignoreTextChange = true;
	            this.searchInProgress = false;
	            var pickedAddressLocation = { addressSuggestion: this.pickedAddress, addressLocation: addressLocation[0] };
	            // this._eventsService.setSelectedAddress(pickedAddressLocation);
	            this.selectedAddressItem.emit(pickedAddressLocation);
	            this.voterAddressValid.emit(true);
	            this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
	            this.suggestions = new Array();
	        };
	        LocationSearchComponent.prototype.tableRowClick = function (event) {
	            alert("row click");
	        };
	        __decorate([
	            core_1.ViewChild('searchinput'),
	            __metadata("design:type", core_1.ElementRef)
	        ], LocationSearchComponent.prototype, "searchinput", void 0);
	        __decorate([
	            core_1.ViewChild('lstSuggestions'),
	            __metadata("design:type", core_1.ElementRef)
	        ], LocationSearchComponent.prototype, "lstSuggestions", void 0);
	        __decorate([
	            core_1.ViewChild('searchContainer'),
	            __metadata("design:type", core_1.ElementRef)
	        ], LocationSearchComponent.prototype, "searchContainer", void 0);
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], LocationSearchComponent.prototype, "selectedAddressItem", void 0);
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], LocationSearchComponent.prototype, "voterAddressValid", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputWidth", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputAddress", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputCity", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputZip", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputXcoord", void 0);
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", String)
	        ], LocationSearchComponent.prototype, "inputYcoord", void 0);
	        LocationSearchComponent = __decorate([
	            core_1.Component({
	                selector: 'location-search',
	                //templateUrl: 'app/location-search/locationsearch.component.html',
	                template: __webpack_require__(116),
	                styles: [
	                    'li:hover { background-color: #ED1C24; }',
	                    'li:hover > span {color:lightgray }',
	                    'li {cursor:pointer}',
	                    'li {cursor:pointer; border: lightgray 1px solid; min-height: 36px; }',
	                    'ul {background-color: white; padding: 0px 0px 0px 0px; z-index:100}',
	                    // '#searchContainer {width:325px}',
	                    // '.mdl-textfield__input { width:250px}',
	                    // '.mdl-textfield__label { padding-left: 10px; color: #CCCCCC;}',
	                    '@-moz-document url-prefix() { .locationSearchIcon {margin-top:-50px;}}',
	                    '*::-ms-backdrop, .locationSearchIcon {margin-top:-50px !important;}'
	                ],
	                // styles: [require('../location-search/locationsearch.component.css')],
	                providers: [locationsearch_service_1.LocationService]
	                //    pipes: [TranslatePipe]
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, locationsearch_service_1.LocationService, Events_service_1.EventsService, ng2_translate_1.TranslateService])
	        ], LocationSearchComponent);
	        return LocationSearchComponent;
	    }());
	    exports.LocationSearchComponent = LocationSearchComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(27), __webpack_require__(6), __webpack_require__(55), __webpack_require__(66), __webpack_require__(67), __webpack_require__(41), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, http_1, Observable_1, BehaviorSubject_1, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var LocationService = /** @class */ (function () {
	        function LocationService(http, jsonp, _settingsService) {
	            var _this = this;
	            this.http = http;
	            this.jsonp = jsonp;
	            this._settingsService = _settingsService;
	            // Observable navItem source
	            this._navItemSource = new BehaviorSubject_1.BehaviorSubject(0);
	            // Observable navItem stream
	            this.navItem$ = this._navItemSource.asObservable();
	            this.concatenators = ['and', '&', 'at'];
	            this.jsonpCallback = "?method=JSONP_CALLBACK";
	            this.parsedAddress = new Object;
	            this.searchType = "";
	            this.offset = 10;
	            // Get app settings from settings service
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                _this.locateServiceURL = _this.appSettings["addressServiceURL"];
	            }, function (err) { _this.error = true; });
	        }
	        // service command
	        LocationService.prototype.changeNav = function (Object) {
	            this._navItemSource.next(Object);
	        };
	        LocationService.prototype.getAddressSuggestions = function (typedAddress) {
	            var _this = this;
	            if (!typedAddress) {
	                this.changeNav(false);
	                return new Array();
	            }
	            var urlAddress = this.constructURL(typedAddress);
	            // return this.jsonp.get(urlAddress + "?method=JSONP_CALLBACK")
	            //     .toPromise()
	            //     .then(
	            //         (response) => response.json()
	            //     ).catch(this.handleError);
	            if (urlAddress != "") {
	                this.changeNav(true);
	                return this.jsonp.get(urlAddress + this.jsonpCallback)
	                    .map(function (response) {
	                    var suggestionsArray = response.json();
	                    for (var _i = 0, suggestionsArray_1 = suggestionsArray; _i < suggestionsArray_1.length; _i++) {
	                        var sug = suggestionsArray_1[_i];
	                        sug["SuggestionType"] = _this.searchType;
	                    }
	                    return suggestionsArray;
	                })
	                    .catch(this.handleObservableError);
	            }
	            this.changeNav(false);
	            return new Array();
	        };
	        LocationService.prototype.handleObservableError = function (error) {
	            return Observable_1.Observable.of([]);
	        };
	        LocationService.prototype.handleError = function (error) {
	            console.error('An error occurred', error);
	            return Promise.reject(error.message || error);
	        };
	        LocationService.prototype.constructURL = function (typedAddress) {
	            var url = "";
	            this.parsedAddress = new Object();
	            var parsedAddressArray = [typedAddress.substring(0, typedAddress.indexOf(" ")), typedAddress.substring(typedAddress.indexOf(" "))];
	            if (Number(parsedAddressArray[0])) {
	                this.parsedAddress["streetNumber"] = parsedAddressArray[0];
	                if (parsedAddressArray[1] != " ") {
	                    //remove any non alphanumeric characters
	                    var trimStreetName = parsedAddressArray[1].replace(/[\W_]+/g, " ").trim();
	                    //if the resulting value is "" with 0 length, then set it to at least a single space
	                    trimStreetName === "" ? trimStreetName = " " : null;
	                    //resupply to the array
	                    parsedAddressArray[1] = trimStreetName;
	                }
	                this.parsedAddress["streetName"] = parsedAddressArray[1];
	                if (this.searchType == "Streets") {
	                    this.parsedAddress["type"] = "Streets";
	                    url = this.locateServiceURL + "StreetAddresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1];
	                    return url;
	                }
	                this.parsedAddress["type"] = "Address";
	                url = this.locateServiceURL + "Addresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1] + "/true/true/true";
	                this.searchType = "Address";
	                return url;
	            }
	            for (var _i = 0, _a = this.concatenators; _i < _a.length; _i++) {
	                var conc = _a[_i];
	                if (typedAddress.indexOf(" " + conc + " ") != -1 && typedAddress.split(" " + conc + " ").length > 1 && typedAddress.split(" " + conc + " ").indexOf("") == -1) {
	                    var intersections = typedAddress.split(" " + conc + " ");
	                    url = this.locateServiceURL + "Intersections/" + intersections[0] + "/" + intersections[1] + "/" + conc;
	                    this.searchType = "Intersection";
	                    return url;
	                }
	            }
	            return url;
	        };
	        LocationService.prototype.getAddressLocation = function (suggestion) {
	            var locationUrl = "";
	            if (suggestion["SuggestionType"] == "Address") {
	                locationUrl = this.locateServiceURL + "AddressLocation/" +
	                    suggestion["HouseNum"] + "/" + suggestion["Street"]["Tag"] + "/" + (suggestion["Unit"] == "" ? " " : suggestion["Unit"]) +
	                    "/Unit/Parcel" + this.jsonpCallback;
	            }
	            else if (suggestion["SuggestionType"] == "Intersection") {
	                locationUrl = this.locateServiceURL + "IntersectionLocation/" + suggestion["ID"] + this.jsonpCallback;
	            }
	            else if (suggestion["SuggestionType"] == "Streets") {
	                locationUrl = this.locateServiceURL + "StreetLocation/" + suggestion["StreetNumber"] + "/" + suggestion["Tag"] + "/" + this.offset + this.jsonpCallback;
	            }
	            return this.jsonp.get(locationUrl)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        LocationService.prototype.getStreetRanges = function () {
	            var streetName = this.parsedAddress["streetName"];
	            var streetRangesURL = this.locateServiceURL + "Streets/" + streetName + this.jsonpCallback;
	            return this.jsonp.get(streetRangesURL)
	                .toPromise()
	                .then(function (response) { return response.json(); }).catch(this.handleError);
	        };
	        LocationService = __decorate([
	            core_1.Injectable(),
	            __metadata("design:paramtypes", [http_1.Http, http_1.Jsonp, settings_service_1.SettingsService])
	        ], LocationService);
	        return LocationService;
	    }());
	    exports.LocationService = LocationService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports) {

	module.exports = "<div>\r\n        \r\n     \r\n    <!--<label class=\"locationSearchIcon mdl-button mdl-js-button mdl-button--icon\" for=\"searchinput\" (click)=\"startFallbackSearch()\" >\r\n\r\n        <div class=\"material-icons\" *ngIf = \"!searchInProgress\" >search</div>\r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" *ngIf = \"searchInProgress\"></div>\r\n       \r\n               \r\n    </label>-->\r\n    <button id=\"btfallbackSearch\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\"\r\n\t    [disabled]=\"searchButtonEnabled\" (click)=\"startFallbackSearch()\" title=\"{{'fallbackSearchBtnText' | translate:{value: fallbackSearchBtnText} }}\">\r\n             <!--<div class=\"material-icons\" *ngIf = \"!searchInProgress\" >search</div>-->\r\n             <i class=\"material-icons\" *ngIf = \"!searchInProgress && searchButtonEnabled\" >search</i>\r\n             <i class=\"material-icons blue\" *ngIf = \"!searchInProgress && !searchButtonEnabled\" >play_circle_outline</i>\r\n        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" *ngIf = \"searchInProgress\"></div>\r\n    </button>\r\n    <div id=\"searchContainer\" #searchContainer class=\"mdl-textfield mdl-js-textfield mdl-textfield--floating-label\" [style.width]=\"inputWidth\">\r\n        <input id=\"searchinput\" class=\"mdl-textfield__input\" role = \"textbox\" aria-required=\"true\" type=\"text\" #searchinput [formControl]=\"term\" (keyup)=\"onKey($event)\" (keydown)=\"onKeyDown($event)\"\r\n        required />   \r\n       \r\n        <ul  #lstSuggestions  class=\"mdl-list suggestionsList\" aria-live=\"polite\"  style=\"position:absolute\" >\r\n            <li class=\"mdl-list__item suggestionItem\" tabindex=\"{{idx}}\"  role=\"button\" *ngFor=\"let suggestion of suggestions; let idx = index\" (click)=\"suggestionClicked(suggestion)\">\r\n   \r\n                <span class=\"mdl-list__item-primary-content\">\r\n                    {{suggestion.FullAddress}}\r\n                </span>\r\n            </li>\r\n        </ul>\r\n        <!--<label class=\"mdl-textfield__label\" for=\"searchinput\">{{'addressPlaceholder' | translate:{value: addressPlaceholder} }}</label>-->\r\n        <label class=\"mdl-textfield__label\" for=\"searchinput\" *ngIf = \"searchButtonEnabled\"  style=\"overflow: visible\">{{'addressPlaceholder' | translate:{value: addressPlaceholder} }}</label>\r\n        <label class=\"mdl-textfield__label\" for=\"searchinput\" *ngIf = \"!searchButtonEnabled\"  style=\"overflow: visible\">{{'addressSearchInstructions' | translate:{value: addressSearchInstructions} }}</label>\r\n         <!--<a class=\"material-icons\" href=\"http://maps.indy.gov/addresscomponenthelp/index_en.htm\"></a>-->\r\n     \r\n        <!-- <label class=\"locationSearchIcon mdl-button mdl-js-button mdl-button--icon\" for=\"searchinput\" style=\"position: absolute;bottom: 20px;right: -5px;\">\r\n            <i class=\"material-icons blue\">my_location</i>\r\n        </label> -->\r\n          <label class=\"locationSearchIcon mdl-button mdl-js-button mdl-button--icon\" for=\"searchinput\" style=\"position: absolute;bottom: 20px;right: -30px;\">\r\n                <!--<div class=\"material-icons\" [style.visibility]=\"searchInProgress == false ? 'visible' : 'hidden'\">search</div>-->\r\n                <!--<div class=\"material-icons\" *ngIf = \"!searchInProgress\" >help</div>-->\r\n                <a href=\"http://maps.indy.gov/addresscomponenthelp/index_{{langValue}}.htm\" target=\"_blank\"><i class=\"material-icons blue\" alt=\"Help\">help</i></a>\r\n\r\n            </label>\r\n    </div> \r\n\r\n       <!--<a href=\"http://maps.indy.gov/addresscomponenthelp/index_{{langValue}}.htm\" target=\"_blank\" ><i class=\"material-icons blue\" alt=\"Help\">help</i></a>-->\r\n</div>\r\n\r\n<!--<div class=\"mblSimpleDialogCover\" *ngIf=\"dialogShow\"></div>-->\r\n<!-- Square card -->\r\n<div id=\"dlgAddressRanges\" class=\"demo-card-square mdl-card mdl-shadow--2dp\" *ngIf=\"dialogShow\">\r\n    <div class=\"mdl-card__title\">\r\n        <span>{{'addressInvalidMessageTitle' | translate:{value: addressInvalidMessageTitle} }}</span>\r\n    </div>\r\n    <div class=\"mdl-card__supporting-text\" style=\"overflow-y:auto\">\r\n        <span><b>{{'addressInvalidMessageSubTitle' | translate:{value: addressInvalidMessageSubTitle} }}</b></span>\r\n        <ul class=\"mdl-list\">\r\n            <li class=\"mdl-list__item\" *ngFor=\"let range of validStreetRanges\">\r\n                <span class=\"mdl-list__item-primary-content\" ><b *ngIf=\"!oneSuggStreet\">{{range.name}}: </b>{{range.min}} to {{range.max}}</span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <div class=\"mdl-card__actions mdl-card--border\">\r\n        <a (click)=\"dialogShow = false\" class=\"mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect\">\r\n      {{'addressInvalidOKButton' | translate:{value: addressInvalidOKButton} }}\r\n    </a>\r\n    </div>\r\n</div>";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(118), __webpack_require__(127), __webpack_require__(120), __webpack_require__(57), __webpack_require__(100)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, map_component_1, mapview_component_1, map_service_1, shared_module_1, locationsearch_module_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var MapInfoModule = /** @class */ (function () {
	        function MapInfoModule() {
	        }
	        MapInfoModule = __decorate([
	            core_1.NgModule({
	                imports: [
	                    shared_module_1.SharedModule,
	                    locationsearch_module_1.LocationSearchModule
	                ],
	                declarations: [map_component_1.MapComponent, mapview_component_1.MapViewComponent],
	                providers: [map_service_1.MapService],
	                exports: [map_component_1.MapComponent, mapview_component_1.MapViewComponent]
	            })
	        ], MapInfoModule);
	        return MapInfoModule;
	    }());
	    exports.MapInfoModule = MapInfoModule;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(119), __webpack_require__(120), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, MapView, map_service_1, Events_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var MapComponent = /** @class */ (function () {
	        function MapComponent(elRef, _eventsService, _mapService) {
	            this.elRef = elRef;
	            this._eventsService = _eventsService;
	            this._mapService = _mapService;
	            // @Input() centerX: number;
	            // @Input() centerY: number;
	            this.viewCreated = new core_1.EventEmitter();
	            this.view = null;
	        }
	        MapComponent.prototype.ngOnInit = function () {
	            this.view = new MapView({
	                container: this.elRef.nativeElement.firstChild,
	                map: this._mapService.map,
	                zoom: this.zoom
	                // center: [this.centerLng, this.centerLat],
	                // rotation: this.rotation
	            });
	            //map is loaded, then do some stuff
	            this.view.then(function (view) {
	                this.viewCreated.next(view);
	            }.bind(this));
	            this.view.on("click", function (evt) {
	                // evt is the event object returned after the event fires
	                // Prints the map coordinates of the clicked location
	                console.log(evt.mapPoint.x, evt.mapPoint.y);
	            });
	        };
	        // destroy map
	        MapComponent.prototype.ngOnDestroy = function () {
	            if (this.map) {
	                this.map.destroy();
	            }
	        };
	        __decorate([
	            core_1.Input(),
	            __metadata("design:type", Number)
	        ], MapComponent.prototype, "zoom", void 0);
	        __decorate([
	            core_1.Output(),
	            __metadata("design:type", Object)
	        ], MapComponent.prototype, "viewCreated", void 0);
	        MapComponent = __decorate([
	            core_1.Component({
	                selector: 'map-info',
	                // templateUrl: 'app/information/map/map.component.html',
	                template: '<div id="viewDiv"><ng-content></ng-content></div>'
	                // providers: [MapService] 
	            }),
	            __metadata("design:paramtypes", [core_1.ElementRef, Events_service_1.EventsService, map_service_1.MapService])
	        ], MapComponent);
	        return MapComponent;
	    }());
	    exports.MapComponent = MapComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_119__;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(122), __webpack_require__(123), __webpack_require__(121), __webpack_require__(124), __webpack_require__(125), __webpack_require__(126), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, Map, esriConfig, TileLayer, Collection, GraphicsLayer, MapImageLayer, settings_service_1) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    //import {AbandonedHomesPopup, PotholesPopup} from './map.popupTemplate';
	    // import { Http, Response,HTTP_PROVIDERS } from '@angular/http';
	    // import { Observable }     from 'rxjs/Observable';
	    var MapService = /** @class */ (function () {
	        // sliderValue$ = this.sliderSource.asObservable();
	        function MapService(_settingsService) {
	            var _this = this;
	            this._settingsService = _settingsService;
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                _this.addMapServices();
	            }, function (err) { _this.error = true; });
	        }
	        MapService.prototype.addMapServices = function () {
	            esriConfig.request.proxyUrl = "./ESRIProxy/proxy.ashx";
	            //  esriConfig.request.useCors = false;
	            var layers = new Collection();
	            this.appSettings["mapServices"].forEach(function (mapService) {
	                if (mapService.dynamic == false) {
	                    layers.add(new TileLayer({
	                        id: mapService["id"],
	                        url: mapService["url"],
	                        opacity: mapService["opacity"]
	                    }));
	                }
	                else {
	                    layers.add(new MapImageLayer({
	                        id: mapService["id"],
	                        url: mapService["url"],
	                        opacity: mapService["opacity"]
	                    }));
	                }
	            });
	            layers.addMany([
	                new GraphicsLayer({
	                    id: "route"
	                }),
	                new GraphicsLayer({
	                    id: "locations"
	                })
	            ]);
	            this.map = new Map({
	                layers: layers
	            });
	            this.centerX = 189680;
	            this.centerY = 1646766;
	        };
	        MapService = __decorate([
	            core_1.Injectable(),
	            __metadata("design:paramtypes", [settings_service_1.SettingsService])
	        ], MapService);
	        return MapService;
	    }());
	    exports.MapService = MapService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_121__;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_122__;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_123__;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_124__;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_125__;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_126__;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(27), __webpack_require__(60), __webpack_require__(6), __webpack_require__(129), __webpack_require__(130), __webpack_require__(82), __webpack_require__(131), __webpack_require__(132), __webpack_require__(133), __webpack_require__(134), __webpack_require__(128), __webpack_require__(135), __webpack_require__(136), __webpack_require__(54), __webpack_require__(120), __webpack_require__(66), __webpack_require__(137), __webpack_require__(138), __webpack_require__(139), __webpack_require__(140)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, core_1, http_1, forms_1, Observable_1, PopupTemplate, Graphic, Point, PictureMarkerSymbol, RouteTask, RouteParameters, FeatureSet, SimpleMarkerSymbol, SimpleLineSymbol, Color, Events_service_1, map_service_1, settings_service_1, PrintTask, PrintTemplate, PrintParameters) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var MapViewComponent = /** @class */ (function () {
	        function MapViewComponent(_eventsService, _mapService, _settingsService, http, jsonp) {
	            this._eventsService = _eventsService;
	            this._mapService = _mapService;
	            this._settingsService = _settingsService;
	            this.http = http;
	            this.jsonp = jsonp;
	            this.mapSliderControl = new forms_1.FormControl();
	            this.precinctToggleControl = new forms_1.FormControl();
	            this.initTransparencyValue = 0;
	            this.precinctsDisplay = false;
	            this.satelliteVotingPlaces = [];
	            this.selectedAddressString = "";
	            this.showDirections = false;
	            this.tabActivated = false;
	            this.directionsAddrToggleControl = new forms_1.FormControl();
	            this.stopSelectControl = new forms_1.FormControl();
	            this.useDiffAddress = false;
	            this.routeInProgress = false;
	            this.selectedStop = "polling";
	            this.exportedMapImgURL = "";
	            this.showPrint = false;
	            this.printInProgress = false;
	            this.panelHide = false;
	            this.showEmailPanel = false;
	            this.IEbrowser = false;
	            this.internetExplorer = false;
	        }
	        MapViewComponent.prototype.ngOnInit = function () {
	            var _this = this;
	            if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge/") > -1) {
	                this.IEbrowser = true;
	            }
	            if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1) {
	                this.internetExplorer = true;
	            }
	            // Get app settings from settings service      
	            this._settingsService.getAppSettings().subscribe(function (settings) {
	                _this.appSettings = settings[0];
	                var currentTabSettings = _this.appSettings["widgets"].filter(function (item) { return item.name === 'Map'; });
	                _this.tabActivated = currentTabSettings[0].activate;
	            }, function (err) { _this.error = true; });
	            //listen for command to get driving directions
	            this._eventsService.directionsInvoked$.subscribe(function (destination) {
	                //clear any existing list of directions
	                _this.showDirections = false;
	                _this.routelayer ? _this.routelayer.removeAll() : null;
	                //Get the current address location
	                destination ? _this.selectedStop = destination : console.log("A destination was not provided.");
	                var tabpanels = document.querySelectorAll('.mdl-tabs__panel');
	                var tabs = document.querySelectorAll('.mdl-tabs__tab');
	                // let view: any = tabview;
	                for (var _i = 0, tabpanels_1 = tabpanels; _i < tabpanels_1.length; _i++) {
	                    var tabpanel = tabpanels_1[_i];
	                    tabpanel.classList.contains('is-active') ? tabpanel.classList.remove('is-active') : null;
	                    tabpanel.id === "directions-panel" ? tabpanel.classList.add('is-active') : null;
	                }
	                for (var _a = 0, tabs_1 = tabs; _a < tabs_1.length; _a++) {
	                    var tab = tabs_1[_a];
	                    tab.classList.contains('is-active') ? tab.classList.remove('is-active') : null;
	                    tab.hash === "#directions-panel" ? tab.classList.add('is-active') : null;
	                }
	            });
	        };
	        MapViewComponent.prototype.ngAfterViewInit = function () {
	        };
	        MapViewComponent.prototype.inputChange = function (event) {
	            if (this.internetExplorer) {
	                this.initTransparencyValue = event.currentTarget.value;
	                this.sliderChange(event.currentTarget.value);
	            }
	        };
	        MapViewComponent.prototype.startAddressIsSelected = function (address) {
	            // selectedAddressItem
	            address ? this.newStartAddress = address : this.newStartAddress = null;
	            this.directionsStartAddress = this.newStartAddress;
	        };
	        MapViewComponent.prototype.validateAddressToggle = function (validAddress) {
	            !validAddress ? this.directionsStartAddress = null : null;
	        };
	        MapViewComponent.prototype.onMapLoad = function (response) {
	            var _this = this;
	            //handle event when the map/aerial slider value changes
	            this.mapSliderControl.valueChanges
	                .subscribe(function (n) { return _this.sliderChange(n); });
	            //handle event when the precincts layer toggle value changes
	            this.precinctToggleControl.valueChanges
	                .subscribe(function (n) { return _this.precinctsToggle(n); });
	            //handle event when the directions start address toggle value changes
	            this.directionsAddrToggleControl.valueChanges
	                .subscribe(function (n) { return _this.directionsAddrToggle(n); });
	            //get a reference to the MapView
	            this.mapViewRef = response;
	            //get references for the respective map layers
	            this.mapViewRef.map.layers.forEach(function (layer) {
	                if (layer.id === 'aerial') {
	                    _this.aeriallayer = layer;
	                }
	                if (layer.id === 'precincts') {
	                    _this.precinctslayer = layer;
	                    //  this.precinctslayer.visible = this.precinctsDisplay;
	                }
	                if (layer.id === 'route') {
	                    _this.routelayer = layer;
	                }
	                ;
	                if (layer.id === "locations") {
	                    _this.locationGraphics = layer;
	                }
	            });
	            //disable map rotation
	            this.mapViewRef.constraints = {
	                rotationEnabled: false
	            };
	            //listen for any new selected addresses resulting from a new search
	            this._eventsService.selectedAddressObject$.subscribe(function (address) {
	                //this.mapViewRef.graphics.removeAll();
	                _this.locationGraphics.removeAll();
	                //clear any routing results
	                _this.showDirections = false;
	                _this.routelayer.removeAll();
	                //Get the current address location
	                address ? _this.selectedAddress = address : console.log("address object is not set.");
	                _this.selectedAddress ? _this.directionsStartAddress = _this.selectedAddress : null;
	                // address ? this.addHomeAddressGraphic(address): console.log("address object is not set.")
	            });
	            //listen for the new polling place
	            this._eventsService.pollingPlace$.subscribe(function (pollingplace) {
	                //this.mapViewRef.graphics.removeAll();
	                _this.locationGraphics.removeAll();
	                //Get the current address location
	                pollingplace ? _this.addPollingPlaceGraphic(pollingplace) : console.log("polling place object is not set.");
	                _this.pollingPlaceFacility = pollingplace;
	                _this.selectedAddress ? _this.addHomeAddressGraphic(_this.selectedAddress) : console.log("address object is not set.");
	            });
	            //listen for new satellite polling places
	            this._eventsService.satellites$.subscribe(function (satellites) {
	                //Get the current address location
	                satellites ? _this.addSatellitesGraphic(satellites) : console.log("satellite voting object is not set.");
	                _this.satelliteVotingPlaces = satellites;
	            });
	            //listen for command to zoom to a location 
	            this._eventsService.mapZoom$.subscribe(function (votingLocation) {
	                //Get the current address location
	                votingLocation["place"]["Location"] ? _this.zoomMaptoLocation(votingLocation["place"]["Location"]) : console.log("satellite voting object is not set.");
	                _this.selectedStop = votingLocation["id"];
	            });
	            this.mapViewRef.popup.dockOptions = {
	                // Disables the dock button from the popup
	                buttonEnabled: false,
	                // Ignore the default sizes that trigger responsive docking
	                breakpoint: false,
	                position: "bottom-right"
	            };
	        };
	        MapViewComponent.prototype.ngAfterViewChecked = function () {
	        };
	        //Add the home graphic for the voters address
	        MapViewComponent.prototype.addHomeAddressGraphic = function (address) {
	            //let selectedAddressLocation: Object = address["addressLocation"];
	            this.homeLocation = address["addressLocation"];
	            var homeAddress = address["addressSuggestion"];
	            this.selectedAddressString = homeAddress["FullAddress"] + ", IN " + homeAddress["Zip"];
	            // let sr: SpatialReference = this.mapViewRef.spatialReference;
	            var pt = new Point({
	                x: this.homeLocation["X"],
	                y: this.homeLocation["Y"],
	                spatialReference: 2965
	            });
	            var markerSymbol = new PictureMarkerSymbol();
	            markerSymbol.url = "./images/home_red.png";
	            markerSymbol.width = 48;
	            markerSymbol.height = 48;
	            var homeAtt = {
	                Name: "Home",
	                Address: this.selectedAddressString
	            };
	            this.homeGraphic = new Graphic({
	                geometry: pt,
	                symbol: markerSymbol,
	                attributes: homeAtt,
	                popupTemplate: new PopupTemplate({
	                    title: "{Name}",
	                    content: "{Address}"
	                })
	            });
	            //this.mapViewRef.graphics.add(this.homeGraphic);
	            this.locationGraphics.add(this.homeGraphic);
	            this.zoomMaptoLocation(this.homeLocation);
	        };
	        //Add a graphic for the voters polling place
	        MapViewComponent.prototype.addPollingPlaceGraphic = function (pollingplace) {
	            this.pollingLocation = pollingplace["Location"];
	            var pt = new Point({
	                x: this.pollingLocation["X"],
	                y: this.pollingLocation["Y"],
	                spatialReference: 2965
	            });
	            var markerSymbol = new PictureMarkerSymbol();
	            markerSymbol.url = "./images/polling_green.png";
	            markerSymbol.width = 48;
	            markerSymbol.height = 48;
	            var pollingAtt = {
	                Name: pollingplace["Name"],
	                Address: pollingplace["StreetAddress"] + ", " + pollingplace["City"]
	            };
	            this.pollingGraphic = new Graphic({
	                geometry: pt,
	                symbol: markerSymbol,
	                attributes: pollingAtt,
	                popupTemplate: new PopupTemplate({
	                    title: "{Name}",
	                    content: "{Address}" // Displays a table of all the attributes in the popup
	                })
	            });
	            this.locationGraphics.add(this.pollingGraphic);
	        };
	        //add a graphic for satellite voting locations
	        MapViewComponent.prototype.addSatellitesGraphic = function (satellites) {
	            for (var _i = 0, satellites_1 = satellites; _i < satellites_1.length; _i++) {
	                var satellite = satellites_1[_i];
	                var satelliteLocation = satellite["Location"];
	                var pt = new Point({
	                    x: satelliteLocation["X"],
	                    y: satelliteLocation["Y"],
	                    spatialReference: 2965
	                });
	                var markerSymbol = new PictureMarkerSymbol();
	                markerSymbol.url = "./images/accessibility_blue.png";
	                markerSymbol.width = 48;
	                markerSymbol.height = 48;
	                var satelliteAtt = {
	                    Name: satellite["Name"],
	                    Address: satellite["StreetAddress"] + ", " + satellite["City"]
	                };
	                var satelliteGraphic = new Graphic({
	                    geometry: pt,
	                    symbol: markerSymbol,
	                    attributes: satelliteAtt,
	                    popupTemplate: new PopupTemplate({
	                        title: "{Name}",
	                        content: "{Address}" // Displays a table of all the attributes in the popup
	                    })
	                });
	                //this.mapViewRef.graphics.add(satelliteGraphic);
	                this.locationGraphics.add(satelliteGraphic);
	                // this.pollinglayer.add(satelliteGraphic);
	            }
	        };
	        MapViewComponent.prototype.zoomMaptoLocation = function (location) {
	            var pt = new Point({
	                x: location["X"],
	                y: location["Y"],
	                spatialReference: 2965
	            });
	            this.mapViewRef.scale = 8000;
	            this.mapViewRef.center = pt;
	        };
	        //function to run on slider change for toggleing aerial transparency 
	        MapViewComponent.prototype.sliderChange = function (slidervalue) {
	            // let opacityValue:number = parseInt(this.mapSlider.value);
	            var opacityValue = slidervalue;
	            this.aeriallayer.opacity = opacityValue / 100;
	            this.initTransparencyValue = slidervalue;
	        };
	        //function for immediatly toggleing basemap/aerial when clicking on the 
	        //map/imagery buttons rather than the slider
	        MapViewComponent.prototype.basemapToggle = function (slidervalue) {
	            this.initTransparencyValue = slidervalue;
	        };
	        //function for toggling the precincts layer on/off
	        MapViewComponent.prototype.precinctsToggle = function (togglevalue) {
	            ////Note - for whatever reason, toggling the visibility using layer.visible does not work here 
	            ////when defaulting the layer visibility to false on initial load. So when to toggling transparency
	            //  this.precinctslayer.visible = this.precinctsDisplay;
	            togglevalue ? this.precinctslayer.opacity = 1 : this.precinctslayer.opacity = 0;
	        };
	        MapViewComponent.prototype.directionsAddrToggle = function (togglevalue) {
	            this.newStartAddress = null;
	            togglevalue ? this.useDiffAddress = true : this.useDiffAddress = false;
	            this.useDiffAddress && this.newStartAddress ? this.directionsStartAddress = this.newStartAddress : this.directionsStartAddress = null;
	            !this.useDiffAddress ? this.directionsStartAddress = this.selectedAddress : null;
	            this.showDirections = false;
	            this.routelayer.removeAll();
	        };
	        MapViewComponent.prototype.stopLocationChange = function (togglevalue) {
	            this.showDirections = false;
	        };
	        //function to get driving directions
	        MapViewComponent.prototype.getDirections = function () {
	            var _this = this;
	            var directionsStop = this.selectedStop;
	            var isSatelliteStop;
	            directionsStop.indexOf('satellite') >= 0 ? isSatelliteStop = true : isSatelliteStop = false;
	            //clear out graphics
	            this.routelayer.removeAll();
	            this.routeInProgress = true;
	            // Point the URL to a valid route service
	            var routeTask = new RouteTask({
	                url: this.appSettings["routingService"]["url"]
	            });
	            // Setup the route parameters
	            var routeParams = new RouteParameters({
	                stops: new FeatureSet(),
	                outSpatialReference: {
	                    wkid: 2965
	                }
	            });
	            // Define the symbology used to display the start location
	            var startSymbol = new SimpleMarkerSymbol({
	                style: "cross",
	                size: 15,
	                outline: {
	                    width: 4
	                },
	                color: new Color("#2E4172")
	            });
	            var startLocation = this.directionsStartAddress["addressLocation"];
	            var startddress = this.directionsStartAddress["addressSuggestion"];
	            var startPt = new Point({
	                x: startLocation["X"],
	                y: startLocation["Y"],
	                spatialReference: 2965
	            });
	            var startAtt = {
	                Name: startddress["FullAddress"]
	            };
	            // Add a point at the location of the map click
	            var start = new Graphic({
	                geometry: startPt,
	                attributes: startAtt,
	                symbol: startSymbol,
	            });
	            this.startAddrText = startddress["FullAddress"];
	            var stopLocation;
	            var stopPt;
	            var stopAtt;
	            // Define the symbology used to display the stop location
	            var stopSymbol = new SimpleMarkerSymbol({
	                style: "cross",
	                size: 15,
	                outline: {
	                    width: 4
	                }
	            });
	            var stopName;
	            if (!isSatelliteStop) {
	                stopLocation = this.pollingLocation;
	                stopName = this.pollingPlaceFacility["Name"] + " " + this.pollingPlaceFacility["StreetAddress"] + ", " + this.pollingPlaceFacility["City"];
	            }
	            else {
	                this.selectedSatellite = this.satelliteVotingPlaces[directionsStop.split("-")[1]];
	                stopLocation = this.selectedSatellite["Location"];
	                stopName = this.selectedSatellite["Name"] + " " + this.selectedSatellite["StreetAddress"] + ", " + this.selectedSatellite["City"];
	            }
	            this.stopAddrText = stopName;
	            stopPt = new Point({
	                x: stopLocation["X"],
	                y: stopLocation["Y"],
	                spatialReference: 2965
	            });
	            stopAtt = {
	                Name: stopName
	            };
	            // Add a point at the location of the map click
	            var stop = new Graphic({
	                geometry: stopPt,
	                attributes: stopAtt,
	                symbol: stopSymbol
	            });
	            this.routelayer.add(start);
	            this.routelayer.add(stop);
	            routeParams.stops["features"].push(start);
	            routeParams.stops["features"].push(stop);
	            if (routeParams.stops["features"].length >= 2) {
	                routeParams.impedanceAttribute = this.appSettings["routingService"]["impedance"];
	                routeParams.returnDirections = true;
	                routeTask.solve(routeParams).then(function (route) {
	                    //create symbol for route graphic
	                    var routeSymbol = new SimpleLineSymbol({
	                        color: new Color("#FF0000"),
	                        width: 5
	                    });
	                    //get the route result 
	                    _this.routeResult = route.routeResults[0].route;
	                    //get the list of directions
	                    var routeDirections = route.routeResults[0].directions;
	                    _this.routeDirectionList = routeDirections.features;
	                    _this.routeResult.symbol = routeSymbol;
	                    _this.routelayer.add(_this.routeResult);
	                    _this.showDirections = true;
	                    _this.routeInProgress = false;
	                    _this.routeExtent = _this.routeResult.geometry.extent.expand(1.5);
	                    _this.mapViewRef.extent = _this.routeExtent;
	                })
	                    .otherwise(function (errback) {
	                    console.log(errback);
	                });
	            }
	        };
	        MapViewComponent.prototype.printDirections = function () {
	            var _this = this;
	            this.printInProgress = true;
	            var mapImage;
	            //   let container = document.getElementById("printArea");
	            var container = document.getElementById("directionsList");
	            var div = document.createElement('div');
	            div.innerHTML = "<span>Directions from " + this.startAddrText + " to " + this.stopAddrText + ":</span>";
	            div.innerHTML += container.innerHTML;
	            this.getMap().subscribe(function (data) {
	                _this.printInProgress = false;
	                mapImage = data;
	                _this.exportedMapImgURL = '<img src="' + mapImage["url"] + '" width="800" height="500">';
	                // this.showPrint = true;
	                var width = parseFloat("800");
	                var height = parseFloat("500");
	                var printWindow = window.open('', "_parent ", 'PrintMap');
	                printWindow.document.writeln(_this.exportedMapImgURL + "<br/><br/>" + div.innerHTML);
	                printWindow.document.close();
	                setTimeout(function () {
	                    printWindow.print();
	                }, 1000);
	                // printWindow.close();
	            }, function (err) {
	                alert("We were unable to print directions. Please try again later.");
	                _this.error = false;
	                _this.printInProgress = false;
	            });
	        };
	        MapViewComponent.prototype.hidePrintModal = function () {
	            this.showPrint = false;
	        };
	        MapViewComponent.prototype.showPrintDialog = function () {
	            var width = parseFloat("800");
	            var container = document.getElementById("directionsList");
	            var height = parseFloat("500");
	            var printWindow = window.open('', 'PrintMap', 'width=' + width + ',height=' + height);
	            printWindow.document.writeln(container.innerHTML);
	            printWindow.document.close();
	            printWindow.print();
	            printWindow.close();
	        };
	        MapViewComponent.prototype.getMap = function () {
	            this.mapViewRef.extent = this.routeExtent;
	            var printTask = new PrintTask(this.appSettings["printing"]["printingTask"]);
	            var template = new PrintTemplate(new Object(this.appSettings["printing"]["printingTemplate"]));
	            var params = new PrintParameters();
	            params.view = this.mapViewRef;
	            params.template = template;
	            return Observable_1.Observable.fromPromise(printTask.execute(params).then(function (result) {
	                return result;
	            }));
	        };
	        // Adds the solved route to the map as a graphic
	        MapViewComponent.prototype.showRoute = function (data) {
	            // Define the symbology used to display the route
	            var routeSymbol = new SimpleLineSymbol({
	                color: new Color("#FF0000"),
	                width: 5
	            });
	            var routeResult = data.routeResults[0].route;
	            routeResult.symbol = routeSymbol;
	            this.zoomMaptoLocation(this.homeLocation);
	        };
	        MapViewComponent.prototype.closeMapToolsPanel = function () {
	            this.panelHide = true;
	        };
	        MapViewComponent.prototype.showMapToolsPanel = function () {
	            this.panelHide = false;
	        };
	        //show/hide the share via email panel
	        MapViewComponent.prototype.toggleEmailPanel = function (display) {
	            var _this = this;
	            this.showEmailPanel = display;
	            var forAddress;
	            var ppPrecinctLabel;
	            var ppNameLabel;
	            var ppAddressLabel;
	            var ppCityLabel;
	            var accessibilityText;
	            this.emailBody = "";
	            var container = document.getElementById("directionsList");
	            var div = document.createElement('div');
	            div.innerHTML = "<span>Directions from " + this.startAddrText + " to " + this.stopAddrText + ":</span>";
	            div.innerHTML += container.innerHTML;
	            this.emailSubject = "Polling Place Driving Directions";
	            this.getMap().subscribe(function (data) {
	                var emailMapImgURL = "";
	                if (data["url"]) {
	                    emailMapImgURL = '<img src="' + data["url"] + '" width="800" height="500">';
	                }
	                _this.emailBody = emailMapImgURL + "<br/><br/>" + div.innerHTML;
	            }, function (err) {
	                _this.emailBody = div.innerHTML;
	            });
	        };
	        MapViewComponent = __decorate([
	            core_1.Component({
	                selector: 'map-view',
	                template: __webpack_require__(141)
	            }),
	            __metadata("design:paramtypes", [Events_service_1.EventsService, map_service_1.MapService, settings_service_1.SettingsService, http_1.Http, http_1.Jsonp])
	        ], MapViewComponent);
	        return MapViewComponent;
	    }());
	    exports.MapViewComponent = MapViewComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_128__;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_129__;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_130__;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_131__;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_132__;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_133__;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_134__;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_135__;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_136__;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_137__;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_138__;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_139__;

/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"mdl-layout__tab-panel\" id=\"tabMap\">\r\n    <div *ngIf=\"!tabActivated\">\r\n        <div class=\"mdl-card__supporting-text\">\r\n            <h2 class=\"mdl-card__title-text\">Map information is currently unavailable.</h2>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"tabActivated\">\r\n        <map-info #mapView (viewCreated)=\"onMapLoad(mapView.view)\" zoom=\"5\">\r\n\r\n        </map-info>\r\n\r\n        <button class=\"mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mapToolsToggle\" *ngIf=\"panelHide\" (click)=\"showMapToolsPanel()\"\r\n            title=\"{{'mapToolsPanelShow' | translate:{value: mapToolsPanelShow} }}\">\r\n            <i class=\"material-icons white\">toc</i>\r\n        </button>\r\n        <div class=\"legend-card-square mdl-card mdl-shadow--2dp\" *ngIf=\"!panelHide\">\r\n            <div class=\"mdl-card__title main-banner\">\r\n\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                <button id=\"btnClose\" class=\"mdl-button mdl-js-button mdl-button--icon\" (click)=\"closeMapToolsPanel()\" title=\"{{'mapToolsPanelHide' | translate:{value: mapToolsPanelHide} }}\">    \r\n                    <i class=\"material-icons\">cancel</i>\r\n                </button>\r\n            </div>\r\n            <div class=\"mdl-tabs mdl-js-tabs mdl-js-ripple-effect\">\r\n                <div class=\"mdl-tabs__tab-bar\">\r\n                    <a href=\"#mapinfo-panel\" class=\"mdl-tabs__tab is-active\">{{'mapToolsTitle' | translate:{value: mapToolsTitle} }}</a>\r\n                    <a href=\"#directions-panel\" class=\"mdl-tabs__tab\">{{'directionsTitle' | translate:{value: directionsTitle} }}</a>\r\n                </div>\r\n\r\n                <div class=\"mdl-tabs__panel is-active\" id=\"mapinfo-panel\">\r\n                    <div class=\"mdl-card__supporting-text\">\r\n                        <label class=\"mdl-switch mdl-js-switch mdl-js-ripple-effect\" for=\"switch-precinct\">\r\n                        <input type=\"checkbox\" id=\"switch-precinct\" class=\"mdl-switch__input\" [formControl]=\"precinctToggleControl\"  [(ngModel)]=\"precinctsDisplay\" value={{precinctsDisplay}}>\r\n                        <span class=\"mdl-switch__label\">{{'showPrecincts' | translate:{value: showPrecincts} }}</span>\r\n                    </label>\r\n                    </div>\r\n\r\n\r\n                    <div class=\"mdl-card__actions mdl-card--border legendSliderActionsDiv\">\r\n                        <div class=\"legendSliderDiv\">\r\n\r\n                            <button id=\"maptoggle\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" (click)=\"basemapToggle(0)\">\r\n                                <i class=\"material-icons blue\" >map</i>\r\n                            </button>\r\n\r\n                            <input class=\"mdl-slider mdl-js-slider\" [ngClass]=\"{iemdlslider: IEbrowser}\" (change)=\"inputChange($event)\" type=\"range\"\r\n                                min=\"0\" max=\"100\" [formControl]=\"mapSliderControl\" [(ngModel)]=\"initTransparencyValue\" value={{initTransparencyValue}}>\r\n\r\n                            <button id=\"sattoggle\" class=\"mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect\" (click)=\"basemapToggle(100)\">\r\n                                    <i class=\"material-icons blue\" >satellite</i>\r\n                                    \r\n                </button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"mdl-tabs__panel\" id=\"directions-panel\">\r\n\r\n\r\n                    <div class=\"mdl-card__title\">\r\n\r\n                        <span>{{'startLocationTitle' | translate:{value: startLocationTitle} }}</span>\r\n                    </div>\r\n                    <div class=\"mdl-card__supporting-text\">\r\n                        <label class=\"mdl-switch mdl-js-switch mdl-js-ripple-effect\" for=\"switch-start\">\r\n            <input type=\"checkbox\" id=\"switch-start\" class=\"mdl-switch__input\" [formControl]=\"directionsAddrToggleControl\">\r\n            <span class=\"mdl-switch__label\" *ngIf=\"!useDiffAddress\">{{selectedAddressString}}</span>\r\n            <span class=\"mdl-switch__label\" *ngIf=\"useDiffAddress\">{{'enterDiffAddressTitle' | translate:{value: enterDiffAddressTitle} }}</span>\r\n        </label>\r\n                        <location-search *ngIf=\"useDiffAddress\" (selectedAddressItem)=\"startAddressIsSelected($event)\" (voterAddressValid)=\"validateAddressToggle($event)\"\r\n                            inputWidth=\"210px\"></location-search>\r\n                    </div>\r\n                    <hr>\r\n                    <div class=\"mdl-card__title\">\r\n\r\n                        <span>{{'destinationTitle' | translate:{value: destinationTitle} }}</span>\r\n                    </div>\r\n                    <div class=\"mdl-card__supporting-text\" style=\"padding-right:8px; padding-left:8px; width:calc(100% - 5px);\">\r\n                        <div id=\"stopLocationsContainer\" class=\"mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label\" *ngIf=\"pollingPlaceFacility\">\r\n                            <select class=\"mdl-selectfield__select\" id=\"routeStopLocations\" [(ngModel)]=\"selectedStop\" #routeStopLocations [formControl]=\"stopSelectControl\">\r\n            <option value=\"polling\" >{{pollingPlaceFacility.Name}}</option>\r\n            <option value=\"satellite-{{i}}\" *ngFor=\"let satellite of satelliteVotingPlaces; let i = index\">{{satellite.Name}}</option>\r\n      \r\n            </select>\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n                    <hr>\r\n                    <div class=\"mdl-grid\">\r\n\r\n                        <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" *ngIf=\"routeInProgress\"></div>\r\n                        <div id=\"directionsList\" class=\"directions-steps\" *ngIf=\"showDirections\">\r\n                            <ul class=\"mdl-list\" style=\"list-style: none;\">\r\n                                <li class=\"mdl-list__item\" *ngFor=\"let step of routeDirectionList; let i = index\">\r\n                                    {{i + 1}}. {{step.attributes.text}}\r\n\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"mdl-card__actions mdl-card--border\">\r\n                        <div style=\"display:flex; margin-top: 0px; margin-left: 0px; \">\r\n                            <button id=\"btDirections\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" title=\"{{'routeTitle' | translate:{value: routeTitle} }}\"\r\n                                [disabled]=\"useDiffAddress && !directionsStartAddress\" (click)=\"getDirections()\">\r\n                    <i class=\"material-icons blue\">directions</i>\r\n                    <span>{{'routeTitle' | translate:{value: routeTitle} }}</span>\r\n                </button>\r\n                <div class=\"mdl-layout-spacer\"></div>\r\n                \r\n                <button id=\"btPrintDirections\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" *ngIf=\"showDirections && !printInProgress\" title=\"{{'printTitle' | translate:{value: printTitle} }}\" (click)=\"printDirections()\">\r\n                    <i class=\"material-icons blue\">print</i>\r\n                </button>\r\n                <div class=\"mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active\" *ngIf=\"printInProgress\"></div>\r\n\r\n                            <button id=\"btEmailDirections\" class=\"mdl-button mdl-js-button mdl-js-ripple-effect\" *ngIf=\"showDirections\" title=\"{{'emailTitle' | translate:{value: emailTitle} }}\"\r\n                                (click)=\"toggleEmailPanel(true)\">\r\n                    <i class=\"material-icons blue\">email</i>\r\n                    \r\n                </button>\r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n\r\n\r\n        </div>\r\n        <div class=\"mdl-tooltip\" for=\"maptoggle\">\r\n            {{'mapView' | translate:{value: mapView} }}\r\n        </div>\r\n        <div class=\"mdl-tooltip\" for=\"sattoggle\">\r\n            {{'aerialView' | translate:{value: aerialView} }}\r\n        </div>\r\n    </div>\r\n\r\n    <!--modal dialog for email sharing-->\r\n    <email-panel *ngIf=\"showEmailPanel\" (displayStatus)=\"showEmailPanel = $event\" emailSubject=\"{{emailSubject}}\" emailBody=\"{{emailBody}}\"></email-panel>\r\n\r\n</section>";

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_150__;

/***/ })
])});;


// WEBPACK FOOTER //
// js/main.bundle.js